/* ==========================================================================
   Cap Customizer — front-end engine
   Port of the Claude Design prototype's DCLogic component to vanilla JS.

   Reads its configuration from <script type="application/json" data-cc-config>
   rendered by sections/cap-customizer.liquid, so all real product data
   (variants, images, prices, tiers) comes from Shopify.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- helpers --------------------------------------------------- */

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  var clamp = function (n, lo, hi) { return Math.max(lo, Math.min(hi, n)); };

  /* Merchant-editable copy. Every message this file shows the customer is a
     template from the section settings, filled here — the wording is tuned in
     the theme editor rather than in a deploy.

     Tokens are {name}, single-braced so nothing collides with Liquid's own
     {{ }} in a settings box. The replacer is a FUNCTION on purpose: several
     substitutions are formatted money, and String.replace reads '$&' or "$'"
     inside a string replacement as a backreference — a bug that would only
     surface at one particular price. A token the merchant deleted resolves to
     nothing, so trimming one shortens the sentence instead of throwing. */
  var fill = function (tpl, vars) {
    return String(tpl == null ? '' : tpl).replace(/\{(\w+)\}/g, function (m, k) {
      var v = vars ? vars[k] : null;
      return v == null ? '' : String(v);
    });
  };

  /* Preview zoom bounds. 4x is where a 1% imprint on a 1600px render becomes
     big enough to judge; past that the source photo is the limit, not the
     scale. Viewing only — the exported proof reads state.place and config,
     never these. */
  var ZOOM_MIN = 1, ZOOM_MAX = 4;

  /* Files need an identity that survives the list being reordered or thinned.
     The blob URL is unique but contains characters that break an attribute
     selector, and it is what `art` already compares on — so ids are a short
     sequence used only for placement keys and the shown-set. */
  var FILE_SEQ = 0;

  // Shopify money formatting from the shop's money_format string.
  function makeMoney(format) {
    var fallback = function (cents) { return '$' + (cents / 100).toFixed(2); };
    if (!format) return fallback;

    function withDelim(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    return function (cents) {
      var value = '';
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = format.match(placeholder);
      if (!match) return fallback(cents);
      switch (match[1]) {
        case 'amount': value = withDelim(cents, 2, ',', '.'); break;
        case 'amount_no_decimals': value = withDelim(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = withDelim(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelim(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = withDelim(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = withDelim(cents, 0, ' ', ','); break;
        case 'amount_with_period_and_space_separator': value = withDelim(cents, 2, ' ', '.'); break;
        default: value = withDelim(cents, 2, ',', '.');
      }
      return format.replace(placeholder, value);
    };
  }

  /* ---------- component ------------------------------------------------- */

  function CapCustomizer(root) {
    this.root = root;
    var cfgNode = root.querySelector('[data-cc-config]');
    if (!cfgNode) return;

    try {
      this.cfg = JSON.parse(cfgNode.textContent);
    } catch (err) {
      console.error('[cap-customizer] bad config JSON', err);
      return;
    }

    var c = this.cfg;
    this.money = makeMoney(c.moneyFormat);

    // Slider geometry is derived from the stop list so the two never drift.
    this.sliderMax = (c.stops.length - 1) * 100;

    /* One index, used twice. They used to be computed apart — `color` from
       defaultColorIndex(), `picked` hard-coded to 0 — so whenever colors[0]
       was sold out the customer landed previewing one colourway and ordering
       a different one. Harmless while a click did both; not any more. */
    var startColor = this.defaultColorIndex();

    this.state = {
      view: 0,
      color: startColor,
      /* Quantities keyed '<colorway>|<size>', size empty for one-size
         products. ONE store for both, because the alternative is a scalar for
         one-size and a map for sized, and then a colour axis on top of each —
         four combinations for the minimum rules to be right in.

         It also replaces keying by size NAME alone, which existed so a shopper
         who filled in a run and then tried another colour kept it. Colours
         accumulate now instead of switching, so the run is kept by having its
         own row rather than by being carried. */
      qtyBy: {},
      /* Colourways being ordered, as indexes into cfg.colors. state.color is
         separate and is only ever which one the PREVIEW shows. Browsing moves
         the preview alone; this changes only when the customer says ADD.

         EMPTY ON LOAD (Kelly, 2026-08-22). It used to start with the landing
         colourway already on the order, which was honest when a swatch WAS
         the order — one colour, switched between. Now that browsing and
         ordering are different acts, starting with something on the order
         means the customer never chose it: they either notice and remove it,
         or ship a colour they only ever previewed. */
      picked: [],
      active: 0,
      place: {},
      dragging: false,
      /* Which object the size / rotate / curve / remove controls act on.
         Selection used to be implied by the LOCATION, which was fine while a
         location held one thing — with several images on one location it
         always resolved to the first and the rest could not be touched. */
      selectedKey: '',
      // A VIEWING aid only. It must never reach state.place, or the customer's
      // placement — and therefore the exported proof — would change with how
      // far they happened to be zoomed in.
      zoom: 1,
      bgBusy: false,
      bgError: '',
      hidden: {},
      dropActive: false,
      hoverStage: false,
      saveOpen: false,
      saveSent: false,
      saveMode: 'mockup',
      saving: false,
      email: '',
      /* Held on state like `email` rather than read off the DOM at submit,
         so a re-render cannot lose what the customer typed. Request-only. */
      reqName: '',
      reqNotes: '',
      locations: [],
      notes: '',
      refMode: 'none',
      refOrder: '',
      refMock: '',
      adding: false,
      error: ''
    };

    this.el = {};
    this.cacheNodes();
    this.bind();
    this.render();

    /* A webfont that arrives after the first paint changes glyph WIDTHS, and
       those widths are what place a curved imprint. Without a re-render the
       proof on screen keeps geometry measured against the fallback face while
       the letters are drawn in the real one, and the exported PNG — measured
       later — quietly disagrees with it. */
    var self = this;
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { self.render(); }).catch(function () {});
    }
  }

  var P = CapCustomizer.prototype;

  P.defaultColorIndex = function () {
    var colors = this.cfg.colors || [];
    var pre = this.cfg.selectedVariantId;
    for (var i = 0; i < colors.length; i++) {
      if (pre && String(colors[i].variantId) === String(pre)) return i;
    }
    for (var j = 0; j < colors.length; j++) {
      if (colors[j].available) return j;
    }
    return 0;
  };

  P.q = function (name) { return this.root.querySelector('[data-cc="' + name + '"]'); };
  P.qa = function (name) { return Array.prototype.slice.call(this.root.querySelectorAll('[data-cc="' + name + '"]')); };

  P.cacheNodes = function () {
    var names = [
      'track', 'placementLabel', 'caption', 'stage', 'placer',
      'zoom', 'zoomIn', 'zoomOut', 'zoomLabel',
      'sizeRange', 'sizeLabel', 'rotRange', 'rotLabel', 'resetRot', 'flipRot', 'bgRemove', 'bgStatus',
      'stockChip',
      'saveMockup', 'toggleLogo', 'resetPlace', 'views', 'colorName', 'swatches', 'addColor',
      'locSummary', 'locations', 'addable', 'panelRow', 'panels', 'panelNote',
      'imprintNote', 'decoHead',
      'decoBlock', 'decorations', 'subtypeBlock', 'subtypeHead', 'subtypes',
      'patchColorBlock', 'patchColorHead', 'patchColors',
      'detailBlock', 'detailImg', 'detailText',
      'lightbox', 'lightboxImg', 'lightboxClose',
      'addonBlock', 'addons',
      'puff', 'puffCheck', 'puffPrice', 'puffNote', 'artBlock',
      'artStep', 'activeLocName', 'artStatus', 'tabUpload', 'tabText', 'uploadPane',
      'textPane', 'drop', 'fileInput', 'files', 'noFiles', 'dropTitleLoc',
      'textValue', 'fontSelect', 'threadSelect', 'notesStep', 'notesStatus', 'notesBlock',
      'threadGrid', 'threadFilter', 'threadCurrent', 'threadNone',
      'curveRange', 'curveLabel', 'resetCurve', 'curveWrap',
      'notesValue', 'refNone', 'refOrder', 'refMock', 'refOrderPane', 'refMockPane',
      'reorderNote',
      'refOrderValue', 'refMockValue', 'qtyStep', 'tierLabel', 'qtyValue', 'qtyDec',
      'qtyInc', 'qtySlider', 'stops', 'colorRows', 'sizeSum', 'qtyBox',
      'totalLabel', 'perCapLabel', 'perCapCaption',
      'tiers', 'tiersBlock', 'upsell', 'upsellText', 'capsSubtotalLabel',
      'capsSubtotal', 'discountRow', 'discountLabel', 'discountValue',
      'lineItems', 'setupCount', 'setupLabel', 'shippingRow', 'shippingLabel', 'totalLabel2',
      'slideTpl', 'logoTpl',
      'toast',
      'addToCart', 'ctaTotal', 'saveQuote', 'error', 'modal', 'modalForm',
      'modalDone', 'mockSummary', 'mockPricing', 'emailValue', 'sendMock',
      'modalTitle', 'modalLede', 'doneTitle', 'doneBody',
      'requestMockup', 'nameField', 'nameValue', 'reqArtField', 'reqArtValue',
      'reqArtNote', 'reqNotesField', 'reqNotesValue',
      'closeSave', 'closeSave2', 'closeSave3', 'form', 'fileMirror', 'propsMirror',
      'quantityInput', 'variantInput'
    ];
    for (var i = 0; i < names.length; i++) this.el[names[i]] = this.q(names[i]);
  };

  /* ---------- derived values (port of renderVals) ------------------------ */

  P.defaultSubtype = function (decoId) {
    var d = this.decoOf(decoId);
    return (d && d.subtypes && d.subtypes.length) ? d.subtypes[0].value : '';
  };

  /* Colour choices offered by the selected sub-type's own variant. Colours are
     an attribute of that one variant, all at the same price, so they never
     take part in resolve() or in pricing — see the note on patchColor in
     blankLoc. Returns [] for sub-types that offer no colour choice, which is
     most of them. */
  P.colorsFor = function (l) {
    var d = this.decoOf(l.deco);
    var subs = (d && d.subtypes) || [];
    for (var i = 0; i < subs.length; i++) {
      if (subs[i].value === l.subtype) return subs[i].colors || [];
    }
    return [];
  };

  /* Add-ons offered for this location: those attached either to the whole
     decoration (`for` = the decoration id) or to the specific sub-choice
     currently selected (`for` = that variant's title). */
  /* A one-time charge in dollars, from the cents the config carries.

     This got read wrong twice. Reaching for the money metafield's .value.amount
     in Liquid yields nil — it is not an object there — and `default: 0` turned
     that into a free die on every patch. Passing .value straight through then
     billed a $200 PV+ die as $20,000, which is what established the unit.

     So: cents in the payload under a name that says so, one division here, and
     anything non-numeric reads 0 rather than NaN — NaN would poison the order
     total instead of one line. */
  /* The setup variant that bills a given dollar amount, or '' if none exists.

     Setup is a real line item because a Cart Transform can only DISCOUNT a
     merged line — a die is money on, not off. Keyed by cents so a float
     never has to be compared: 30.0 and 30 are the same money and different
     strings. */
  P.setupVariantFor = function (amount) {
    var cents = Math.round((Number(amount) || 0) * 100);
    if (cents <= 0) return '';
    var map = this.cfg.setupVariants || {};
    return map[String(cents)] || '';
  };

  /* Every setup charge this configuration owes, as {amount, variantId}. The
     rule is the pricing rule: the FIRST location pays its decoration's own
     charge, later locations pay the flat additional-location fee, and an
     add-on's charge always bills because an add-on die is a second die.

     A REORDER NO LONGER WAIVES ANY OF IT (Kelly, 2026-09-06) — see the
     matching comment in pricing(). Setup is charged on every order, repeat
     or not, and a genuine repeat is refunded after the order is placed and
     reviewed (the "REORDER" badge + setup_refund_status flow in wce-oms).
     `pricing()` was updated for that policy the same day; this function,
     which is what actually puts a setup line in the cart, still had the
     OLD `refMode === 'order'` skip from before that policy existed — so
     the quote panel correctly showed setup while the real cart silently
     dropped it. Found live 2026-09-07 on a TravisMathew polo AND a
     TravisMathew 1/4-zip repeat order; both templates share this one
     function, so both broke from the same drift and both are fixed by
     the same one-line removal. Two implementations of "does this order
     owe setup" is exactly the class of bug the rest of this file's
     one_time_charge history warns about — there should only ever be one. */
  P.setupCharges = function () {
    var self = this;
    /* Same list, same order, as pricing() — state.locations is already held in
       the configured order, so index 0 is the primary location both here and
       there. Reading it any other way would bill a different first location
       than the one the customer was quoted. */
    var locs = this.state.locations;
    var out = [];
    if (!locs.length) return out;
    locs.forEach(function (l, i) {
      if (i === 0) {
        var one = self.oneTimeOf(self.resolve(l));
        if (one > 0) out.push({ amount: one, variantId: self.setupVariantFor(one) });
      }
      self.activeAddons(l).forEach(function (a) {
        var av = self.oneTimeOf(a);
        if (av > 0) out.push({ amount: av, variantId: self.setupVariantFor(av) });
      });
    });
    return out;
  };

  P.oneTimeOf = function (o) {
    var c = Number(o && o.oneTimeCents);
    return isFinite(c) ? c / 100 : 0;
  };

  P.addonsFor = function (l) {
    var list = this.cfg.addons || [];
    return list.filter(function (a) {
      return a.for === l.deco || a.for === l.subtype;
    });
  };

  /* Only the add-ons that are BOTH selected and still offered. A selection can
     survive a sub-choice change in state; pricing and the cart must ignore it
     rather than bill for an add-on that is no longer on screen. */
  P.activeAddons = function (l) {
    var chosen = l.addons || [];
    return this.addonsFor(l).filter(function (a) { return chosen.indexOf(a.value) > -1; });
  };

  /* Add-ons split two ways: those carrying a group name are mutually
     exclusive within that group (Application: Sewn On vs Heat Applied), the
     rest are independent checkboxes. Groups keep the order they first appear
     in, which is the variant order in Shopify. */
  P.addonGroups = function (l) {
    var order = [];
    var byName = {};
    this.addonsFor(l).forEach(function (a) {
      var g = (a.group || '').trim();
      if (!g) return;
      if (!byName[g]) { byName[g] = []; order.push(g); }
      byName[g].push(a);
    });
    return order.map(function (n) { return { name: n, items: byName[n] }; });
  };

  P.plainAddons = function (l) {
    return this.addonsFor(l).filter(function (a) { return !(a.group || '').trim(); });
  };

  /* Every group must resolve to exactly one selection. The standard is
     preselected — unlike a patch colour, "Standard" is a defined business
     answer, so choosing it for the customer is correct rather than a guess.
     Falls back to the first entry if nobody flagged a default. */
  P.applyAddonDefaults = function (l) {
    var chosen = (l.addons || []).slice();
    var changed = false;
    this.addonGroups(l).forEach(function (g) {
      var has = g.items.some(function (a) { return chosen.indexOf(a.value) > -1; });
      if (has) return;
      var def = null;
      g.items.forEach(function (a) { if (!def && a.isDefault) def = a; });
      if (!def) def = g.items[0];
      if (def) { chosen.push(def.value); changed = true; }
    });
    if (changed) l.addons = chosen;
    return changed;
  };

  P.addonSum = function (l) {
    return this.activeAddons(l).reduce(function (n, a) { return n + (Number(a.price) || 0); }, 0);
  };

  /* A colour is REQUIRED once the sub-type offers any. Defaulting to the first
     entry would quietly ship the wrong colour patch, which is the same failure
     the thread chart is keyed by code to avoid — an ambiguous colour on a work
     order is a remake. So this blocks add-to-cart instead of guessing. */
  P.needsColor = function (l) {
    return this.colorsFor(l).length > 0 && !l.patchColor;
  };

  // Decorations a given location is allowed to offer. Patches, printing and
  // 3D puff are front-only; sides and back take embroidery only.
  P.decosForLoc = function (locId) {
    var meta = this.locMeta(locId);
    var allowed = meta && meta.decos;
    if (!allowed || !allowed.length) return this.cfg.decorations;
    var out = this.cfg.decorations.filter(function (d) { return allowed.indexOf(d.id) > -1; });
    return out.length ? out : this.cfg.decorations;
  };

  /* Which already-placed locations cannot survive `incomingId` joining them.

     Two locations conflict only when they share a GROUP and at least one of
     them is `solo`. Kelly's t-shirt front, 2026-08-25:

       Full Front   front:solo    takes the whole front
       Front Chest  front:solo    takes the whole front
       Left Chest   front:share   may sit beside Right Chest
       Right Chest  front:share   may sit beside Left Chest

     So Left Chest + Right Chest is the ONLY front pair, and either one is
     evicted by a Full Front or a Front Chest arriving. Backs are all `solo` in
     one group, which is "exactly one back location, ever".

     A location with no group conflicts with nothing — a sleeve is its own view
     and its own piece of garment. Different groups never conflict either, which
     is what lets a front and a back coexist without listing every pair. */
  P.conflictsWith = function (existingId, incomingId) {
    if (existingId === incomingId) return true;
    var a = this.locMeta(existingId), b = this.locMeta(incomingId);
    if (!a || !b) return false;
    if (!a.group || !b.group || a.group !== b.group) return false;
    return a.mode === 'solo' || b.mode === 'solo';
  };

  P.dropConflicts = function (locs, incomingId) {
    var self = this;
    return (locs || []).filter(function (l) { return !self.conflictsWith(l.loc, incomingId); });
  };

  P.blankLoc = function (locId) {
    var c = this.cfg;
    var lid = locId || (c.locations[0] || {}).id || 'front';
    var allowedHere = this.decosForLoc(lid);
    /* A new location JOINS the order's method rather than picking its own —
       see setDecoration: one method per order. Falls back to this location's
       first allowed method for the opening location, and also for the case
       where the order's method is not offered here, which on a well-configured
       template should not arise because the add button would not be shown. */
    var current = (this.state && this.state.locations && this.state.locations[0] || {}).deco;
    var joins = current && allowedHere.some(function (d) { return d.id === current; });
    var deco = joins ? current : ((allowedHere[0] || c.decorations[0] || {}).id || 'flat');
    return {
      loc: lid,
      panel: 'center',
      deco: deco,
      subtype: this.defaultSubtype(deco),
      // Deliberately NOT part of `subtype`: resolve() matches the variant on
      // subtype alone, and colour is a sibling attribute of that same variant,
      // not part of its identity. Folding it in would break the price lookup.
      patchColor: '',
      // Selected add-on values (variant titles). An array because several can
      // apply at once — unlike subtype and patchColor, which are single picks.
      addons: [],
      tab: 'upload',
      /* File ids currently drawn. An ARRAY because a location can carry
         several images at once — it used to be the single `art` url, which is
         precisely why a second image had nowhere to be. `art` is kept in step
         as the first of these, because the cart copy, the bg-removal target
         and the file list all still read it. */
      shown: [],
      /* Whether text is ON the product, as opposed to merely pre-filled in
         the box. It has to be explicit: `default_text` pre-fills the field —
         the cap ships with "TEXT" — so drawing whenever `text` is non-empty
         would stamp the word TEXT on every location the moment it is added. */
      textOn: false,
      text: c.defaultText || '',
      font: ((c.fonts[0] || {}).label || ''),
      thread: this.threadKey(c.threads[0]),
      curve: 0,
      files: [],
      art: ''
    };
  };

  /* Which view a location is PREVIEWED on for the colourway on screen.

     Normally its own. But a colourway photographed from the front only drops
     every other view (see viewOnColor), and a sleeve decoration would then
     preview nowhere at all — the customer configures it, pays for it, and sees
     nothing. Kelly, 2026-08-26: "sleeve preview on the front image is fine
     because the front images show the sleeves."

     ONE hop, and only when the location's own view is genuinely absent. A view
     with a photo always wins, so nothing changes on a fully photographed cap.
     BACK carries no fallback on purpose and must never gain one: a back
     decoration drawn on a front photo is a false proof, and no photo at all is
     the honest answer. */
  P.viewForLoc = function (l, col) {
    var meta = this.locMeta(l.loc);
    var own = meta ? String(meta.view).toUpperCase() : '';
    if (!own) return '';
    if (this.viewOnColor(col || this.currentColor(), own)) return own;
    var to = (this.cfg.viewFallback || {})[own];
    if (to && this.viewOnColor(col || this.currentColor(), to)) return String(to).toUpperCase();
    return own;
  };

  P.locMeta = function (id) {
    var list = this.cfg.locations;
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0];
  };

  /* NULL when the product has no panels at all, rather than `list[0]` — which
     is `undefined` on an empty list, and every caller then read a property off
     it. Panels are a CAP idea (front left / centre / right); a beanie, a towel
     or a t-shirt has none, and the first template with a location called
     `front` and no panels crashed the whole render on the first click. */
  P.panelMeta = function (id) {
    var list = this.cfg.panels || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0] || null;
  };

  P.decoOf = function (id) {
    var list = this.cfg.decorations;
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0];
  };

  /* Is this order's setup eligible for the repeat-order refund?

     PRINTED IS NEVER REFUNDED, on any template (Kelly, 2026-09-06): the
     garment templates' "DTF Print" and the cap template's "Printed" are both
     print methods and both pay setup on every order, repeat or not. A print
     transfer is consumed; there is nothing archived to reuse.

     Embroidery and patches ARE refundable — digitizing and a die survive the
     job and get pulled from the archive on an exact repeat.

     Keyed on `deco_id`, which is 'print' for both print methods and is the
     same machine identifier `deco_map` keys on. An earlier version matched the
     NAME for "DTF" and was wrong twice over: it left the note showing on cap
     Printed, and it would break the moment someone renamed a decoration in the
     theme editor, which names are there to allow.

     An order carries ONE method throughout (see setDecoration), so location 0
     decides. With no location chosen there is no method yet and the note
     shows — the customer has not committed to anything. */
  P.setupRefundable = function () {
    var l = this.state.locations[0];
    if (!l) return true;
    return l.deco !== 'print';
  };

  /* Threads are keyed by code, not name: the real chart repeats names across
     ranges (Black is both 2296 and 5596), and an ambiguous name on a work order
     is a remake. Lists without codes fall back to the name as the key. */
  P.threadKey = function (t) { return (t && (t.code || t.name)) || ''; };

  P.threadOf = function (key) {
    var list = this.cfg.threads || [];
    var i;
    for (i = 0; i < list.length; i++) if (list[i].code && list[i].code === key) return list[i];
    for (i = 0; i < list.length; i++) if (list[i].name === key) return list[i];
    return null;
  };

  P.threadHex = function (key) {
    var t = this.threadOf(key);
    return t ? t.hex : '#ffffff';
  };

  // What a human reads on the proof, the cart line and the work order.
  P.threadLabel = function (key) {
    var t = this.threadOf(key);
    if (!t) return key || '';
    return t.code ? t.name + ' ' + t.code : t.name;
  };

  /* ---------- imprint text geometry ----------------------------------------
     One layout function, two renderers. The on-screen proof draws it as SVG and
     the exported PNG draws it on canvas; both consume these glyph positions, so
     a curved proof and the customer's mockup cannot drift apart.
  -------------------------------------------------------------------------- */

  var MEASURE = null;
  var measureCtx = function () {
    if (!MEASURE) MEASURE = document.createElement('canvas').getContext('2d');
    return MEASURE;
  };

  /* The imprint is drawn in the face the chosen font maps to (Kelly,
     2026-08-19). It used to always draw in the theme face on the grounds that
     a font name is an instruction to the digitiser — true, but it made the
     picker look broken: five options, one appearance.

     The LABEL is still the instruction. Where the drawn face is a stand-in for
     a real embroidery font, the preview represents the shape, not the thread.

     A font with no CSS stack falls back to the theme face, which is exactly
     the old behaviour, so an unmapped name renders instead of vanishing. */
  var THEME_FACE = 'Archivo, Helvetica, Arial, sans-serif';
  var IMPRINT_FONT = function (px, face, weight) {
    return (weight || '800') + ' ' + px + 'px ' + (face || THEME_FACE);
  };

  // curve is -100..100. Positive arcs up (rainbow), negative arcs down (valley),
  // 0 is a straight baseline. 160 degrees is the practical ceiling before the
  // ends of a long word start colliding.
  var MAX_ARC = Math.PI * 160 / 180;

  /* The face a location's imprint is drawn in. Everything that measures or
     draws text goes through this, so the on-screen SVG, the glyph geometry and
     the exported PNG cannot disagree about which font they are using. */
  P.faceFor = function (fontLabel) {
    var list = this.cfg.fonts || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].label === fontLabel) {
        return { css: list[i].css || THEME_FACE, weight: list[i].weight || '800' };
      }
    }
    return { css: THEME_FACE, weight: '800' };
  };

  P.textLayout = function (text, size, curve, face) {
    var ctx = measureCtx();
    var f = face || { css: THEME_FACE, weight: '800' };
    ctx.font = IMPRINT_FONT(size, f.css, f.weight);

    var chars = String(text || '').split('');
    var widths = chars.map(function (ch) { return ctx.measureText(ch).width; });
    var total = widths.reduce(function (a, b) { return a + b; }, 0);
    var glyphs = [];
    var i, cursor;

    var c = Math.max(-100, Math.min(100, Number(curve) || 0));
    var theta = (c / 100) * MAX_ARC;

    if (!theta || !total) {
      cursor = -total / 2;
      for (i = 0; i < chars.length; i++) {
        glyphs.push({ ch: chars[i], x: cursor + widths[i] / 2, y: 0, rot: 0 });
        cursor += widths[i];
      }
      return { glyphs: glyphs, minX: -total / 2, maxX: total / 2, minY: -size / 2, maxY: size / 2 };
    }

    // Lay the run along a circle whose arc length equals the straight width, so
    // curving does not change how much text there is.
    var mag = Math.abs(theta);
    var R = total / mag;
    var dir = theta > 0 ? 1 : -1;
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;

    cursor = 0;
    for (i = 0; i < chars.length; i++) {
      var mid = cursor + widths[i] / 2;                 // distance along the arc
      var a = (mid / total) * mag - mag / 2;            // angle from the apex
      var x = R * Math.sin(a);
      var y = dir * (R - R * Math.cos(a));              // apex at y=0, ends fall away
      glyphs.push({ ch: chars[i], x: x, y: y, rot: dir * a });
      minX = Math.min(minX, x - widths[i] / 2); maxX = Math.max(maxX, x + widths[i] / 2);
      minY = Math.min(minY, y - size / 2); maxY = Math.max(maxY, y + size / 2);
      cursor += widths[i];
    }

    // Centre the run vertically so curving does not shift the imprint's anchor.
    var shift = (minY + maxY) / 2;
    for (i = 0; i < glyphs.length; i++) glyphs[i].y -= shift;

    return { glyphs: glyphs, minX: minX, maxX: maxX, minY: minY - shift, maxY: maxY - shift };
  };

  // The proof renders the same glyph positions as SVG, scaled to fill its box.
  P.textSvg = function (text, curve, hex, face) {
    var NOMINAL = 100;
    var f = face || { css: THEME_FACE, weight: '800' };
    var L = this.textLayout(text, NOMINAL, curve, f);
    if (!L.glyphs.length) return '';

    var pad = NOMINAL * 0.12;
    var vbX = L.minX - pad, vbY = L.minY - pad;
    var vbW = (L.maxX - L.minX) + pad * 2, vbH = (L.maxY - L.minY) + pad * 2;

    var body = L.glyphs.map(function (g) {
      return '<text x="0" y="0" text-anchor="middle" dominant-baseline="central" ' +
             'transform="translate(' + g.x.toFixed(2) + ' ' + g.y.toFixed(2) + ') ' +
             'rotate(' + (g.rot * 180 / Math.PI).toFixed(2) + ')">' + esc(g.ch) + '</text>';
    }).join('');

    return '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" ' +
           'viewBox="' + vbX.toFixed(2) + ' ' + vbY.toFixed(2) + ' ' + vbW.toFixed(2) + ' ' + vbH.toFixed(2) + '" ' +
           'preserveAspectRatio="xMidYMid meet" aria-hidden="true">' +
           '<g font-family="' + esc(f.css) + '" font-weight="' + esc(f.weight) + '" ' +
           'font-size="' + NOMINAL + '" fill="' + esc(hex) + '">' + body + '</g></svg>';
  };

  /* Two independent discount tables: decorated orders and blank caps.

     An empty table means NO discount for that side, not "borrow the other
     one". The old fallback to the decorated table made clearing the blank
     tiers impossible — blanks silently kept the decorated percentages. */
  P.tierTable = function () {
    var c = this.cfg;
    if (c.discountsEnabled === false) return [];
    var decorated = this.state.locations.length > 0;
    return (decorated ? c.tiersDecorated : c.tiersBlank) || [];
  };

  P.tierFor = function (q, table) {
    var t = table || this.tierTable();
    for (var i = 0; i < t.length; i++) {
      if (q >= t[i].min && (t[i].max === null || q <= t[i].max)) return t[i];
    }
    return t[0] || { min: 0, max: null, pct: 0 };
  };

  // Undiscounted per-cap price: the blank cap plus every decoration.
  /* Off the ORDERED colourway, not the previewed one. Where colourways carry
     different prices, browsing would otherwise rewrite the quoted total for a
     cap the customer is not buying. */
  /* ONE discounted line, the way Shopify actually discounts one.

     MEASURED on four real draft orders, not taken from the docs: Shopify
     applies the percentage to each LINE and FLOORS the discount to the cent.
     Not half-up, and not per unit.

       #D2736  12 x 13.88 @5%     8.328  -> 8.32   charged 158.24
       #D2719  50 x 12.25 @7.5%  45.9375 -> 45.93  charged 566.57
       #D2647  48 x 13.88 @7.5%  49.968  -> 49.96  charged 616.28
       #D2672  50 x 12.50 @7.5%  46.875  -> 46.87  charged 578.13

     Integer cents, because this number becomes a charge. The epsilon stops a
     float product like 4410.000000001 flooring a cent low.

     `pct` is WHOLE percent (5, not 0.05) — the shape the tier table holds, so
     nothing has to remember which side of the conversion it is on.

     THIS MUST MATCH `discountedLine` in wce-oms `src/lib/quotes/pricing.ts`.
     They price the same order on two paths and the customer sees both. */
  P.discountedLine = function (qty, unit, pct) {
    var cents = Math.round((Number(qty) || 0) * (Number(unit) || 0) * 100);
    var off = Math.floor((cents * (Number(pct) || 0)) / 100 + 1e-9);
    return (cents - off) / 100;
  };

  /* The caps and their decorations, summed as the LINES they become.

     It used to be `qty * perCap` — one multiply, one rounding — which cannot
     express per-line flooring at any number of lines, and was already a cent
     out on single-colourway orders before multi-colour existed (#D2647 quoted
     $1,355.57 against an invoice of $1,355.58).

     The line set mirrors `addonItems()` exactly: one line per colourway-and-
     size, then per location its decoration, its 3D puff and each add-on, all
     at the cap quantity. Setup is not here — it is never discounted. */
  P.capsSubtotal = function (qty, pct) {
    var self = this;
    var lines = this.orderLines();
    var base = (this.orderColor() || {}).price || this.cfg.fallbackPrice || 0;

    /* EVERY line at its OWN price. There used to be a guard here: if the lines
       did not all cost the same as the representative colourway, the whole
       order collapsed to `base` x quantity, mirroring a refusal in wce-oms
       `splitCapLines` so the screen and the invoice stayed the same shape.

       They did stay the same shape. Both were wrong. `base` is the
       representative colourway's price — the CHEAPEST size — so on any garment
       with size upcharges every larger piece was billed at the small price.
       The Gildan 5000 runs $6.22 at S and $12.40 at 3XL; a Nike polo $48.02 to
       $62.76. Measured on the polo: 36 at $48.02 plus 6 at $54.02 came to
       $2,434.78 where it should be $2,469.00.

       The assumption underneath was recorded and was true when written —
       "nothing in the catalogue prices a size or a colour differently" — and it
       was measured on CAPS, which are one size. It stopped holding the moment
       the customizer priced garments.

       wce-oms dropped the matching refusal in the same change, so the two are
       still the same shape; they are now also correct. */
    var sub = lines.length > 0
      ? lines.reduce(function (n, l) { return n + self.discountedLine(l.qty, l.price, pct); }, 0)
      : this.discountedLine(qty, base, pct);

    this.state.locations.forEach(function (l) {
      var r = self.resolve(l);
      // Only lines that will really exist — an unmapped decoration is billed
      // by nobody, and add-to-cart refuses separately.
      if (r.variantId) sub += self.discountedLine(qty, r.price, pct);
      if (self.puffAdd(l) && self.cfg.puffVariantId) {
        sub += self.discountedLine(qty, self.puffAdd(l), pct);
      }
      self.activeAddons(l).forEach(function (a) {
        if (a.variantId) sub += self.discountedLine(qty, a.price, pct);
      });
    });

    return Math.round(sub * 100) / 100;
  };

  P.listPerCap = function () {
    var col = this.orderColor();
    var base = (col && col.price) ? col.price : (this.cfg.fallbackPrice || 0);
    return base + this.addSum();
  };

  P.activeIndex = function () {
    return Math.max(0, Math.min(this.state.active, this.state.locations.length - 1));
  };

  P.activeLoc = function () {
    return this.state.locations[this.activeIndex()] || this.blankLoc();
  };

  P.frontLoc = function () {
    var l = this.state.locations;
    for (var i = 0; i < l.length; i++) if (l[i].loc === 'front') return l[i];
    return null;
  };

  P.puffAdd = function (l) {
    return (l.loc === 'front' && l.deco === this.cfg.puffDecoId && l.puff) ? this.cfg.puffAdd : 0;
  };

  // Resolve a configured location to its customization variant. A decoration
  // with sub-choices is priced by the chosen sub-choice regardless of location;
  // everything else falls back deco|loc|panel → deco|loc| → deco||.
  P.resolve = function (l) {
    var deco = this.decoOf(l.deco);
    var subs = (deco && deco.subtypes) || [];
    if (subs.length) {
      var want = l.subtype;
      for (var i = 0; i < subs.length; i++) {
        if (subs[i].value === want) return subs[i];
      }
      return subs[0];
    }
    var map = this.cfg.decoMap || {};
    var panel = l.panel || 'center';
    return map[l.deco + '|' + l.loc + '|' + panel]
      || map[l.deco + '|' + l.loc + '|']
      || map[l.deco + '||']
      || { price: 0, variantId: null, unmapped: true, value: '' };
  };

  P.hasSubtypes = function (decoId) {
    var d = this.decoOf(decoId);
    return !!(d && d.subtypes && d.subtypes.length);
  };

  P.lineAdd = function (l) {
    return this.resolve(l).price + this.puffAdd(l) + this.addonSum(l);
  };

  // Any location whose decoration didn't map to a real variant. Quoting $0 for
  // one of these would silently undercharge, so the UI has to say so.
  P.unmapped = function () {
    var self = this;
    return this.state.locations.filter(function (l) { return self.resolve(l).unmapped; });
  };

  P.addSum = function () {
    var self = this;
    return this.state.locations.reduce(function (n, l) { return n + self.lineAdd(l); }, 0);
  };

  /* Which configured location a view previews. A location names its view
     keyword, so LEFT shows the left-side decoration. The 3/4 hero shot belongs
     to no location and mirrors the front. Returns null when nothing is
     configured for that view, which is what keeps the placer bar off a view
     with no decoration to place. */
  P.locForView = function (view) {
    if (!view) return null;
    var id = String(view.id).toUpperCase();
    var locs = this.state.locations;
    for (var i = 0; i < locs.length; i++) {
      var meta = this.locMeta(locs[i].loc);
      if (meta && String(meta.view).toUpperCase() === id) return locs[i];
    }
    if (id === String(this.cfg.heroView || 'FINAL').toUpperCase()) return this.frontLoc();
    return null;
  };

  P.viewByKey = function (key) {
    var views = this.viewsForColor();
    for (var i = 0; i < views.length; i++) if (views[i].logo === key) return views[i];
    return null;
  };

  /* Default placement for a view, overridden by any dragged/sized value.

     `ratio` lives in this record rather than as a constant at each call site.
     It used to be written twice — 0.63/0.65 inline in the stage renderer and
     again in the PNG export — which is exactly how the on-screen proof and the
     customer's file drift apart. One record, both readers. */
  P.placeFor = function (key) {
    // Presets are configured per VIEW, so the defaults come from the key's
    // view half. Everything a merchant never configured starts centred, which
    // is what Kelly asked for: the customer drags it where they want it.
    var parts = this.parseObjKey(key);
    var vk = parts.view.toUpperCase();
    var vps = this.cfg.viewPlacements || {};
    /* A borrowed view gets its own row. A sleeve previewed on the front shot
       must land ON THE SLEEVE, and the front row puts it on the chest — so
       `LEFT@FRONT` is looked up before plain `FRONT`. Without that row the
       fallback would draw sleeve art across the chest, which is worse than
       drawing nothing. */
    var lmeta = this.locMeta(parts.loc);
    var own = lmeta ? String(lmeta.view).toUpperCase() : vk;
    var defs = (own !== vk && vps[own + '@' + vk]) || vps[vk] ||
      { x: 50, y: 50, w: 17, r: 0, ratio: 0.65 };

    var x = defs.x;
    if (x == null) {
      /* Front-facing views take their x from the chosen front panel. Read off
         the key's OWN location now rather than "whoever owns this view" — with
         several locations on one photo that lookup returned the first one and
         positioned everything by its panel. */
      var loc = this.locById(parts.loc) || this.locForView(this.viewByKey(parts.view)) || this.frontLoc();
      var panel = this.panelMeta((loc && loc.panel) || 'center');
      var isHero = parts.view.toUpperCase() === String(this.cfg.heroView || 'FINAL').toUpperCase();
      // Centre when there are no panels to read a position from. Only reached
      // when a placement preset asks for `panel` as its x.
      x = panel ? parseFloat(isHero ? panel.left : panel.frontLeft) : 50;
    }

    var cur = this.state.place[key] || {};
    return {
      x: cur.x != null ? cur.x : x,
      y: cur.y != null ? cur.y : defs.y,
      w: cur.w != null ? cur.w : defs.w,
      r: cur.r != null ? cur.r : defs.r,
      ratio: defs.ratio || 0.65
    };
  };

  /* The placement key for the object on screen — nothing when the view holds
     nothing. Standing on BACK with no back decoration must not hand the
     customer a live placer editing something invisible. */
  P.placeKey = function () {
    var o = this.selectedObject();
    return o ? o.key : null;
  };

  P.locById = function (id) {
    var locs = this.state.locations;
    for (var i = 0; i < locs.length; i++) if (locs[i].loc === id) return locs[i];
    return null;
  };

  /* ---------- drawable objects ------------------------------------------

     Placement used to be keyed by VIEW (`state.place['FRONT']`), which is
     exactly why a photo could only ever hold one thing: two locations sharing
     a view had one x/y/w/r record between them, so the polo's Right Chest drew
     on the left chest and a second logo had nowhere to store its position.

     The key is now `<viewKey>|<locationId>:<kind>`. The VIEW part stays first
     because it must: one location draws on both the 3/4 hero and the front
     shot, with different presets and independent positions, and collapsing
     those would change how the cap behaves today. */

  P.objKey = function (viewKey, locId, kind) {
    return viewKey + '|' + locId + ':' + (kind || 'art');
  };

  P.parseObjKey = function (key) {
    var str = String(key || '');
    var bar = str.indexOf('|');
    if (bar < 0) return { view: str, loc: '', kind: 'art' };
    var rest = str.slice(bar + 1);
    var colon = rest.lastIndexOf(':');
    // `kind` may carry a file id — `art#f3` — so split that off too.
    var kind = colon < 0 ? 'art' : rest.slice(colon + 1);
    var hash = kind.indexOf('#');
    return {
      view: str.slice(0, bar),
      loc: colon < 0 ? rest : rest.slice(0, colon),
      kind: hash < 0 ? kind : kind.slice(0, hash),
      file: hash < 0 ? '' : kind.slice(hash + 1)
    };
  };

  /* Everything drawable on one view, in location order. Today each location
     contributes one object — its artwork or its imprint text, whichever the
     tab says. The shape is a list so a location can contribute both. */
  P.objectsForView = function (v) {
    if (!v || !v.logo) return [];
    var self = this;
    var vid = String(v.id).toUpperCase();
    var out = [];

    /* Listed whether or not it currently has anything IN it. renderStage
       decides visibility. Filtering on drawability here would take the placer
       bar — and SAVE MOCKUP with it — off screen between adding a location and
       uploading to it, which is exactly when the customer needs it. */
    var add = function (l, idx) {
      var shown = self.shownFiles(l);
      shown.forEach(function (f) {
        out.push({
          key: self.objKey(v.logo, l.loc, 'art#' + f.id),
          loc: l, idx: idx, kind: 'art', file: f, view: v
        });
      });
      // Text rides ALONGSIDE the images rather than instead of them, with its
      // own key and therefore its own position (Kelly: independently movable).
      if (l.textOn && l.text) {
        out.push({
          key: self.objKey(v.logo, l.loc, 'text'),
          loc: l, idx: idx, kind: 'text', file: null, view: v
        });
      }
      /* Nothing on the product yet still gets ONE object, so the placer bar —
         and SAVE MOCKUP with it — stays on screen between adding a location
         and uploading to it, which is exactly when it is needed. */
      if (!shown.length && !(l.textOn && l.text)) {
        out.push({
          key: self.objKey(v.logo, l.loc, l.tab === 'text' ? 'text' : 'art'),
          loc: l, idx: idx, kind: l.tab === 'text' ? 'text' : 'art', file: null, view: v
        });
      }
    };

    this.state.locations.forEach(function (l, idx) {
      var meta = self.locMeta(l.loc);
      if (meta && self.viewForLoc(l) === vid) add(l, idx);
    });

    // The hero shot mirrors the front rather than naming a view of its own.
    if (!out.length && vid === String(this.cfg.heroView || 'FINAL').toUpperCase()) {
      var front = this.frontLoc();
      if (front) add(front, this.state.locations.indexOf(front));
    }
    return out;
  };

  /* Which object the size / rotate / remove controls act on. Prefer the
     location the customer is configuring on the right; otherwise the first
     thing on the photo, so the controls are never pointed at something the
     customer cannot see. */
  P.selectedObject = function () {
    var v = this.viewsForColor()[this.state.view];
    var objs = this.objectsForView(v);
    if (!objs.length) return null;
    var i;

    // An explicit pick wins, but only while it is still on this view — the
    // key is dropped rather than trusted when the customer switches views or
    // deletes the thing it named.
    var want = this.state.selectedKey;
    if (want) {
      for (i = 0; i < objs.length; i++) if (objs[i].key === want) return objs[i];
    }

    // Otherwise follow the location being configured on the right, then fall
    // back to the first thing on the photo.
    var act = this.activeLoc();
    for (i = 0; i < objs.length; i++) if (act && objs[i].loc === act) return objs[i];
    return objs[0];
  };

  /* Selecting also makes the object's location the active one, so the panel
     on the right and the controls under the photo can never describe
     different things. */
  P.selectObject = function (key) {
    var parts = this.parseObjKey(key);
    var idx = -1;
    var locs = this.state.locations;
    for (var i = 0; i < locs.length; i++) if (locs[i].loc === parts.loc) { idx = i; break; }
    var patch = { selectedKey: key };
    if (idx > -1) patch.active = idx;
    this.set(patch);
  };

  // Locations name a view by keyword, since views are omitted when a colorway
  // has no photo for them and positions therefore shift.
  P.viewIndexFor = function (keyword) {
    var views = this.viewsForColor();
    for (var i = 0; i < views.length; i++) {
      if (String(views[i].id).toUpperCase() === String(keyword).toUpperCase()) return i;
    }
    return 0;
  };

  P.currentColor = function () { return this.cfg.colors[this.state.color] || this.cfg.colors[0] || {}; };

  /* ---------- sizes -------------------------------------------------------
     Off entirely unless the section names a size option, which is what keeps
     caps on exactly the path they were on before this existed.
  ---------------------------------------------------------------------- */

  P.sizeMode = function () { return !!(this.cfg.sizeOptionName || ''); };

  /* ---------- the size run for a colourway past the 250-variant cap --------

     Liquid hands back at most 250 of a product's variants. On the Gildan 5000
     (580) that leaves 46 of 80 colourways with no size list at all, so the
     section marks them `needsSizes` and they are fetched here, one colourway
     at a time, from `templates/product.cc-sizes.liquid` — an alternate template
     carrying `{% layout none %}`, so the response is the payload and nothing
     else. The Section Rendering API was the obvious route and does not fit;
     the reason is written out in that template.

     Fetched on TOUCH rather than up front. Asking for all 46 on load would be
     46 requests to render a page where a customer picks one or two colours;
     the ones nobody touches cost nothing.

     Every outcome is cached, failures included — the entry goes to 'done' or
     'error' and never back. A colourway whose fetch failed must not re-request
     on every hover; it keeps the empty grid and the rest of the page works.
  ---------------------------------------------------------------------- */

  P.ensureSizes = function (i) {
    var self = this;
    var col = (this.cfg.colors || [])[i];
    if (!col || !col.needsSizes || !this.sizeMode()) return;

    this._sizeFetch = this._sizeFetch || {};
    if (this._sizeFetch[i]) return;          // in flight, done, or failed
    if (!col.variantId || !this.cfg.productUrl) return;

    this._sizeFetch[i] = 'loading';

    /* `?variant=` is what selects the colourway server-side, and it is only
       answerable because the section now emits a variant id for EVERY
       colourway — including these. Before that, this request had nothing to
       ask about. */
    var url = this.cfg.productUrl +
      (this.cfg.productUrl.indexOf('?') === -1 ? '?' : '&') +
      'variant=' + encodeURIComponent(col.variantId) +
      '&view=cc-sizes';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {

        /* The section reports every option; the size one is whichever carries
           the name this customizer was configured with. Matching by name keeps
           that setting in ONE place — a section that guessed would be a second
           copy, and the two would drift. */
        var want = String(self.cfg.sizeOptionName || '').toLowerCase();
        var opt = (data.options || []).filter(function (o) {
          return String(o.name || '').toLowerCase() === want;
        })[0];
        if (!opt) throw new Error('no size option named ' + self.cfg.sizeOptionName);

        /* A colourway does not stock every size — 8 of the Gildan's colours
           carry six and 6 carry seven — so a value resolving to no variant
           under this colour is DROPPED, not shown sold out. A box that fails at
           add-to-cart is worse than no box. */
        var rows = (opt.values || []).filter(function (v) { return v.variantId; });

        col.sizes = rows.map(function (v) {
          return {
            name: v.name,
            variantId: v.variantId,
            price: v.price,
            sku: v.sku,
            available: v.available,
            stock: typeof v.stock === 'number' ? v.stock : -1
          };
        });

        /* The colourway total is the sum of its sizes, and only when they are
           ALL tracked. One untracked size makes the sum a lie, so the whole
           colourway goes back to -1 — "not tracked" — which renderStock already
           knows not to print as a zero. */
        var tracked = col.sizes.length > 0 && col.sizes.every(function (s) { return s.stock >= 0; });
        col.stock = tracked
          ? col.sizes.reduce(function (n, s) { return n + s.stock; }, 0)
          : -1;

        col.needsSizes = false;
        self._sizeFetch[i] = 'done';
        self.render();
      })
      .catch(function () {
        /* Left as needsSizes so nothing claims the run is deliberately empty,
           but never retried — see the cache note above. */
        self._sizeFetch[i] = 'error';
      });
  };

  /* One template out of the settings, filled. Liquid supplies the default
     wording for every key, so an absent value means the payload is older than
     this file — the empty string that comes back is inert rather than fatal. */
  P.copy = function (key, vars) { return fill((this.cfg.strings || {})[key], vars); };

  /* What one piece is called. Caps say CAP, apparel says EACH. A setting
     rather than a string in six places, because the two drifted the moment
     the polo template existed. */
  P.unit = function () { return (this.cfg.unitNoun || 'CAP').toUpperCase(); };
  P.unitLc = function () { return this.unit().toLowerCase(); };
  /* Plural is its own setting, not unit + "s". CAP pluralises, EACH does not —
     "3 eaches" is what deriving it would have produced. */
  P.units = function () { return (this.cfg.unitPlural || 'CAPS').toUpperCase(); };
  P.unitsLc = function () { return this.units().toLowerCase(); };

  /* `sizeRows()` lived here and read the PREVIEWED colourway's sizes. It lost
     its last caller to `sizeRowsFor(col)` when the order gained a colour axis,
     and a preview that no longer implies an order makes it a trap rather than
     dead weight — the next caller would silently size a grid off a colourway
     the customer is only looking at. */

  P.qtyKey = function (colorName, sizeName) {
    return String(colorName) + '|' + String(sizeName || '');
  };

  P.qtyOf = function (colorName, sizeName) {
    var n = (this.state.qtyBy || {})[this.qtyKey(colorName, sizeName)];
    return Math.max(0, parseInt(n, 10) || 0);
  };

  P.setQtyFor = function (colorName, sizeName, n) {
    var cur = this.state.qtyBy || {};
    var map = {};
    Object.keys(cur).forEach(function (k) { map[k] = cur[k]; });
    var v = Math.max(0, parseInt(n, 10) || 0);
    var key = this.qtyKey(colorName, sizeName);
    if (v > 0) map[key] = v; else delete map[key];
    this.set({ qtyBy: map });
  };

  // Colourways being ordered. Never empty — the previewed one stands in, so
  // there is always something to price and the grid is never blank.
  P.pickedColors = function () {
    var self = this;
    var out = (this.state.picked || [])
      .map(function (i) { return self.cfg.colors[i]; })
      .filter(Boolean);
    /* No fallback to the previewed colourway. It used to return one so that
       callers never saw an empty order, but the product now LANDS empty —
       nothing is on the order until the customer adds it — and a fallback
       would put the landing colourway straight back into the quantity grid,
       the tier, the cart properties and the quote.

       Every caller was checked for this. `orderColor()` falls back on its own
       so the price still has a cap to quote; `totalQty`, `variantShortfalls`
       and `orderLines` all return nothing, which is correct for an empty
       order; and `renderPrice` names the empty case before the sold-out one. */
    return out;
  };

  P.isPicked = function (i) { return (this.state.picked || []).indexOf(i) > -1; };

  /* The previewed colourway can now be one the customer is only LOOKING at,
     so anything that has to name a colourway they are actually buying asks
     for this instead of currentColor(). */
  P.orderColor = function () {
    if (this.isPicked(this.state.color)) return this.currentColor();
    return this.pickedColors()[0] || this.currentColor();
  };

  // Sizes for a GIVEN colourway. A colour that does not stock 4XL has no 4XL
  // cell, rather than a box that fails at add-to-cart.
  P.sizeRowsFor = function (col) {
    if (!this.sizeMode()) return [];
    return (col && col.sizes) || [];
  };

  /* The tier is priced on this and nothing else. Six each of four sizes in two
     colours is a 48-piece order and tiers as one — splitting a run by colour
     must not lose the discount any more than splitting it by size does. */
  P.totalQty = function () {
    var self = this;
    var n = 0;
    this.pickedColors().forEach(function (col) {
      var rows = self.sizeRowsFor(col);
      if (rows.length) {
        rows.forEach(function (r) { n += self.qtyOf(col.name, r.name); });
      } else {
        n += self.qtyOf(col.name, '');
      }
    });
    return n;
  };

  /* Cells that have something in them but not enough of it. An EMPTY cell is
     simply not ordered and is never short — the rule is about the size of a
     run, not about forcing every colourway to be bought. */
  /* Blank and decorated runs answer to different per-cell figures, the same
     way they already do for the order total. A blank run is picked and packed;
     a decorated one is set up and stitched, and the setup is what a big single
     colourway amortises. Kelly, on caps: 12 blank, 6 decorated. */
  P.effectiveVariantMin = function () {
    var c = this.cfg;
    var raw = this.state.locations.length ? c.minQtyVariant : c.minQtyVariantBlank;
    return Math.max(1, parseInt(raw, 10) || 1);
  };

  P.variantShortfalls = function () {
    var floor = this.effectiveVariantMin();
    if (floor <= 1) return [];
    var self = this;
    var out = [];
    this.pickedColors().forEach(function (col) {
      var rows = self.sizeRowsFor(col);
      var list = rows.length ? rows : [{ name: '' }];
      list.forEach(function (r) {
        var n = self.qtyOf(col.name, r.name);
        if (n > 0 && n < floor) {
          out.push({ color: col.name, size: r.name, qty: n, need: floor - n });
        }
      });
    });
    return out;
  };

  // Only combinations with a quantity AND a real variant become cart lines.
  P.orderLines = function () {
    var self = this;
    var out = [];
    this.pickedColors().forEach(function (col) {
      var rows = self.sizeRowsFor(col);
      if (rows.length) {
        rows.forEach(function (r) {
          var n = self.qtyOf(col.name, r.name);
          if (n > 0 && r.variantId) {
            // The price rides along because the subtotal is now summed per
            // LINE, and a size can carry its own price.
            out.push({ color: col.name, name: r.name, variantId: r.variantId, qty: n, price: r.price });
          }
        });
      } else {
        var n = self.qtyOf(col.name, '');
        if (n > 0 && col.variantId) {
          out.push({ color: col.name, name: '', variantId: col.variantId, qty: n, price: col.price });
        }
      }
    });
    return out;
  };

  /* Takes the colourway rather than reaching for the previewed one, so the
     proof sheet can ask for a colour that is on the order but not on screen.
     Every existing caller omits it and keeps the old meaning exactly. */
  P.viewsForColor = function (col) {
    col = col || this.currentColor();
    return (col.views && col.views.length) ? col.views : this.cfg.views;
  };

  /* One view of one colourway, by keyword. Views are dropped when a colourway
     has no photo for them, so the answer is per colour and may be null — a
     colourway photographed from the front only contributes a front tile and no
     back tile, rather than a back tile wearing the wrong colour's cap. */
  P.viewOnColor = function (col, viewId) {
    var want = String(viewId).toUpperCase();
    var views = this.viewsForColor(col);
    for (var i = 0; i < views.length; i++) {
      if (String(views[i].id).toUpperCase() === want) return views[i];
    }
    return null;
  };

  // Piecewise slider scale: 100 units per stop segment, sticky within 12% of a stop.
  P.qtyToPos = function (q) {
    var S = this.cfg.stops;
    if (q >= S[S.length - 1]) return (S.length - 1) * 100;
    for (var i = 0; i < S.length - 1; i++) {
      if (q >= S[i] && q <= S[i + 1]) return Math.round(i * 100 + ((q - S[i]) / (S[i + 1] - S[i])) * 100);
    }
    return 0;
  };

  P.posToQty = function (pos) {
    var S = this.cfg.stops;
    var seg = Math.min(S.length - 2, Math.floor(pos / 100));
    var frac = (pos - seg * 100) / 100;
    if (frac < 0.12) frac = 0;
    if (frac > 0.88) frac = 1;
    return Math.round(S[seg] + frac * (S[seg + 1] - S[seg]));
  };

  /* Some decorations carry their own minimum order quantity — a woven patch
     runs 50, sublimation 48 — so the floor is whichever chosen decoration
     demands most. Clamped to maxQty as well, so a minimum above the ceiling
     can never produce a quantity the customer cannot order. */
  P.effectiveMinQty = function () {
    var c = this.cfg;
    var self = this;
    /* A blank order answers to its own minimum. There is no digitizing to
       amortise, so the quantity that makes a decorated run worth setting up is
       not the quantity that makes a blank one worth picking and packing. With
       no locations the per-decoration floors below cannot raise it either,
       so this is the whole answer. */
    if (!this.state.locations.length) {
      var b = Number(c.minQtyBlank) || 1;
      return Math.min(Math.max(1, b), c.maxQty);
    }
    var floor = c.minQty;
    this.state.locations.forEach(function (l) {
      var m = Number(self.resolve(l).minQty) || 0;
      if (m > floor) floor = m;
      self.activeAddons(l).forEach(function (a) {
        var am = Number(a.minQty) || 0;
        if (am > floor) floor = am;
      });
    });
    return Math.min(floor, c.maxQty);
  };

  /* The per-piece figure, as a RANGE when the sizes ordered cost different
     amounts. Kelly chose a range over a blended average, 2026-08-25: no piece
     in the order costs the average, so a customer checking the maths against
     one shirt would find it wrong.

     One function because there are three places that show this — the price
     panel, the order-row summary and the `_quoted_per_cap` line property that
     travels to the cart. Three copies of the vary test is how a screen ends up
     saying "$57.26" beside a row reading "$57.26–$62.96". */
  P.moneyRange = function (lo, hi) {
    var cents = this.money(Math.round(lo * 100));
    return lo === hi ? cents : cents + '–' + this.money(Math.round(hi * 100));
  };

  /* ALWAYS from the ordered lines, never from `perCap`.

     `perCap` is built from the colourway's representative price, and the two
     agree only when the customer happens to have ordered that size. One 4XL on
     its own is a single price, so nothing "varies" — and the screen still read
     $48.02 PER BLANK EACH beside an ORDER TOTAL of $56.02, with a breakdown of
     "1 shirts @ $48.02" that did not add up to its own total. Kelly caught it
     in a screenshot.

     Branching on `unitsVary` and falling back to `perCap` was the mistake: the
     fallback was the number being replaced. min and max come from the lines, so
     when they are equal that one number is already the right one. */
  P.perCapText = function (p) { return this.moneyRange(p.perCapMin, p.perCapMax); };
  P.listText = function (p) { return this.moneyRange(p.listMin, p.listMax); };

  P.pricing = function () {
    var self = this;
    var c = this.cfg;
    var minQty = this.effectiveMinQty();
    // Raise rather than block: the tier is then picked from the raised
    // quantity, so the customer sees the higher count AND the better per-cap
    // price together, instead of an error they have to decode.
    /* In size mode the quantity is the SUM of the grid and is NOT raised to
       the minimum — there is no honest way to pick which size absorbs the
       difference. The shortfall is reported instead, and add-to-cart refuses.
       Outside size mode the old raise-rather-than-block behaviour stands. */
    /* NEVER raised to the minimum any more, in either mode. It used to be
       raised for a single quantity — one box, one honest place to put the
       difference. With several colours, and sizes within them, there is no
       honest choice of which cell absorbs a shortfall, so this refuses and
       says by how much instead. Same reasoning that already stopped size mode
       raising; it now applies to one-size products too, which IS a change to
       how they behaved. */
    var qty = Math.min(this.totalQty(), c.maxQty);
    var locs = this.state.locations;
    var table = this.tierTable();
    var tier = this.tierFor(qty, table);
    var addSum = this.addSum();
    var list = this.listPerCap();

    // The discount applies to the whole decorated price, not just the blank.
    var pct = (tier.pct || 0) / 100;
    var perCap = list * (1 - pct);
    // Summed per LINE, because that is what Shopify charges — see
    // capsSubtotal(). `perCap` stays as the headline per-cap figure the screen
    // shows; it is no longer what the subtotal is derived from.
    var capsSub = this.capsSubtotal(qty, tier.pct || 0);

    /* What the pieces in THIS order actually cost, low to high.

       `perCap` above is built from the representative colourway. On a cap that
       is the whole truth — one size, one price. On apparel it is whichever size
       happens to represent the order, and showing it as "per each" is how an
       order billing $2,434.78 instead of $2,469.00 looked correct.

       Taken from the ordered LINES, not from the product, so it describes the
       sizes actually chosen: a run of S to XL on a polo whose 4XLT costs $62.76
       is a $48 order, not a $48-$63 one. */
    var oLines = this.orderLines();
    var unitLow = null, unitHigh = null;
    oLines.forEach(function (l) {
      var u = Number(l.price) || 0;
      if (unitLow === null || u < unitLow) unitLow = u;
      if (unitHigh === null || u > unitHigh) unitHigh = u;
    });
    if (unitLow === null) { unitLow = unitHigh = this.listPerCap() - addSum; }
    var listMin = unitLow + addSum;
    var listMax = unitHigh + addSum;

    /* The order at LIST, before the tier — summed from the lines for the same
       reason the subtotal is. `qty * list` is this number only when every size
       costs the same, and it is what the breakdown row printed and what the
       discount was derived from: one 4XLT read "1 shirts @ $62.76 ... $48.02",
       a row that did not add up to its own total. With a tier applied the same
       expression made the discount NEGATIVE. */
    var listSub = oLines.length
      ? oLines.reduce(function (n, l) { return n + l.qty * (Number(l.price) || 0); }, 0) + qty * addSum
      : qty * list;
    var perCapMin = listMin * (1 - pct);
    var perCapMax = listMax * (1 - pct);
    /* The ONE test everything downstream asks. Comparing the two numbers in
       each place they are shown is how a screen ends up saying "$57.26" beside
       an order that spans $57.26-$62.96. */
    var unitsVary = perCapMax !== perCapMin;

    var reorder = this.state.refMode === 'order';
    /* Setup = the real one-time charges, plus $10 for every location past the
       first. Kelly, 2026-08-18: the flat $30 first-location setup is RETIRED —
       what a location costs to set up is the die / plate / mold / digitizing
       fee carried on its own decoration variant (custom.one_time_charge), and
       nothing else. The additional-location fee survives untouched, because it
       pays for the extra hooping run rather than for artwork.

       So front PV+ AirDome ($200) + back embroidery = $200 + $10 = $210.

       Consequence worth knowing: a decoration with an EMPTY one_time_charge
       now contributes $0 setup, where it used to fall back to $30. There is
       deliberately no fallback — same reasoning as every other customizer
       metafield, one place to look — so an unset charge is a $0 charge.

       An add-on's one-time charge still ADDS: an add-on die is a second die.

       A REORDER NO LONGER WAIVES ANY OF IT (Kelly, 2026-09-06). Setup is
       charged on every order, repeat or not, and a genuine repeat is REFUNDED
       after the order is placed and reviewed. Waiving it up front meant taking
       the customer's word for "same as last time" before anyone had checked
       the artwork actually matched an archived file. `reorder` is still read
       and still travels to wce-oms — it flags the order for that review — it
       simply no longer changes the price. */
    var setupTotal = 0;
    {
      locs.forEach(function (l, i) {
        /* The FIRST location pays its decoration's own setup charge; every
           location after it pays the flat additional-location fee (Kelly,
           2026-08-18). Locations are held in the configured order, so with a
           front decoration chosen the front is always index 0.

           This is the old $30-then-$10 model stated properly, and the reason
           the naive read is wrong: the metafield holds DIGITIZING, which is a
           per-DESIGN cost, while the $10 is a per-LOCATION cost. Billing the
           charge at every location multiplies a fee that should be paid once —
           front+back embroidery came out $70 instead of $40. Billing $10 at
           every location instead lets a side-only order pay $10 for digitizing
           that costs $30.

           So a secondary location's own charge is only ever read when it IS
           the first location — which is exactly the side-only or back-only
           order that used to slip through at $0. Dies are unaffected: patches
           are front-only in the locations setting, so a die can never land on
           a secondary location.

           An add-on's charge still bills wherever it sits: an add-on die is a
           second die, not a second run of the same one. */
        /* UNLESS the method charges ONE setup for the whole order. DTF on a
           t-shirt is one transfer sheet: it is set up once and the number of
           places it lands on the garment does not change that (Kelly,
           2026-08-25). Embroidery is the opposite and is the default — each
           location is a separate hooping run, so each pays the fee.

           Safe to read the method off location 0 because an order carries ONE
           method throughout; see setDecoration. */
        /* Off the VARIANT this decoration resolves to, not off the decoration
           block — wce-oms reads the same `custom.setup_once` metafield on the
           same variant, and the server is what invoices. A theme-side checkbox
           would have been a second copy the server could not see, which is how
           a screen and an invoice come to disagree.

           Read from location 0 because an order carries ONE method throughout;
           see setDecoration. */
        /* ONLY THE PRIMARY pays a one-time charge. Every additional location
           pays the flat fee, whatever method it uses.

           A per-METHOD version shipped briefly on 2026-09-06 and was reverted
           the same day. It was built on a measurement error — a probe of the
           page config read `oneTime`/`oneTimeCharge` when the key is
           `oneTimeCents`, came back null, and produced the false claim that cap
           setup charges were all zero. They are not: EVERY cap decoration
           carries one, embroidery $30 at any location, patches $30-$200.

           With real numbers the per-method rule double-charged. The $30 on
           `Headwear - Secondary Embroidery Side` exists so a side-only order
           still pays a setup; it is only ever meant to be read when that side
           IS the primary. The $10 is what a secondary costs when it rides
           behind a front decoration. Billing both made a Woven Patch front plus
           an embroidered side $70 where Kelly's own note promises $40. */
        var oneSetup = self.resolve(locs[0] || l).setupOnce;
        if (i === 0) {
          setupTotal += self.oneTimeOf(self.resolve(l));
        } else if (!oneSetup) {
          setupTotal += c.addlLocationSetup;
        }
        self.activeAddons(l).forEach(function (a) {
          setupTotal += self.oneTimeOf(a);
        });
      });
    }

    var idx = table.indexOf(tier);
    var next = table[idx + 1] || null;
    var nextPct = next ? (next.pct || 0) / 100 : pct;

    /* Nothing ordered is not a $40 order. In size mode the quantity can be
       ZERO — the grid starts empty and is deliberately never raised to the
       minimum — and setup is a per-ORDER charge, so it was being totalled
       against no garments: the summary read ORDER TOTAL $40.00 beside 0
       PIECES. addToCart already refuses at zero, so nothing could ever be
       sold, but a number that large presented as the total is read as broken
       pricing, and reasonably so.

       Only size mode can reach zero; everywhere else the quantity is clamped
       to the minimum. */
    var empty = qty <= 0;
    if (empty) setupTotal = 0;

    /* Blank cap shipping surcharge — Kelly, 2026-09-07. Charged per cap ONLY
       when nothing is being decorated (locs is empty): a blank order costs
       more to ship per dollar of revenue than a decorated run at the same
       flat/free shipping rate. Gated on `locs.length` the same way setupTotal
       above is gated, and computed here rather than in addonItems() alone so
       the QUOTE and the real cart line cannot drift apart the way setup did
       (see the setupCharges()/pricing() history above this function). */
    var blankShippingTotal = (empty || locs.length) ? 0 : qty * (Number(c.blankShippingFee) || 0);

    /* Below the minimum is also unsellable, and only size mode can get here:
       everywhere else the quantity is clamped UP to the floor, so it can never
       be short. addToCart refuses either way — this is so the button says so
       before it is pressed rather than after. */
    var belowMin = qty > 0 && qty < minQty;
    var shortBy = belowMin ? minQty - qty : 0;
    // Carried here so the button, the summary and addToCart cannot disagree
    // about whether an order is sellable.
    var vShort = this.variantShortfalls();

    return {
      qty: qty, tier: tier, next: next, table: table, addSum: addSum,
      list: list, pct: tier.pct || 0, perCap: perCap,
      perCapMin: perCapMin, perCapMax: perCapMax, unitsVary: unitsVary,
      listMin: listMin, listMax: listMax, listSub: listSub,
      capsSub: capsSub, setupTotal: setupTotal, reorder: reorder,
      blankShippingTotal: blankShippingTotal,
      empty: empty, belowMin: belowMin, shortBy: shortBy,
      variantShort: vShort, variantMin: this.effectiveVariantMin(),
      /* DERIVED from the subtotal, not computed alongside it. `qty * list *
         pct` is the discount before per-line flooring, so with the subtotal
         now floored the screen would show a breakdown that does not add up —
         list minus discount landing a cent or two off the total beneath it.
         wce-oms builds the emailed breakdown the same way. */
      discountTotal: empty ? 0 : Math.round((listSub - capsSub) * 100) / 100,
      total: capsSub + setupTotal + blankShippingTotal,
      gap: next ? next.min - qty : 0,
      // Per-cap saving at the next tier — always true, unlike a projected total.
      save: next ? listMin * (nextPct - pct) : 0
    };
  };

  /* ---------- background removal ----------------------------------------

     ONE mechanism: the artwork is sent to wce-oms and a real matted cutout
     comes back. The old mix-blend-mode multiply "drop white" fake was removed
     2026-08-22 (Kelly) — it only ever read correctly on light art over light
     fabric, and it cannot work at all once several images share a view, since
     a white box multiplied over its neighbour darkens it.

     Removal is PERMANENT and lives ON THE FILE (`f.cut`). There is no mode to
     switch off: once a cutout exists it is what gets drawn, on screen and in
     the exported proof, for as long as that file is attached. Deleting the
     file takes its cutout with it, which is the only way back.

     Keying on the file rather than on global state is what makes several
     images on one view behave: each carries its own answer, and switching
     files or locations picks up that file's own cutout. */

  // Files currently on the product, in list order.
  P.shownFiles = function (l) {
    var ids = (l && l.shown) || [];
    return ((l && l.files) || []).filter(function (f) {
      return f.url && ids.indexOf(f.id) > -1;
    });
  };

  P.fileById = function (l, id) {
    var files = (l && l.files) || [];
    for (var i = 0; i < files.length; i++) if (files[i].id === id) return files[i];
    return null;
  };

  // What to DRAW for one file: its cutout if it has one, else the upload.
  P.srcForFile = function (f) { return (f && (f.cut || f.url)) || ''; };

  // The file entry currently drawn, so a cutout attaches to the right artwork.
  P.fileForArt = function (l) {
    var art = (l && l.art) || '';
    if (!art) return null;
    var hit = (l.files || []).filter(function (f) { return f.url === art; });
    return hit[0] || null;
  };

  // '' unless this file has a cutout. Nothing else gates it: removal is
  // permanent, so the question is only ever "has it been done to this file".
  P.cutoutFor = function (l) {
    var f = this.fileForArt(l);
    return (f && f.cut) || '';
  };

  // What to DRAW. Everything else — the file list's "ON PRODUCT" marker, removal
  // on delete — keeps comparing against the original url, which stays the
  // identity of the artwork.
  P.artSrcFor = function (l) {
    return this.cutoutFor(l) || (l && l.art) || '';
  };

  // Whether the drawn artwork is the matted version rather than the upload.
  P.usingCutout = function (l) { return !!this.cutoutFor(l); };

  P.requestCutout = function (f) {
    var self = this;
    var ep = this.cfg.bgRemoveEndpoint;
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.onerror = function () { resolve(self.copy('errArtworkUnreadable')); };
      reader.onload = function () {
        fetch(ep, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ image: String(reader.result || '') })
        })
          .then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (d) {
              return { ok: r.ok, d: d };
            });
          })
          .then(function (res) {
            if (!res.ok || !res.d.url) {
              resolve(res.d.error || self.copy('errBgRemoveFailed'));
              return;
            }
            f.cut = res.d.url;
            resolve('');
          })
          .catch(function (e) { resolve(self.copy('errBgRemoveFailed') + ': ' + (e && e.message ? e.message : e)); });
      };
      reader.readAsDataURL(f.file);
    });
  };

  /* Drop a file from a location and re-point the artwork. Shared so the
     ARTWORK list's REMOVE and the preview's REMOVE LOGO cannot drift: if the
     next file becomes the artwork in one place and not the other, the cap
     shows something the list says was deleted. */
  P.removeFileFrom = function (idx, f) {
    var loc = this.state.locations[idx];
    if (!loc || !f) return;
    var rest = (loc.files || []).filter(function (x) { return x !== f; });
    var stillUsed = rest.some(function (x) { return x.url && x.url === loc.art; });
    var fallback = rest.filter(function (x) { return x.url; })[0];
    this.patchLoc(idx, {
      files: rest,
      shown: (loc.shown || []).filter(function (id) { return id !== f.id; }),
      art: stillUsed ? loc.art : (fallback ? fallback.url : '')
    });
  };

  // The location owning the view on screen — not necessarily the active one,
  // since the preview can be parked on a view belonging to another location.
  P.ownerOfView = function () {
    var v = this.viewsForColor()[this.state.view];
    var owner = v ? this.locForView(v) : null;
    return owner ? { loc: owner, idx: this.state.locations.indexOf(owner) } : null;
  };

  P.artNote = function (l) {
    /* Describes what is ON the product, which can be both. It used to
       return the text and stop, so a location carrying a logo and a name
       reported only the name. */
    if (l.textOn && l.text) {
      var files = this.shownFiles(l);
      return files.length
        ? files.length + (files.length === 1 ? ' IMAGE' : ' IMAGES') + ' + TEXT: ' + l.text
        : 'TEXT: ' + l.text;
    }
    var f = l.files || [];
    if (!f.length) return 'ART NEEDED';
    return f.length === 1 ? f[0].name : f.length + ' FILES';
  };

  // "Patches · Rubber (PVC) · 3D PUFF" — the sub-choice is part of what the
  // customer picked, so it belongs everywhere the decoration is named.
  P.decoLabel = function (l) {
    var bits = [this.decoOf(l.deco).name];
    var r = this.resolve(l);
    if (r.label) bits.push(r.label);
    // Read back to the customer everywhere the decoration is named, including
    // the quote email summary — a colour they cannot see before submitting is
    // a colour they cannot correct.
    if (l.patchColor) bits.push(l.patchColor);
    this.activeAddons(l).forEach(function (a) { bits.push(a.label); });
    if (this.puffAdd(l)) bits.push('3D PUFF');
    return bits.join(' · ');
  };

  /* "Front Left Panel" on a cap, plain "Front" on anything without panels.

     The panel half is appended only when a panel actually EXISTS — it used to
     be appended whenever the location id was literally `front`, which threw on
     every product whose `panels` setting is empty. Guarding on the id was
     always the wrong test: what decides this is whether the product has panels,
     not what somebody named the location.

     A missing location returns '' rather than throwing. It means the id in
     `deco_map` or `locations` no longer matches, which is a misconfiguration
     worth surviving long enough to be seen. */
  P.locFullName = function (l) {
    var meta = this.locMeta(l && l.loc);
    if (!meta) return '';
    var panel = this.panelMeta((l && l.panel) || 'center');
    return meta.name + (panel && panel.name ? ' ' + panel.name : '');
  };

  /* ---------- state helpers --------------------------------------------- */

  P.set = function (patch) {
    for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) this.state[k] = patch[k];
    this.render();
  };

  /* ONE DECORATION METHOD PER ORDER — Kelly, 2026-08-25.

     Choosing DTF anywhere makes the whole order DTF; choosing embroidery makes
     it all embroidery. So this sets the method on EVERY location, not just the
     one being edited.

     The reason is money, not tidiness. Setup is charged per method — DTF is one
     flat charge for the order however many locations, embroidery is a charge
     for the first plus a fee for each additional — and an order carrying both
     would have to run two setup schemes side by side on one quote. Kelly ruled
     that out rather than have the customizer invent the arithmetic.

     A location that cannot take the new method is DROPPED, because leaving it
     would be an order that silently mixes after all. On a t-shirt that is the
     real case: switching to embroidery cannot keep a Full Front, which is a
     print-only location.

     Sub-choice, patch colour and add-ons are cleared wherever the method
     changes — they belong to the method, and a leather patch's colour means
     nothing once the location is embroidered. */
  P.setDecoration = function (decoId) {
    var self = this;

    /* Mixed methods (caps): the picker belongs to the ACTIVE location, so it
       changes that one and leaves the rest alone. Without this a patch on the
       front rewrites the embroidered side into a patch the side cannot take,
       and then drops it — which is the whole complaint. */
    if (this.cfg.allowMixedMethods) {
      var ai = this.activeIndex();
      var mixed = this.state.locations.map(function (l, n) {
        if (n !== ai) return l;
        if (!self.decosForLoc(l.loc).some(function (d) { return d.id === decoId; })) return l;
        return Object.assign({}, l, {
          deco: decoId,
          subtype: self.defaultSubtype(decoId),
          patchColor: '',
          addons: []
        });
      });
      this.set({ locations: mixed });
      return;
    }

    var kept = [];
    this.state.locations.forEach(function (l) {
      var allows = self.decosForLoc(l.loc).some(function (d) { return d.id === decoId; });
      if (!allows) return;
      kept.push(l.deco === decoId ? l : Object.assign({}, l, {
        deco: decoId,
        subtype: self.defaultSubtype(decoId),
        patchColor: '',
        addons: []
      }));
    });
    this.set({ locations: kept, active: Math.min(this.state.active, Math.max(0, kept.length - 1)) });
  };

  P.patchLoc = function (i, obj) {
    this.state.locations = this.state.locations.map(function (l, n) {
      return n === i ? Object.assign({}, l, obj) : l;
    });
    this.render();
  };

  /* ---------- file intake ------------------------------------------------ */

  P.intake = function (fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    if (!files.length) return;
    var locs = this.state.locations;
    var ai = this.activeIndex();
    var act = locs[ai];
    if (!act) return;

    var maxBytes = (this.cfg.maxFileMb || 20) * 1048576;
    var rejected = [];
    var added = [];

    files.forEach(function (f) {
      if (f.size > maxBytes) { rejected.push(f.name); return; }
      var ext = (f.name.split('.').pop() || 'FILE').toUpperCase();
      var mb = f.size / 1048576;
      var vector = ['AI', 'EPS', 'PDF', 'SVG'].indexOf(ext) > -1;
      added.push({
        id: 'f' + (++FILE_SEQ),
        name: f.name,
        ext: ext,
        meta: (mb < 0.1 ? Math.round(f.size / 1024) + ' KB' : mb.toFixed(1) + ' MB') + ' · ' + (vector ? 'VECTOR OK' : 'RASTER — 300DPI REQUIRED'),
        url: /^image\//.test(f.type) ? URL.createObjectURL(f) : '',
        file: f
      });
    });

    var next = (act.files || []).concat(added);
    /* Every uploaded image goes ON the product immediately. Kelly asked for
       "separate images on the same location", and an upload that appears in a
       list but not on the garment reads as a failed upload. Anything unwanted
       is one click away in that list. */
    var nextShown = (act.shown || []).concat(
      added.filter(function (f) { return f.url; }).map(function (f) { return f.id; })
    );
    var firstShown = next.filter(function (f) { return nextShown.indexOf(f.id) > -1; })[0];
    this.state.dropActive = false;
    this.state.hidden = {};
    this.state.error = rejected.length
      ? this.copy('errFileTooLarge', {
        max: this.cfg.maxFileMb || 20,
        files: rejected.join(', '),
        email: this.cfg.proofEmail || 'us'
      })
      : '';
    this.patchLoc(ai, {
      files: next,
      shown: nextShown,
      art: firstShown ? firstShown.url : act.art
    });
  };

  /* ---------- drag placement -------------------------------------------- */

  P.startDrag = function (key, e) {
    e.preventDefault();
    var self = this;
    var wrap = this.root.querySelector('[data-cc-logo="' + key + '"]');
    // The wrap's parent is the SLIDE, whose box is dimensionally identical to
    // the stage's.
    var slide = wrap && wrap.parentElement;
    if (!slide) return;
    var cur = this.placeFor(key);

    var point = function (ev) {
      var t = ev.touches && ev.touches[0];
      return { x: t ? t.clientX : ev.clientX, y: t ? t.clientY : ev.clientY };
    };

    var move = function (ev) {
      if (ev.cancelable) ev.preventDefault();
      var p = point(ev);
      /* Measured per move, not once at mousedown. getBoundingClientRect
         returns POST-transform viewport coordinates, so this ratio is already
         scale-invariant and must NOT be divided by the zoom — but a rect
         cached at mousedown goes stale the moment the zoom changes or the page
         scrolls mid-drag, and the artwork jumps. */
      var box = slide.getBoundingClientRect();
      var x = clamp(((p.x - box.left) / box.width) * 100, 4, 96);
      var y = clamp(((p.y - box.top) / box.height) * 100, 4, 96);
      var place = Object.assign({}, self.state.place);
      place[key] = { x: x, y: y, w: cur.w, r: cur.r };
      self.state.place = place;
      self.state.dragging = true;
      self.render();
    };

    var up = function () {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
      window.removeEventListener('touchmove', move);
      window.removeEventListener('touchend', up);
      self.set({ dragging: false });
    };

    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('touchend', up);
  };

  // Keyboard nudge for the placement grip — the drag handle is otherwise
  // mouse/touch only, which would fail WCAG 2.1.1.
  P.nudge = function (key, dx, dy) {
    var cur = this.placeFor(key);
    var place = Object.assign({}, this.state.place);
    place[key] = { x: clamp(cur.x + dx, 4, 96), y: clamp(cur.y + dy, 4, 96), w: cur.w, r: cur.r };
    this.set({ place: place });
  };

  /* ---------- event binding ---------------------------------------------- */

  // Placement grip: pointer drag, plus arrow-key nudging so the control is
  // reachable without a mouse. Called as each slide is built.
  P.bindGrip = function (grip, key) {
    var self = this;
    // Touching a grip selects its object. Without this the sliders stayed
    // pointed at whatever was first while the customer dragged something else.
    grip.addEventListener('mousedown', function (e) {
      self.selectObject(key);
      self.startDrag(key, e);
    });
    grip.addEventListener('touchstart', function (e) {
      self.selectObject(key);
      self.startDrag(key, e);
    }, { passive: false });
    grip.addEventListener('focus', function () { self.selectObject(key); });
    grip.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 5 : 1;
      var map = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
      var d = map[e.key];
      if (!d) return;
      e.preventDefault();
      self.nudge(key, d[0], d[1]);
    });
  };

  P.bind = function () {
    var self = this;
    var el = this.el;
    var c = this.cfg;

    var on = function (node, ev, fn) { if (node) node.addEventListener(ev, fn); };

    on(el.addColor, 'click', function () { self.pickColor(self.state.color); });

    on(el.stage, 'mouseenter', function () { self.set({ hoverStage: true }); });
    on(el.stage, 'mouseleave', function () { self.set({ hoverStage: false }); });


    on(el.sizeRange, 'input', function (e) {
      var k = self.placeKey();
      var cur = self.placeFor(k);
      var place = Object.assign({}, self.state.place);
      place[k] = Object.assign({}, cur, { w: parseInt(e.target.value, 10) });
      self.set({ place: place });
    });

    on(el.rotRange, 'input', function (e) {
      var k = self.placeKey();
      var cur = self.placeFor(k);
      var place = Object.assign({}, self.state.place);
      place[k] = Object.assign({}, cur, { r: parseInt(e.target.value, 10) });
      self.set({ place: place });
    });

    on(el.resetRot, 'click', function () {
      var k = self.placeKey();
      var cur = self.placeFor(k);
      var place = Object.assign({}, self.state.place);
      var def = (self.cfg.viewPlacements || {})[String(k).toUpperCase()] || {};
      place[k] = Object.assign({}, cur, { r: def.r || 0 });
      self.set({ place: place });
    });

    // Straight to upside down and back, without dragging the slider the whole way.
    on(el.flipRot, 'click', function () {
      var k = self.placeKey();
      var cur = self.placeFor(k);
      var r = Math.round(cur.r);
      var place = Object.assign({}, self.state.place);
      place[k] = Object.assign({}, cur, { r: Math.abs(r) >= 90 ? 0 : 180 });
      self.set({ place: place });
    });

    /* A button, not a checkbox (Kelly, 2026-08-22): the result is permanent,
       so there is nothing to untick and a control that cannot be reversed
       should not look like one that can.

       Acts on the artwork the customer is LOOKING at — ownerOfView, the same
       target REMOVE LOGO beside it uses. It used to read activeLoc(), so
       standing on the back view and pressing it attached the cutout to the
       front location's file and appeared to do nothing. */
    /* Multiplicative steps, because a fixed +25% crawls at 4x and leaps at 1x.
       Zoom is deliberately NOT wired to pinch: the drag handler binds a window
       touchmove with preventDefault and reads touches[0] only, so a two-finger
       gesture starting on the grip would register as a one-finger drag. */
    var stepZoom = function (factor) {
      var z = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, self.state.zoom * factor));
      self.set({ zoom: Math.round(z * 100) / 100 });
    };
    on(el.zoomIn, 'click', function () { stepZoom(1.5); });
    on(el.zoomOut, 'click', function () { stepZoom(1 / 1.5); });

    on(el.bgRemove, 'click', function () {
      var sel = self.selectedObject();
      var loc = sel ? sel.loc : self.activeLoc();
      // The object's OWN file — with several images on a location, the first
      // one is not necessarily the one the customer is looking at.
      var f = (sel && sel.file) || self.fileForArt(loc);
      // No endpoint, no file, or this file is already cut — a second call
      // spends vendor credit for an answer we hold.
      if (!self.cfg.bgRemoveEndpoint || !f || !f.file || f.cut) return;

      self.set({ bgBusy: true, bgError: '' });
      self.requestCutout(f).then(function (err) {
        // There is no fallback left, so a failure must SAY so and leave the
        // button pressable. Doing nothing quietly reads as a dead control.
        self.set({ bgBusy: false, bgError: err || '' });
      });
    });

    on(el.toggleLogo, 'click', function () {
      var k = self.placeKey();
      if (!k) return;
      var own = self.selectedObject();
      var f = own ? (own.file || (own.kind === 'art' ? self.fileForArt(own.loc) : null)) : null;

      /* Taking artwork off the cap now DELETES it, so the ARTWORK list agrees
         with the preview (Kelly, 2026-08-18). It used to only hide it, which
         left a file listed as attached that the customer believed they had
         removed — and that file still travelled with the quote.

         The hide/restore toggle survives for imprint TEXT and for artwork with
         no file behind it, where there is nothing to delete.

         Reads the SELECTED OBJECT's kind and its own file, not the location's
         tab and first file. With several images on one location, the tab said
         nothing about which of them the button was pointed at, and it would
         have deleted the first one whatever the customer had selected. */
      if (own && own.kind === 'art' && f) {
        self.removeFileFrom(own.idx, f);
        // Drop any stale hidden flag with it, or the next upload onto this
        // view would arrive invisible.
        var cleared = Object.assign({}, self.state.hidden);
        delete cleared[k];
        self.set({ hidden: cleared });
        return;
      }

      var hidden = Object.assign({}, self.state.hidden);
      hidden[k] = !hidden[k];
      self.set({ hidden: hidden });
    });

    on(el.resetPlace, 'click', function () {
      var place = Object.assign({}, self.state.place);
      delete place[self.placeKey()];
      self.set({ place: place });
    });

    // `error: ''` on open, or a failure from the last attempt is sitting there
    // waiting the next time the modal is raised.
    on(el.saveMockup, 'click', function () { self.set({ saveOpen: true, saveSent: false, saveMode: 'mockup', error: '' }); });
    on(el.closeSave, 'click', function () { self.set({ saveOpen: false }); });
    on(el.closeSave2, 'click', function () { self.set({ saveOpen: false }); });
    on(el.closeSave3, 'click', function () { self.set({ saveOpen: false }); });
    /* A quote is an order we intend to make, so it answers to the same
       minimums the cart does. Checked HERE as well as on submit so the
       customer is told what is short beside the quantities they typed, rather
       than after being asked for an email they cannot use yet.

       SAVE MOCKUP is deliberately not gated: a mockup is a picture, and asking
       someone to meet a minimum before they can look at their own artwork is
       the toll gate this whole flow exists to remove. */
    /* A mockup REQUEST is not a quote and not a download: it asks staff to
       build something. It reuses this modal because the customer is doing the
       same thing — handing over an email so we can come back to them — but it
       collects a name and optional artwork, and it answers to no minimums,
       because the whole point is that the customer has not configured an
       order. */
    on(el.requestMockup, 'click', function () {
      self.set({ saveOpen: true, saveSent: false, saveMode: 'request', error: '' });
    });

    on(el.saveQuote, 'click', function () {
      var short = self.quantityBlocker(self.pricing(), self.orderLines());
      if (short) { self.set({ error: short }); return; }
      self.set({ saveOpen: true, saveSent: false, saveMode: 'quote', error: '' });
    });
    on(el.emailValue, 'input', function (e) { self.state.email = e.target.value; });
    on(el.nameValue, 'input', function (e) { self.state.reqName = e.target.value; });
    on(el.reqNotesValue, 'input', function (e) { self.state.reqNotes = e.target.value; });
    // Names the chosen files; the input itself shows only a count.
    on(el.reqArtValue, 'change', function () { self.renderRequestFiles(); });
    on(el.sendMock, 'click', function () { self.sendMockup(); });

    on(el.modal, 'click', function (e) { if (e.target === el.modal) self.set({ saveOpen: false }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.state.saveOpen) self.set({ saveOpen: false });
    });

    on(el.tabUpload, 'click', function () { self.patchLoc(self.activeIndex(), { tab: 'upload' }); });
    // Opening the TEXT tab is the customer asking for text on the product.
    // The tab is now which EDITOR is showing, not which one thing is drawn.
    on(el.tabText, 'click', function () {
      self.patchLoc(self.activeIndex(), { tab: 'text', textOn: true });
    });

    on(el.fileInput, 'change', function (e) { self.intake(e.target.files); e.target.value = ''; });
    on(el.drop, 'dragover', function (e) {
      e.preventDefault();
      if (!self.state.dropActive) self.set({ dropActive: true });
    });
    on(el.drop, 'dragleave', function () { self.set({ dropActive: false }); });
    on(el.drop, 'drop', function (e) {
      e.preventDefault();
      self.intake(e.dataTransfer && e.dataTransfer.files);
    });

    /* Typed case is kept (Kelly, 2026-08-19). This used to force uppercase on
       every keystroke, rewriting the field as the customer typed — which made
       lowercase impossible and script fonts pointless, since a script face
       exists to show lowercase letterforms.

       Case now travels to the work order exactly as entered, so it is also
       what the digitiser sees. */
    on(el.textValue, 'input', function (e) {
      self.patchLoc(self.activeIndex(), { text: e.target.value, textOn: true });
    });
    on(el.fontSelect, 'change', function (e) { self.patchLoc(self.activeIndex(), { font: e.target.value }); });
    on(el.threadSelect, 'change', function (e) { self.patchLoc(self.activeIndex(), { thread: e.target.value }); });
    // Filtering is presentation only — it must not touch the configuration.
    on(el.threadFilter, 'input', function () { self.renderThreads(); });

    on(el.curveRange, 'input', function (e) {
      self.patchLoc(self.activeIndex(), { curve: parseInt(e.target.value, 10) || 0 });
    });
    on(el.resetCurve, 'click', function () { self.patchLoc(self.activeIndex(), { curve: 0 }); });

    on(el.notesValue, 'input', function (e) { self.state.notes = e.target.value; self.renderNotesStatus(); });
    on(el.refNone, 'click', function () { self.set({ refMode: 'none' }); });
    on(el.refOrder, 'click', function () { self.set({ refMode: 'order' }); });
    on(el.refMock, 'click', function () { self.set({ refMode: 'mock' }); });
    on(el.refOrderValue, 'input', function (e) { self.state.refOrder = e.target.value; self.renderNotesStatus(); });
    on(el.refMockValue, 'input', function (e) { self.state.refMock = e.target.value; self.renderNotesStatus(); });

    /* The stepper, the slider and BUMP TO all wrote ONE number. There is no
       longer one number to write: quantities live per colourway and per size,
       and picking which cell a bump lands in would be inventing an order the
       customer did not place.

       2026-09-06: the BUMP TO button is GONE from the markup too, not just
       unbound. Losing its handler left a button that looked clickable and did
       nothing, which reads as broken on exactly the sized products it could
       not serve. Kelly's call. The nudge TEXT stays — what the next tier saves
       is information worth showing; only the offer to get there on the
       customer's behalf is withdrawn. Do not re-add the button without
       solving which colourway/size cell the quantity lands in. */

    /* Enlarge the decoration example. The thumbnail is ~110px and the file is
       ~885px wide, so the etching and grain a customer is judging are simply
       too small to see. Opens the SAME file re-requested at a larger width —
       Shopify resizes on the CDN, so this costs one image, not a second asset.

       Bound once here rather than per render: the <img> is static markup whose
       src is swapped, so it survives every re-render and never needs rebinding. */
    on(el.detailImg, 'click', function () { self.openLightbox(el.detailImg.getAttribute('src')); });
    on(el.detailImg, 'keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.openLightbox(el.detailImg.getAttribute('src')); }
    });
    on(el.lightbox, 'click', function () { self.closeLightbox(); });
    on(el.lightboxClose, 'click', function (e) { e.stopPropagation(); self.closeLightbox(); });
    /* Clicking the picture itself must NOT close it — only the backdrop does,
       which is what the zoom-out cursor on the backdrop promises. */
    on(el.lightboxImg, 'click', function (e) { e.stopPropagation(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.lightbox && !el.lightbox.hidden) self.closeLightbox();
    });

    on(el.addToCart, 'click', function (e) { e.preventDefault(); self.addToCart(); });
  };

  /* ---------- render ------------------------------------------------------ */

  // If a settings change makes a saved decoration illegal for its location
  // (e.g. patches removed from Back), fall back to the first allowed one rather
  // than quoting a combination the shop can't produce.
  /* Locations are held in the order the `locations` setting lists them —
     front, left, right, back — not the order the customer happened to add
     them in. Index 0 is what the PRIMARY badge and the setup charge both read,
     so adding a side before the front used to make the side primary and put
     the $30 on it while the front took the $10. The order total was the same,
     but the badge was wrong and the attribution would matter the moment a
     location carries its own one-time charge.

     The active selection is preserved by identity across the sort, or the
     customer's cursor would jump to whichever location happened to land where
     they were working. */
  P.sortLocations = function () {
    var order = (this.cfg.locations || []).map(function (m) { return m.id; });
    var rank = function (id) {
      var i = order.indexOf(id);
      return i === -1 ? 999 : i;
    };
    var locs = this.state.locations;
    if (locs.length < 2) return;

    var activeObj = locs[this.activeIndex()] || null;
    var sorted = locs.slice().sort(function (a, b) { return rank(a.loc) - rank(b.loc); });

    var same = sorted.every(function (l, i) { return l === locs[i]; });
    if (same) return;

    this.state.locations = sorted;
    if (activeObj) {
      var at = sorted.indexOf(activeObj);
      if (at > -1) this.state.active = at;
    }
  };

  P.normalizeLocations = function () {
    var self = this;
    this.sortLocations();
    this.state.locations.forEach(function (l) {
      // Preselect the standard in every option group this location offers.
      self.applyAddonDefaults(l);
      var allowed = self.decosForLoc(l.loc);
      var ok = allowed.some(function (d) { return d.id === l.deco; });
      if (!ok) {
        l.deco = (allowed[0] || {}).id || l.deco;
        l.subtype = self.defaultSubtype(l.deco);
        // A colour belongs to the sub-type that offered it. Carrying it across
        // a decoration change would put a stale colour on a patch that never
        // offered it, and it would ride all the way to the work order.
        l.patchColor = '';
        l.addons = [];
        l.puff = false;
      }
    });
  };

  P.render = function () {
    this.normalizeLocations();
    /* Snap the quantity up to whatever the chosen decorations demand. pricing()
       clamps its own copy, but without writing it back the input would keep
       showing 12 while the customer is being quoted 50 — the number on screen
       has to be the number being priced. Assigned directly rather than through
       set(), which would recurse into render. */
    /* Nothing is raised to the minimum any more. Quantities are per colourway
       and per size, so silently rewriting one would move pieces into a cell
       nobody asked for — the reasoning that already exempted size mode, now
       true everywhere. The shortfall is reported instead. */
    this.renderStage();
    this.renderPlacer();
    this.renderViews();
    this.renderColors();
    this.renderLocations();
    this.renderDecorations();
    this.renderArtwork();
    this.renderNotesStatus();
    this.renderQty();
    this.renderPrice();
    this.renderModal();
    this.renderError();
  };

  P.show = function (node, on) { if (node) node.hidden = !on; };

  /* Re-request a Shopify CDN image at a bigger width. The thumbnail asks for
     `width=480`; the same file has more. Only the width param is touched, so
     any other transform on the URL survives, and a non-Shopify URL is returned
     untouched rather than mangled. */
  P.bigImage = function (src) {
    if (!src) return '';
    if (src.indexOf('width=') === -1) return src;
    return src.replace(/([?&]width=)\d+/, '$1' + 1600);
  };

  P.openLightbox = function (src) {
    var el = this.el;
    if (!el.lightbox || !el.lightboxImg || !src) return;
    el.lightboxImg.setAttribute('src', this.bigImage(src));
    this.show(el.lightbox, true);
    /* Focus the close button so Escape and Tab have somewhere sensible to be,
       and the page behind cannot be scrolled away underneath the overlay. */
    document.documentElement.style.overflow = 'hidden';
    if (el.lightboxClose) el.lightboxClose.focus();
  };

  P.closeLightbox = function () {
    var el = this.el;
    if (!el.lightbox) return;
    this.show(el.lightbox, false);
    document.documentElement.style.overflow = '';
    if (el.detailImg) el.detailImg.focus();
  };

  P.text = function (node, s) { if (node && node.textContent !== s) node.textContent = s; };

  // Rebuild the slide track whenever the set of views changes — the count
  // varies per colorway, so the geometry can't be hardcoded.
  P.buildSlides = function (views) {
    var el = this.el;
    if (!el.track || !el.slideTpl) return;

    /* The signature has to include the OBJECTS, not just the views. It read
       views alone, so adding a second logo to a photo left it unchanged, the
       track was never rebuilt, and the new artwork silently did not appear —
       a bug that looks like broken rendering and is not. */
    var self = this;
    var objsPerView = views.map(function (v) { return self.objectsForView(v); });
    var sig = views.map(function (v, i) {
      return v.id + '|' + (v.logo || '') + '>' +
        objsPerView[i].map(function (o) { return o.key; }).join('+');
    }).join(',');
    if (el.track.dataset.sig === sig) return;
    el.track.dataset.sig = sig;
    el.track.innerHTML = '';

    var n = Math.max(1, views.length);
    el.track.style.width = (n * 100) + '%';

    views.forEach(function (v, i) {
      var slide = el.slideTpl.content.firstElementChild.cloneNode(true);
      slide.style.flex = '0 0 ' + (100 / n) + '%';
      slide.style.width = (100 / n) + '%';

      // One wrap per drawable object. Keys are unique per object, so the
      // singular querySelector in renderStage and startDrag still resolves —
      // but only because the key is stamped here, at build time.
      objsPerView[i].forEach(function (o) {
        var logo = el.logoTpl.content.firstElementChild.cloneNode(true);
        logo.setAttribute('data-cc-logo', o.key);
        var grip = logo.querySelector('[data-cc="logoGrip"]');
        grip.setAttribute('data-cc-drag', o.key);
        self.bindGrip(grip, o.key);
        slide.appendChild(logo);
      });
      el.track.appendChild(slide);
    });
  };

  P.renderStage = function () {
    var el = this.el;
    var s = this.state;
    var locs = s.locations;
    var views = this.viewsForColor();
    var col = this.currentColor();

    this.buildSlides(views);

    var n = Math.max(1, views.length);
    if (s.view > views.length - 1) s.view = 0;
    if (el.track) el.track.style.transform = 'translateX(' + (-(100 / n) * s.view) + '%)';

    /* Zoom towards the ARTWORK, not the centre of the photo. The stage is
       overflow:hidden with no panning, so a centre-origin zoom would push a
       left-chest logo out of sight at exactly the moment the customer zoomed
       in to look at it. Origin follows the placement, so there is nothing to
       pan back to. */
    if (el.zoom) {
      var zk = this.placeKey();
      var zp = zk ? this.placeFor(zk) : null;
      el.zoom.style.transformOrigin = zp ? (zp.x + '% ' + zp.y + '%') : '50% 50%';
      el.zoom.style.transform = 'scale(' + s.zoom + ')';
    }
    if (el.zoomLabel) this.text(el.zoomLabel, Math.round(s.zoom * 100) + '%');
    if (el.zoomOut) el.zoomOut.disabled = s.zoom <= ZOOM_MIN;
    if (el.zoomIn) el.zoomIn.disabled = s.zoom >= ZOOM_MAX;

    // slide images follow the selected colourway
    var slides = this.qa('slideImg');
    for (var i = 0; i < slides.length; i++) {
      var v = views[i] || {};
      var img = slides[i];
      if (!v.src) continue;
      if (img.getAttribute('src') !== v.src) img.setAttribute('src', v.src);
      img.setAttribute('loading', i === 0 ? 'eager' : 'lazy');
      img.alt = (this.cfg.productTitle || '') + ' — ' + (v.label || '') + ' — ' + (col.name || '');
    }

    /* Each view draws the decoration belonging to it, so a left-side
       embroidery shows on the LEFT shot rather than nowhere. The 3/4 hero
       mirrors the front. A view with no configured location renders a bare
       cap, which is the truthful thing to show. */
    var self = this;
    var sel = this.selectedObject();
    this.viewsForColor().forEach(function (v) {
      /* EVERY object on this view, not just the first location that names it.
         The old code took `locForView(v)`, which returns the first match — so
         a second logo on the same photo was never drawn, and the polo's Right
         Chest rendered as the Left Chest. */
      self.objectsForView(v).forEach(function (o) {
      var key = o.key;
      var wrap = self.root.querySelector('[data-cc-logo="' + key + '"]');
      if (!wrap) return;

      var loc = o.loc;
      /* Each object draws itself. The tab used to be the source of truth —
         one location showed its artwork OR its text — which is why a logo and
         a name could not appear together. `shown` and `textOn` are explicit
         now, so the tab only decides which editor is on screen. */
      var art = o.kind !== 'art' ? '' : (o.file ? self.srcForFile(o.file) : self.artSrcFor(loc));
      var hasText = o.kind === 'text' && !!loc.text;
      var on = (!!art || hasText) && !s.hidden[key];

      self.show(wrap, on);
      if (!on) return;

      var p = self.placeFor(key);
      wrap.style.left = p.x + '%';
      wrap.style.top = p.y + '%';
      wrap.style.width = p.w + '%';
      wrap.style.height = (p.w * p.ratio).toFixed(1) + '%';
      wrap.style.transform = 'translate(-50%, -50%) rotate(' + p.r + 'deg)';
      /* The selected object is outlined even when idle. With several things
         on one photo the customer has to be able to see which one the size and
         rotate controls are about to move. */
      /* Outlined only while the customer is actually working on the stage —
         the same gate the grips use. A dashed box that never leaves sits on
         the one image the customer is asked to approve, and starts reading as
         part of the design rather than as a control. */
      var isSel = !!(sel && sel.key === key);
      var active = s.dragging || (s.hoverStage && !s.saveOpen);
      wrap.style.outline = (isSel && active) ? '1px dashed ' + self.cfg.accent : 'none';

      var artNode = wrap.querySelector('[data-cc="logoArt"]');
      var textNode = wrap.querySelector('[data-cc="logoText"]');
      self.show(artNode, !!art);
      self.show(textNode, !art && hasText);
      if (art) artNode.style.backgroundImage = 'url("' + art + '")';
      if (!art && hasText) {
        // Rendered as SVG rather than a styled string so a curved imprint
        // scales with the box and matches the exported PNG exactly.
        var svg = self.textSvg(loc.text, loc.curve, self.threadHex(loc.thread), self.faceFor(loc.font));
        if (textNode.getAttribute('data-svg') !== svg) {
          textNode.innerHTML = svg;
          textNode.setAttribute('data-svg', svg);
        }
      }

      var grip = wrap.querySelector('[data-cc="logoGrip"]');
      if (grip) {
        // Counter-scale: the grip is a fixed-size chip, so without this it
        // grows with the zoom until it covers the artwork it is meant to move.
        grip.style.transform = 'translateX(-50%) scale(' + (1 / s.zoom) + ')';
        var gripOn = active;
        // Unselected grips stay visible but dimmer, so the customer can see
        // there IS something else to grab.
        grip.style.opacity = s.dragging
          ? (isSel ? 1 : 0.35)
          : (gripOn ? (isSel ? 0.85 : 0.45) : 0);
        grip.style.pointerEvents = gripOn ? 'auto' : 'none';
      }
      });
    });

    var colorName = (col.name || '');
    this.text(el.caption, locs.length === 0
      ? 'Blank — no decoration · ' + colorName
      : this.decoOf(this.activeLoc().deco).name + ' · ' + colorName);

    /* Names the SELECTED object, not the first location. With several things
       on one photo, a label describing something else is worse than none —
       the customer would size the wrong item and believe the control was
       broken, which is exactly what happened. */
    var selLabel = '';
    if (sel) {
      selLabel = this.locFullName(sel.loc).toUpperCase();
      if (sel.kind === 'text') selLabel += ' · TEXT';
      else if (sel.file) selLabel += ' · ' + String(sel.file.name).toUpperCase();
    }
    this.text(el.placementLabel, locs.length === 0
      ? 'BLANK — NO DECORATION'
      : (selLabel || this.locFullName(locs[0]).toUpperCase()) +
        ' · ' + locs.length + (locs.length === 1 ? ' LOCATION' : ' LOCATIONS'));
  };

  P.renderPlacer = function () {
    var el = this.el, s = this.state;
    var key = this.placeKey();
    var on = s.locations.length > 0 && !!key;
    this.show(el.placer, on);
    if (!on) return;

    var p = this.placeFor(key);

    if (el.sizeRange) el.sizeRange.value = Math.round(p.w);
    this.text(el.sizeLabel, Math.round(p.w) + '% W');
    if (el.rotRange) el.rotRange.value = Math.round(p.r);
    this.text(el.rotLabel, (p.r > 0 ? '+' : '') + Math.round(p.r) + '°');
    /* The button carries its own state, because a removal is a round trip to
       a vendor and silence for several seconds reads as a dead control. It is
       hidden outright when it could not do anything — no endpoint configured,
       or no uploaded file on this view — since a permanently inert button is
       worse than no button. */
    if (el.bgRemove) {
      var bgOwn = this.selectedObject();
      var bgFile = (bgOwn && bgOwn.file) ||
        this.fileForArt(bgOwn ? bgOwn.loc : this.activeLoc());
      var bgDone = !!(bgFile && bgFile.cut);
      this.show(el.bgRemove, !!this.cfg.bgRemoveEndpoint && !!(bgFile && bgFile.file));
      el.bgRemove.disabled = !!s.bgBusy || bgDone;
      el.bgRemove.textContent = s.bgBusy
        ? 'REMOVING…'
        : (bgDone ? 'BACKGROUND REMOVED' : 'REMOVE BACKGROUND');
    }
    // The status line is now errors only — "removed" and "removing" live on
    // the button itself, and saying either twice invites them to disagree.
    this.text(el.bgStatus, s.bgError ? ' — ' + s.bgError : '');
    if (el.bgStatus) el.bgStatus.className = 'cc-check__status' + (s.bgError ? ' cc-check__status--bad' : '');

    // Curve rides with size and rotate, but only means anything for an imprint
    // set in text: there is nothing to curve about an uploaded file.
    var act = this.activeLoc();
    // Curve belongs to the text, which can now be present while the upload
    // editor is the one on screen.
    var isText = !!(act && act.textOn && act.text);
    this.show(el.curveWrap, isText);
    if (isText) {
      var curve = act.curve || 0;
      if (el.curveRange && document.activeElement !== el.curveRange) el.curveRange.value = curve;
      this.text(el.curveLabel, curve === 0
        ? 'STRAIGHT'
        : (curve > 0 ? 'ARC UP ' : 'ARC DOWN ') + Math.abs(curve) + '%');
    }

    if (el.toggleLogo) {
      /* RESTORE only ever applies to the hide/restore path — text, or artwork
         with no file behind it. When the click deletes a file the label must
         not promise a restore that isn't coming. */
      var own = this.selectedObject();
      var deletes = !!(own && own.kind === 'art' &&
        (own.file || this.fileForArt(own.loc)));
      el.toggleLogo.textContent = (!deletes && s.hidden[key]) ? 'RESTORE LOGO' : 'REMOVE LOGO';
      el.toggleLogo.classList.toggle('cc-pbtn--danger', deletes || !s.hidden[key]);
    }
  };

  P.renderViews = function () {
    var self = this;
    var wrap = this.el.views;
    if (!wrap) return;
    var views = this.viewsForColor();

    if (wrap.children.length !== views.length) {
      wrap.innerHTML = '';
      views.forEach(function (v, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-view';
        b.innerHTML = '<span class="cc-view__thumb"></span><span class="cc-view__label"></span>';
        // Zoom resets with the view: staying at 4x would switch the
        // customer into a blank crop of a photo they have not seen yet.
        b.addEventListener('click', function () { self.set({ view: i, zoom: 1 }); });
        wrap.appendChild(b);
      });
    }

    Array.prototype.forEach.call(wrap.children, function (b, i) {
      var v = views[i] || {};
      b.setAttribute('aria-pressed', i === self.state.view ? 'true' : 'false');
      b.querySelector('.cc-view__thumb').style.backgroundImage = v.thumb ? 'url("' + v.thumb + '")' : 'none';
      b.querySelector('.cc-view__label').textContent = v.label || '';
    });
  };

  P.renderColors = function () {
    var self = this;
    var wrap = this.el.swatches;
    if (!wrap) return;
    var colors = this.cfg.colors || [];

    if (wrap.children.length !== colors.length) {
      wrap.innerHTML = '';
      colors.forEach(function (col, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-swatch';
        b.title = col.name + (col.available ? '' : ' — out of stock');
        b.setAttribute('aria-label', col.name + (col.available ? '' : ', out of stock'));
        b.style.backgroundColor = col.hex || '#ccc';
        if (col.swatchImage) b.style.backgroundImage = 'url("' + col.swatchImage + '")';
        if (!col.available) b.classList.add('cc-swatch--out');
        b.setAttribute('data-cc-swatch', String(i));
        // Every colorway is selectable, sold out or not: a customer needs to see
        // it on the cap and be able to send it as a quote. Ordering is what gets
        // blocked, in renderTotals.
        /* Browsing, not buying. A swatch used to add the colourway it showed,
           so looking at Split Charcoal/Neon Green put it on the order. It now
           moves the PREVIEW only; the ADD button below the palette is the one
           control that changes what is being bought. */
        b.addEventListener('click', function () { self.previewColor(i); });
        wrap.appendChild(b);
      });
    }

    /* aria-pressed is the PREVIEW, because the palette reads as a single
       selection — exactly one swatch is on the cap. Being on the order is a
       second, independent state and markSwatches carries it as a class and in
       the label. Both used to be written here and there, and picked won. */
    Array.prototype.forEach.call(wrap.children, function (b, i) {
      b.setAttribute('aria-pressed', i === self.state.color ? 'true' : 'false');
    });

    this.renderAddColor();

    // Name plus the variant's SKU, so a customer reading a spec sheet or a rep
    // on the phone can confirm they are looking at the same blank.
    var cur = this.currentColor();
    if (this.el.colorName) {
      this.el.colorName.innerHTML = esc(cur.name || '') +
        (cur.sku ? ' <span class="cc-sku">' + esc(cur.sku) + '</span>' : '');
    }
    if (this.el.variantInput) this.el.variantInput.value = cur.variantId || '';
    this.renderStock();
  };

  /* The one control that puts a colourway ON the order, and the only place the
     difference between looking and buying is spelled out in words — a ring
     around a swatch is not enough to carry it on its own.

     It never removes. Removing stays on the row, because a control that both
     adds and removes lets a second click wipe a typed run with no hint that it
     is about to. So this goes inert once the colourway is on the order. */
  P.renderAddColor = function () {
    var btn = this.el.addColor;
    if (!btn) return;
    var on = this.isPicked(this.state.color);
    var name = this.currentColor().name || '';
    this.text(btn, (on ? (this.cfg.addedColorLabel || 'ON YOUR ORDER')
                       : (this.cfg.addColorLabel || 'ADD TO ORDER')));
    btn.disabled = on;
    btn.classList.toggle('cc-addcolor__btn--on', on);
    btn.setAttribute('aria-label', on
      ? name + ' is on your order'
      : 'Add ' + name + ' to your order');
  };

  /* The badge carries the selected colorway's stock, because that is the number
     a buyer ordering 288 of one color needs. `stock` is -1 when the colorway is
     not inventory-tracked, in which case the badge stays a plain label rather
     than claiming zero. */
  P.renderStock = function () {
    var chip = this.el.stockChip;
    if (!chip) return;
    var col = this.currentColor();
    var label = this.cfg.stockLabel || 'IN STOCK';
    var qty = typeof col.stock === 'number' ? col.stock : -1;

    if (!col.available || qty === 0) {
      chip.className = 'cc-chip cc-chip--out';
      this.text(chip, this.cfg.outOfStockLabel || 'OUT OF STOCK');
      return;
    }

    chip.className = 'cc-chip';
    this.text(chip, (this.cfg.showStockQty && qty > 0)
      ? label + ' · ' + qty.toLocaleString('en-US')
      : label);
  };

  P.renderLocations = function () {
    var self = this;
    var s = this.state;
    var locs = s.locations;
    var ai = this.activeIndex();
    var wrap = this.el.locations;
    var money = this.money;

    if (wrap) {
      wrap.innerHTML = '';
      locs.forEach(function (l, i) {
        var row = document.createElement('div');
        row.className = 'cc-loc';
        row.setAttribute('data-active', i === ai ? 'true' : 'false');
        row.innerHTML =
          '<button type="button" class="cc-loc__main">' +
            '<span class="cc-loc__name">' + esc(self.locFullName(l)) +
              '<span class="cc-loc__tag' + (i === 0 ? ' cc-loc__tag--primary' : '') + '">' + (i === 0 ? 'PRIMARY' : 'ADD-ON') + '</span>' +
            '</span>' +
            '<span class="cc-loc__sub">' + esc(self.decoLabel(l)) + ' · ' + esc(self.artNote(l)) + '</span>' +
          '</button>' +
          '<span class="cc-loc__price">+' + esc(money(Math.round(self.lineAdd(l) * 100))) + '<small> /' + esc(self.unit()) + '</small></span>' +
          '<button type="button" class="cc-loc__x" title="Remove location" aria-label="Remove ' + esc(self.locFullName(l)) + '">×</button>';

        row.querySelector('.cc-loc__main').addEventListener('click', function () {
          self.set({ active: i, view: self.viewIndexFor(self.locMeta(l.loc).view) });
        });
        row.querySelector('.cc-loc__x').addEventListener('click', function () {
          self.set({ locations: locs.filter(function (x, n) { return n !== i; }), active: 0 });
        });
        wrap.appendChild(row);
      });
    }

    // add-location buttons
    var addWrap = this.el.addable;
    if (addWrap) {
      addWrap.innerHTML = '';
      /* Not already on the order, and able to take the order's METHOD — one
         method per order, so offering a print-only Full Front while the order
         is embroidered would only produce a button that drops itself. */
      var orderDeco = (locs[0] || {}).deco;
      this.cfg.locations.filter(function (m) {
        if (locs.some(function (l) { return l.loc === m.id; })) return false;
        /* Mixing allowed: every free location is offered and picks its own
           method (blankLoc joins the order's where it can, else falls back to
           the location's first allowed one). */
        if (self.cfg.allowMixedMethods) return true;
        if (!orderDeco) return true;
        return self.decosForLoc(m.id).some(function (d) { return d.id === orderDeco; });
      }).forEach(function (m) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-add';
        b.textContent = '+ ' + m.name;
        b.addEventListener('click', function () {
          var fresh = self.blankLoc(m.id);
          /* Adding a location can EVICT others — a Full Front print covers the
             whole front, so a Left Chest already on the order cannot survive
             it. Silently, because the button the customer just pressed IS the
             instruction, and an "are you sure" on every front swap would be
             worse than the eviction it guards. The evicted rows are visibly
             gone in the list below. */
          var kept = self.dropConflicts(locs, m.id);
          self.set({ locations: kept.concat([fresh]), active: kept.length, view: self.viewIndexFor(m.view) });
        });
        addWrap.appendChild(b);
      });
    }

    var addSum = this.addSum();
    this.text(this.el.locSummary, locs.length === 0
      ? 'BLANK · NO DECORATION'
      : locs.length + (locs.length === 1 ? ' LOCATION · +' : ' LOCATIONS · +') + money(Math.round(addSum * 100)) + '/' + this.unit());
  };

  P.renderDecorations = function () {
    var self = this;
    var s = this.state;
    var act = this.activeLoc();
    var ai = this.activeIndex();
    var hasLocs = s.locations.length > 0;

    this.show(this.el.decoBlock, hasLocs);
    this.show(this.el.panelRow, hasLocs && act.loc === 'front');

    // front-panel segmented control
    var pWrap = this.el.panels;
    if (pWrap && pWrap.children.length === 0) {
      this.cfg.panels.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-seg__btn';
        b.textContent = p.name;
        b.addEventListener('click', function () { self.patchLoc(self.activeIndex(), { panel: p.id }); });
        pWrap.appendChild(b);
      });
    }
    if (pWrap) {
      Array.prototype.forEach.call(pWrap.children, function (b, i) {
        b.setAttribute('aria-pressed', (act.panel || 'center') === self.cfg.panels[i].id ? 'true' : 'false');
      });
    }

    /* The active decoration's Variant Notes — the imprint limit — shown under
       the panel picker and mirrored into the stage's bottom-left caption.
       Both read the SAME string, so the limit on screen always belongs to the
       placement actually selected. It used to be a fixed setting reading
       5" W x 2.25" H while the customer sat on Left Panel, whose real limit is
       2.75". The setting survives only as the nothing-chosen-yet fallback.

       Printed verbatim: it is Kelly's copy, and any reformatting here would
       silently mangle a note that isn't a size. */
    /* Imprint Size (custom.imprint_size) is the dedicated field and wins.
       Variant Notes stays as the fallback because it is not only a size — it
       also carries things like "VEGAN | LASER ETCHED" — so a decoration with
       no Imprint Size set keeps saying whatever it says today rather than
       going blank. Populate imprint_size and it takes over, per decoration,
       with no deploy. */
    var placeRec = hasLocs ? this.resolve(act) : null;
    var placeNote = placeRec ? (placeRec.imprintSize || placeRec.note || '') : '';
    this.text(this.el.panelNote, placeNote);
    this.show(this.el.panelNote, !!placeNote);
    this.text(this.el.imprintNote, hasLocs ? placeNote : (this.cfg.imprintNote || ''));

    if (!hasLocs) return;

    this.text(this.el.activeLocName, this.locFullName(act).toUpperCase());

    // The offered set depends on the active location, so the buttons are
    // rebuilt whenever that set changes.
    var decos = this.decosForLoc(act.loc);
    /* "CHOOSE" only when there is something to choose BETWEEN. An
       embroidery-only garment still shows this block — it carries the price
       and the minimum — but instructing someone to choose from one locked
       option reads like a step they have missed. */
    if (this.el.decoHead) {
      this.text(this.el.decoHead, decos.length > 1 ? 'CHOOSE DECORATION TYPE' : 'DECORATION TYPE');
    }
    var dWrap = this.el.decorations;
    var dsig = decos.map(function (d) { return d.id; }).join(',');
    if (dWrap && dWrap.dataset.sig !== dsig) {
      dWrap.dataset.sig = dsig;
      dWrap.innerHTML = '';
      decos.forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-deco';
        b.innerHTML =
          '<span class="cc-deco__dot"></span>' +
          '<span class="cc-deco__text">' +
            '<span class="cc-deco__name">' + esc(d.name) +
              '<span class="cc-deco__meta"></span>' +
            '</span>' +
            '<span class="cc-deco__note">' + esc(d.note) + '</span>' +
          '</span>' +
          '<span class="cc-deco__price"></span>';
        b.addEventListener('click', function () {
          self.setDecoration(d.id);
        });
        dWrap.appendChild(b);
      });
    }
    if (dWrap) {
      // Prices depend on the active location, so they are recomputed every
      // render rather than baked in when the buttons are built.
      // Same as the sub-choice list: the options block can be injected here
      // too, so index off the buttons, not off every child node.
      Array.prototype.forEach.call(dWrap.querySelectorAll('.cc-deco'), function (b, i) {
        var d = decos[i];
        if (!d) return;
        b.setAttribute('aria-pressed', d.id === act.deco ? 'true' : 'false');
        var probe = Object.assign({}, act, { deco: d.id, subtype: self.defaultSubtype(d.id) });
        var r = self.resolve(probe);
        var label;
        if (r.unmapped) {
          label = '—';
        } else if (self.hasSubtypes(d.id)) {
          label = 'from +' + self.money(Math.round(self.cheapestSubtype(d.id) * 100));
        } else {
          label = '+' + self.money(Math.round(r.price * 100));
        }
        b.querySelector('.cc-deco__price').textContent = label;

        /* Leadtime and minimum come from the variant this decoration resolves
           to AT THIS LOCATION, so they are set per render alongside the price
           rather than baked in. Skipped for decorations with sub-choices: the
           facts belong to the chosen sub-choice, and showing the default's
           here would contradict the row directly below it. */
        var meta = b.querySelector('.cc-deco__meta');
        if (meta) {
          var mText = (r.unmapped || self.hasSubtypes(d.id)) ? '' : self.metaFor(r);
          meta.textContent = mText ? ' - ' + mText : '';
        }
      });
    }

    this.renderSubtypes(act);
    this.renderDetail(act);
    this.renderPatchColors(act);
    this.renderAddons(act);
    /* Placement runs HERE, not at the end of renderAddons, because that bails
       early for a patch with no add-ons — leaving both docked blocks parked
       under whichever patch was selected last. Etched Faux has colours and no
       options, so its swatches surfaced three rows above the selection, under
       Woven Patch. Every render repositions them now, add-ons or not. */
    this.placeDockedBlocks(act);

    var showPuff = hasLocs && act.loc === 'front' && act.deco === this.cfg.puffDecoId && this.cfg.puffAdd > 0;
    this.show(this.el.puff, showPuff);
    if (this.el.puffCheck) this.el.puffCheck.checked = !!act.puff;
    this.text(this.el.puffPrice, '+' + this.money(Math.round(this.cfg.puffAdd * 100)) + '/' + this.unitLc());
    // Note lives on the 3D Embroidery variant, so it can be edited in Shopify
    // rather than in theme code. Hidden when unset so no empty line shows.
    this.text(this.el.puffNote, this.cfg.puffNote || '');
    this.show(this.el.puffNote, !!this.cfg.puffNote);
    if (this.el.puffCheck && !this.el.puffCheck.dataset.bound) {
      this.el.puffCheck.dataset.bound = '1';
      this.el.puffCheck.addEventListener('change', function (e) {
        self.patchLoc(self.activeIndex(), { puff: e.target.checked });
      });
    }
  };

  /* "2 Weeks | 12pc Minimum" — the production facts that decide whether a
     customer can order a decoration at all, shown where they choose it rather
     than discovered at checkout. Both parts are optional and each is omitted
     when unset, so a variant with neither adds nothing. Built in one place so
     the sub-choice list and the decoration list can never disagree about the
     same variant. */
  P.metaFor = function (entry) {
    if (!entry) return '';
    var bits = [];
    var lead = (entry.leadtime || '').trim();
    var min = Number(entry.minQty) || 0;
    if (lead) bits.push(lead);
    if (min > 0) bits.push(min + 'pc Minimum');
    return bits.join(' | ');
  };

  P.cheapestSubtype = function (decoId) {
    var subs = (this.decoOf(decoId) || {}).subtypes || [];
    return subs.reduce(function (lo, s) {
      return (lo === null || s.price < lo) ? s.price : lo;
    }, null) || 0;
  };

  // Second-level choice (patch type). Only rendered for decorations that have
  // sub-choices; the pick sets the price for every location.
  P.renderSubtypes = function (act) {
    var self = this;
    var el = this.el;
    var subs = (this.decoOf(act.deco) || {}).subtypes || [];
    var on = subs.length > 0;

    this.show(el.subtypeBlock, on);
    if (!on) return;

    // Wording comes from the decoration's own Sub-choice heading field, so it
    // can be reworded in the theme editor. Falls back to the derived form for
    // any decoration that has not set one.
    var dec = this.decoOf(act.deco) || {};
    this.text(el.subtypeHead, dec.subtypeHead || (dec.name + ' TYPE'));

    var wrap = el.subtypes;
    if (!wrap) return;
    if (wrap.dataset.deco !== act.deco) {
      wrap.dataset.deco = act.deco;
      wrap.innerHTML = '';
      subs.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-deco';
        b.innerHTML =
          '<span class="cc-deco__dot"></span>' +
          '<span class="cc-deco__text">' +
            '<span class="cc-deco__name">' + esc(s.label) +
              (self.metaFor(s) ? ' <span class="cc-deco__meta">- ' + esc(self.metaFor(s)) + '</span>' : '') +
            '</span>' +
            '<span class="cc-deco__note">' + esc(s.note || '') + '</span>' +
          '</span>' +
          '<span class="cc-deco__price">' + (s.unmapped ? '—' : '+' + esc(self.money(Math.round(s.price * 100)))) + '</span>';
        b.addEventListener('click', function () {
          self.patchLoc(self.activeIndex(), { subtype: s.value, patchColor: '', addons: [] });
        });
        wrap.appendChild(b);
      });
    }
    /* Query the buttons rather than walking children: the options block is
       injected INTO this list, so children[i] no longer lines up with subs[i]
       — which lit the row above the one the customer clicked. */
    Array.prototype.forEach.call(wrap.querySelectorAll('.cc-deco'), function (b, i) {
      if (!subs[i]) return;
      b.setAttribute('aria-pressed', subs[i].value === act.subtype ? 'true' : 'false');
    });
  };

  /* The selected decoration's own image and long copy — whichever resolve()
     hands back, a sub-choice or a deco_map entry, since both now carry the
     pair. Text is set with textContent and CSS white-space, never innerHTML:
     these descriptions are merchant copy with real newlines in them, and
     rendering them as markup would be an injection path for no gain.

     Either field may be empty; the block hides only when BOTH are. */
  P.renderDetail = function (act) {
    var el = this.el;
    if (!el.detailBlock) return;

    var hasLocs = this.state.locations.length > 0;
    var r = hasLocs ? this.resolve(act) : {};
    var img = typeof r.image === 'string' ? r.image : '';
    /* Guarded: a metafield emitted without .value arrives as an object and
       textContent would render it as [object Object] on the storefront. */
    var desc = typeof r.description === 'string' ? r.description : '';

    /* The block also hosts the panel picker and the size limit now, so it has
       to stay up for a front location that has neither image nor copy —
       otherwise the customer loses the panel choice entirely. */
    var showPanels = hasLocs && act.loc === 'front';
    var note = typeof r.note === 'string' ? r.note : '';
    this.show(el.detailBlock, !!(img || desc || note || showPanels));
    if (el.detailImg) {
      if (img && el.detailImg.getAttribute('src') !== img) el.detailImg.setAttribute('src', img);
      this.show(el.detailImg, !!img);
    }
    this.text(el.detailText, desc);
  };

  /* Colour swatches for the selected sub-type. Rebuilt when the sub-type
     changes rather than on every render, the same way the sub-type buttons
     themselves are keyed on deco. Nothing here touches price. */
  P.renderPatchColors = function (act) {
    var self = this;
    var el = this.el;
    var colors = this.colorsFor(act);
    var on = colors.length > 0;

    this.show(el.patchColorBlock, on);
    if (!on) return;

    var sub = null;
    var subs = (this.decoOf(act.deco) || {}).subtypes || [];
    for (var i = 0; i < subs.length; i++) {
      if (subs[i].value === act.subtype) sub = subs[i];
    }
    this.text(el.patchColorHead,
      ((sub && sub.label) || 'PATCH').toUpperCase() + ' COLOR' +
      (act.patchColor ? ' · ' + act.patchColor.toUpperCase() : ' · CHOOSE ONE'));

    var wrap = el.patchColors;
    if (!wrap) return;
    var sig = act.deco + '|' + act.subtype;
    if (wrap.dataset.sig !== sig) {
      wrap.dataset.sig = sig;
      wrap.innerHTML = '';
      colors.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-pswatch';
        b.title = c.name;
        b.setAttribute('aria-label', c.name);
        // The colour rides on the chip, not the button, so the name stays
        // readable whatever the colour is. A missing hex is fine — the chip
        // goes neutral and the name still identifies it.
        if (!c.hex) b.classList.add('cc-pswatch--nohex');
        b.innerHTML =
          '<span class="cc-pswatch__chip"></span>' +
          '<span class="cc-pswatch__name">' + esc(c.name) + '</span>';
        if (c.hex) {
          var chip = b.firstChild;
          if (chip) chip.style.background = c.hex;
        }
        b.addEventListener('click', function () {
          self.patchLoc(self.activeIndex(), { patchColor: c.name });
        });
        wrap.appendChild(b);
      });
    }
    Array.prototype.forEach.call(wrap.children, function (b, i) {
      b.setAttribute('aria-pressed', colors[i].name === act.patchColor ? 'true' : 'false');
    });
  };

  /* Options for whatever is selected.

     Mutually exclusive groups render as PULLDOWNS rather than radio rows: two
     groups of two was already eight lines of chrome under a twelve-row patch
     list, and the customer had to scan past all of it to find the choice they
     had just made. Independent add-ons stay checkboxes — a checkbox reads as
     "extra", a pulldown as "pick one", and that distinction is the whole
     point of the two shapes.

     The block is then MOVED in the DOM to sit directly beneath the selected
     row, so the options are adjacent to the thing they modify instead of
     stranded at the bottom of the list. */
  P.renderAddons = function (act) {
    var self = this;
    var el = this.el;
    var list = this.addonsFor(act);
    var on = list.length > 0;

    this.show(el.addonBlock, on);
    if (!on) return;

    var wrap = el.addons;
    if (!wrap) return;
    var groups = this.addonGroups(act);
    var plain = this.plainAddons(act);
    var chosen = act.addons || [];
    var sig = list.map(function (a) { return a.group + ':' + a.value; }).join('~');

    if (wrap.dataset.sig !== sig) {
      wrap.dataset.sig = sig;
      wrap.innerHTML = '';

      groups.forEach(function (g) {
        var row = document.createElement('div');
        row.className = 'cc-optrow';

        var lab = document.createElement('label');
        lab.className = 'cc-optrow__label';
        lab.textContent = g.name;

        var sel = document.createElement('select');
        sel.className = 'cc-optrow__select';
        g.items.forEach(function (a) {
          var o = document.createElement('option');
          o.value = a.value;
          var price = Number(a.price) || 0;
          // Price belongs in the option text — a pulldown has nowhere else to
          // put it, and a customer choosing between two must see both costs.
          var meta = self.metaFor(a);
          o.textContent = a.label +
            (price > 0 ? '  +' + self.money(Math.round(price * 100)) + '/' + self.unitLc() : '  (included)') +
            (meta ? '  ·  ' + meta : '');
          sel.appendChild(o);
        });
        sel.addEventListener('change', function (e) {
          var cur = (self.activeLoc().addons || []).filter(function (v) {
            return !g.items.some(function (s2) { return s2.value === v; });
          });
          cur.push(e.target.value);
          self.patchLoc(self.activeIndex(), { addons: cur });
        });

        row.appendChild(lab);
        row.appendChild(sel);
        wrap.appendChild(row);
      });

      plain.forEach(function (a) {
        var lab2 = document.createElement('label');
        lab2.className = 'cc-puff';
        var meta = self.metaFor(a);
        var price = Number(a.price) || 0;
        lab2.innerHTML =
          '<input type="checkbox">' +
          '<span class="cc-puff__text">' +
            '<span class="cc-puff__name">' + esc(a.label) +
              (meta ? ' <span class="cc-deco__meta">- ' + esc(meta) + '</span>' : '') +
            '</span>' +
            (a.note ? '<span class="cc-puff__note">' + esc(a.note) + '</span>' : '') +
          '</span>' +
          '<span class="cc-puff__price">' +
            (price > 0 ? '+' + esc(self.money(Math.round(price * 100))) + '/' + esc(self.unitLc()) : 'Included') +
          '</span>';
        lab2.querySelector('input').addEventListener('change', function (e) {
          var cur = (self.activeLoc().addons || []).slice();
          var at = cur.indexOf(a.value);
          if (e.target.checked && at === -1) cur.push(a.value);
          if (!e.target.checked && at > -1) cur.splice(at, 1);
          self.patchLoc(self.activeIndex(), { addons: cur });
        });
        wrap.appendChild(lab2);
      });
    }

    // Reflect state. Selects and checkboxes are rebuilt only when the offered
    // set changes, so values are pushed on every render.
    var gi = 0;
    Array.prototype.forEach.call(wrap.querySelectorAll('.cc-optrow__select'), function (sel) {
      var g = groups[gi++];
      if (!g) return;
      var pick = null;
      g.items.forEach(function (a) { if (chosen.indexOf(a.value) > -1) pick = a.value; });
      if (pick && sel.value !== pick) sel.value = pick;
    });
    Array.prototype.forEach.call(wrap.querySelectorAll('.cc-puff input'), function (box, i) {
      if (plain[i]) box.checked = chosen.indexOf(plain[i].value) > -1;
    });

  };

  /* Park the options block and then the colour swatches immediately after the
     selected row — the chosen patch when there are sub-choices, otherwise the
     chosen decoration. Moving the existing nodes rather than duplicating
     markup keeps one set of listeners and one source of truth per control.

     Colours go SECOND so the panel reads options-then-colour. When a patch has
     no options the addon block is hidden, collapses to nothing, and the
     swatches land directly under the row on their own.

     Safe against the injected-node trap only because every index-based loop
     over these lists queries .cc-deco rather than walking children — these two
     blocks contain .cc-optrow and .cc-pswatch, so they never match. */
  P.placeDockedBlocks = function (act) {
    var block = this.el.addonBlock;
    var colorBlock = this.el.patchColorBlock;
    if (!block && !colorBlock) return;
    var subs = (this.decoOf(act.deco) || {}).subtypes || [];
    var host = subs.length ? this.el.subtypes : this.el.decorations;
    var rows = host ? host.querySelectorAll('.cc-deco') : null;
    if (!rows || !rows.length) return;

    var idx = -1;
    if (subs.length) {
      for (var i = 0; i < subs.length; i++) if (subs[i].value === act.subtype) idx = i;
    } else {
      var decos = this.decosForLoc(act.loc);
      for (var j = 0; j < decos.length; j++) if (decos[j].id === act.deco) idx = j;
    }
    if (idx < 0) idx = 0;

    var anchor = rows[idx];
    if (!anchor) return;

    var after = anchor;
    [this.el.detailBlock, block, colorBlock].forEach(function (node) {
      if (!node) return;
      if (after.nextSibling !== node) host.insertBefore(node, after.nextSibling);
      after = node;
    });
  };

  P.renderArtwork = function () {
    var self = this;
    var s = this.state;
    var act = this.activeLoc();
    var hasLocs = s.locations.length > 0;
    var el = this.el;

    this.show(el.artBlock, hasLocs);
    if (!hasLocs) return;

    var isUpload = act.tab === 'upload';
    var files = act.files || [];

    if (el.tabUpload) el.tabUpload.setAttribute('aria-pressed', isUpload ? 'true' : 'false');
    if (el.tabText) el.tabText.setAttribute('aria-pressed', !isUpload ? 'true' : 'false');
    this.show(el.uploadPane, isUpload);
    this.show(el.textPane, !isUpload);

    this.text(el.artStatus, isUpload
      ? (files.length === 1 ? '1 FILE ATTACHED' : files.length + ' FILES ATTACHED')
      : (act.text || '').length + '/' + this.cfg.maxTextChars + ' CHAR');

    this.text(el.dropTitleLoc, this.locFullName(act));
    if (el.drop) el.drop.setAttribute('data-over', s.dropActive ? 'true' : 'false');

    // file rows
    var fWrap = el.files;
    if (fWrap) {
      fWrap.innerHTML = '';
      files.forEach(function (f, i) {
        var row = document.createElement('div');
        row.className = 'cc-file';
        var on = !!f.url && (act.shown || []).indexOf(f.id) > -1;
        row.innerHTML =
          '<span class="cc-file__l">' +
            '<span class="cc-file__thumb"' + (f.url ? ' style="background-image:url(&quot;' + esc(f.url) + '&quot;)"' : '') + '></span>' +
            '<span class="cc-file__ext">' + esc(f.ext) + '</span>' +
            '<span class="cc-file__name">' + esc(f.name) + '</span>' +
            '<span class="cc-file__meta">' + esc(f.meta) + '</span>' +
            '<span class="cc-file__loc">' + esc(self.locMeta(act.loc).name.toUpperCase()) + '</span>' +
          '</span>' +
          '<span class="cc-file__r">' +
            '<button type="button" class="cc-file__btn" data-on="' + (on ? 'true' : 'false') + '"' + (f.url ? '' : ' disabled') + '>' +
              (f.url ? (on ? 'ON PRODUCT' : 'SHOW ON PRODUCT') : 'NO PREVIEW') +
            '</button>' +
            '<button type="button" class="cc-file__btn">REMOVE</button>' +
          '</span>';

        /* Clicking the row selects that image, so the size and rotate controls
           point at it. Two stacked images can have overlapping grips, and the
           list is the one place they are always separately clickable. */
        row.querySelector('.cc-file__l').addEventListener('click', function () {
          if (!f.url) return;
          var v = self.viewsForColor()[self.state.view];
          if (v && v.logo) self.selectObject(self.objKey(v.logo, act.loc, 'art#' + f.id));
        });

        var btns = row.querySelectorAll('.cc-file__btn');
        btns[0].addEventListener('click', function () {
          if (!f.url) return;
          // A toggle now, not a pick: several files can be on the product at
          // once, so this adds and removes rather than replacing.
          var cur = (act.shown || []).slice();
          var at = cur.indexOf(f.id);
          if (at > -1) cur.splice(at, 1); else cur.push(f.id);
          var first = (act.files || []).filter(function (x) { return cur.indexOf(x.id) > -1; })[0];
          self.patchLoc(self.activeIndex(), { shown: cur, art: first ? first.url : '' });
        });
        btns[1].addEventListener('click', function () {
          self.removeFileFrom(self.activeIndex(), f);
        });
        fWrap.appendChild(row);
      });
    }
    this.show(el.noFiles, files.length === 0);

    // text pane
    if (el.textValue && document.activeElement !== el.textValue) el.textValue.value = act.text || '';
    if (el.fontSelect && el.fontSelect.children.length === 0) {
      this.cfg.fonts.forEach(function (f) {
        var o = document.createElement('option');
        o.value = f.label; o.textContent = f.label;
        // Each option previews its own face, so the list shows the choice
        // rather than describing it.
        if (f.css) o.style.fontFamily = f.css;
        el.fontSelect.appendChild(o);
      });
    }
    if (el.threadSelect && el.threadSelect.children.length === 0) {
      this.cfg.threads.forEach(function (t) {
        var o = document.createElement('option');
        o.value = self.threadKey(t);
        o.textContent = t.code ? t.name + ' ' + t.code : t.name;
        el.threadSelect.appendChild(o);
      });
    }
    if (el.fontSelect) el.fontSelect.value = act.font || '';
    if (el.threadSelect) el.threadSelect.value = act.thread || '';

    this.renderThreads();
  };

  /* The swatch grid is built once and then only re-marked, because rebuilding
     145 buttons on every keystroke of the filter drops the pressed state and
     makes typing feel laggy. Filtering hides rows instead. */
  P.renderThreads = function () {
    var self = this;
    var el = this.el;
    var grid = el.threadGrid;
    if (!grid) return;

    if (grid.children.length === 0) {
      (this.cfg.threads || []).forEach(function (t) {
        var key = self.threadKey(t);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-thread';
        b.setAttribute('role', 'option');
        b.setAttribute('data-key', key);
        b.setAttribute('data-find', ((t.name || '') + ' ' + (t.code || '')).toLowerCase());
        b.title = t.code ? t.name + ' · ' + t.code : t.name;
        b.setAttribute('aria-label', b.title);
        b.style.background = t.hex;
        b.addEventListener('click', function () {
          self.patchLoc(self.activeIndex(), { thread: key });
        });
        grid.appendChild(b);
      });
    }

    var act = this.activeLoc();
    var cur = act ? act.thread : '';
    var q = (el.threadFilter && el.threadFilter.value || '').trim().toLowerCase();
    var shown = 0;

    Array.prototype.forEach.call(grid.children, function (b) {
      var hit = !q || b.getAttribute('data-find').indexOf(q) !== -1;
      b.hidden = !hit;
      if (hit) shown++;
      var on = b.getAttribute('data-key') === cur;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.classList.toggle('cc-thread--on', on);
    });

    this.show(el.threadNone, shown === 0);
    this.text(el.threadCurrent, this.threadLabel(cur));
  };

  P.renderNotesStatus = function () {
    var s = this.state;
    var status = s.refMode === 'order'
      ? 'REORDER REFERENCE'
      : (s.refMode === 'mock'
        ? (s.refMock ? s.refMock.toUpperCase() : 'MOCKUP REF')
        : (s.notes ? 'NOTES ADDED' : 'OPTIONAL'));
    this.text(this.el.notesStatus, status);

    var el = this.el;
    if (el.refNone) el.refNone.setAttribute('aria-pressed', s.refMode === 'none' ? 'true' : 'false');
    if (el.refOrder) el.refOrder.setAttribute('aria-pressed', s.refMode === 'order' ? 'true' : 'false');
    if (el.refMock) el.refMock.setAttribute('aria-pressed', s.refMode === 'mock' ? 'true' : 'false');
    this.show(el.refOrderPane, s.refMode === 'order');
    this.show(el.refMockPane, s.refMode === 'mock');
    /* The refund promise is hidden on print methods, which never get one. */
    this.show(el.reorderNote, this.setupRefundable());

    // No decoration means nothing to instruct about, so the whole step goes
    // away and quantity moves up to take its number.
    var hasLocs = s.locations.length > 0;
    this.show(el.notesBlock, hasLocs);
    this.text(el.notesStep, '04');
    this.text(el.qtyStep, hasLocs ? '05' : '03');
    this.text(el.artStep, '03');
  };

  /* The grid is rebuilt whenever the colourway changes, because the size list
     is the colourway's. Existing typed quantities survive by NAME, so a
     shopper who fills in a run and then tries another colour keeps it. */
  /* One row per colourway being ordered: its swatch and name, then the cells
     the customer types into — a grid of sizes where the product has them, a
     single box where it does not.

     Rebuilt only when the SHAPE changes (which colours, which sizes), and the
     values and stock are written on every render. Rebuilding on every keypress
     would take the focused input out from under the customer mid-type. */
  // Mark which swatches are in the order, so the grid shows the selection.
  P.markSwatches = function () {
    var self = this;
    var wrap = this.el.swatches;
    if (!wrap) return;
    /* Ordered is a class and a label, never aria-pressed — renderColors owns
       that and uses it for the preview. Both were written here and there and
       this one ran second, so the two states rendered as one ring and the
       customer could not tell what was on the order. */
    var colors = this.cfg.colors || [];
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-cc-swatch]'), function (b) {
      var i = parseInt(b.getAttribute('data-cc-swatch'), 10);
      var on = self.isPicked(i);
      var col = colors[i] || {};
      b.classList.toggle('cc-swatch--picked', on);
      b.setAttribute('aria-label', col.name +
        (col.available ? '' : ', out of stock') +
        (on ? ', on your order' : ''));
      b.title = col.name + (col.available ? '' : ' — out of stock') +
        (on ? ' — on your order' : '');
    });
  };

  P.renderColorRows = function () {
    this.markSwatches();
    var self = this;
    var el = this.el;
    if (!el.colorRows) return;

    var picked = this.pickedColors();
    var sig = picked.map(function (col) {
      return col.name + '>' + self.sizeRowsFor(col).map(function (r) {
        return r.name + ':' + r.variantId;
      }).join('+');
    }).join(',');

    if (el.colorRows.getAttribute('data-sig') !== sig) {
      el.colorRows.setAttribute('data-sig', sig);
      el.colorRows.innerHTML = '';

      /* The order starts empty, so this section starts empty too — and an
         empty box reads as broken rather than as waiting. It says what to do
         instead, in the place the rows will appear. */
      if (!picked.length) {
        var none = document.createElement('div');
        none.className = 'cc-crow__none';
        none.textContent = self.cfg.noColorsLabel ||
          'No colorway on your order yet. Pick a swatch above, then press ADD TO ORDER.';
        el.colorRows.appendChild(none);
      }

      picked.forEach(function (col) {
        var ci = self.cfg.colors.indexOf(col);
        var row = document.createElement('div');
        row.className = 'cc-crow';
        row.setAttribute('data-crow-row', String(ci));

        var head = document.createElement('div');
        head.className = 'cc-crow__head';

        /* The row's swatch is a button. With three colourways on the order the
           palette is the wrong place to go back to — the customer would have to
           find the colour again among 124 — so the row previews its own. It
           moves the preview only; the row is already on the order and nothing
           here can take it off. */
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cc-crow__chip';
        chip.style.backgroundColor = col.hex || '#ccc';
        if (col.swatchImage) chip.style.backgroundImage = 'url("' + col.swatchImage + '")';
        chip.setAttribute('data-crow-color', String(ci));
        chip.setAttribute('aria-label', 'Preview ' + col.name);
        chip.title = 'Preview ' + col.name;
        chip.addEventListener('click', function () { self.previewColor(ci); });

        var nm = document.createElement('span');
        nm.className = 'cc-crow__name';
        nm.textContent = col.name;

        head.appendChild(chip);
        head.appendChild(nm);

        /* Removing is on the ROW, not on the swatch. A swatch that both adds
           and removes makes an accidental second click undo a run the customer
           typed, with no hint that it is about to.

           EVERY row gets one, including the last. It used to be hidden at
           `picked.length > 1` so the order could never be emptied — which was
           right when the product landed with a colourway already on it. The
           order now STARTS empty, so refusing to empty it is arbitrary: it
           left the customer stuck with whichever colourway they happened to
           add first. */
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'cc-crow__x';
        x.textContent = 'REMOVE';
        x.setAttribute('aria-label', 'Remove ' + col.name);
        x.addEventListener('click', function () { self.unpickColor(ci); });
        head.appendChild(x);
        row.appendChild(head);

        var cells = document.createElement('div');
        cells.className = 'cc-sizes';
        var rows = self.sizeRowsFor(col);
        var list = rows.length ? rows : [{ name: '', variantId: col.variantId, available: col.available, stock: col.stock }];

        /* The cheapest size in this colourway, which every upcharge below is
           measured against. Per COLOURWAY rather than per product: a colour
           carried only in big sizes should not read as though every size were
           an upcharge. */
        var baseUnit = null;
        list.forEach(function (r) {
          if (r.price == null) return;
          if (baseUnit === null || r.price < baseUnit) baseUnit = r.price;
        });

        list.forEach(function (r) {
          var out = !r.available && !self.cfg.allowOutOfStock;
          var cell = document.createElement('div');
          cell.className = 'cc-sizes__cell' + (out ? ' cc-sizes__cell--out' : '');

          var lab = document.createElement('span');
          lab.className = 'cc-sizes__lab';
          lab.textContent = r.name || 'QTY';
          // The label can be clipped to keep the grid aligned, so the full
          // size has to survive somewhere the customer can reach it.
          lab.title = r.name || 'Quantity';

          /* WHAT THIS SIZE COSTS OVER THE SMALLEST ONE, on the size itself.

             Kelly's call, 2026-08-25. Big sizes cost more — the Gildan runs
             $6.22 at S and $12.40 at 3XL — and until now the only place that
             showed up was the total, after the customer had already typed the
             quantity. A "+$8.00" over 4XL says it at the moment they choose.

             Measured against the CHEAPEST size of this colourway, which is how
             a customer reads it: the shirt is $48 and the 4XL is eight dollars
             more. Nothing is PRINTED on the sizes at base price — a row of
             "+$0.00" is noise, and the absence is the message.

             The span is ALWAYS created even so, and left empty where there is
             no upcharge. The cells are top-aligned, so one that appears on only
             some of them pushes those quantity boxes down and the row stops
             lining up — and the customer reads this grid by position. */
          var upcharge = document.createElement('span');
          upcharge.className = 'cc-sizes__up';
          if (r.price != null && baseUnit != null && r.price > baseUnit) {
            var over = self.money(Math.round((r.price - baseUnit) * 100));
            upcharge.textContent = '+' + over;
            upcharge.title = (r.name || 'This size') + ' costs ' + over +
              ' more than the smallest size';
          }

          var inp = document.createElement('input');
          inp.type = 'number';
          inp.min = '0';
          inp.step = '1';
          inp.className = 'cc-sizes__in';
          inp.setAttribute('aria-label', col.name + ' ' + (r.name || 'quantity'));
          inp.setAttribute('data-qty-color', col.name);
          inp.setAttribute('data-qty-size', r.name || '');
          if (out) inp.disabled = true;
          /* Stock is a ceiling, not a warning. -1 means the colourway is not
             inventory-tracked, which is not the same as none left, so it takes
             no ceiling at all. Allowing out-of-stock ordering removes it too —
             that setting exists precisely to sell what is not on the shelf. */
          var cap = (!self.cfg.allowOutOfStock && typeof r.stock === 'number' && r.stock >= 0)
            ? r.stock
            : null;
          if (cap !== null) inp.setAttribute('max', String(cap));
          inp.addEventListener('input', function () {
            var n = Math.max(0, parseInt(inp.value, 10) || 0);
            if (cap !== null && n > cap) {
              /* Rewritten in the box as well as in state. Leaving the typed
                 number on screen while pricing a smaller one is the kind of
                 disagreement a customer only discovers at checkout. */
              n = cap;
              inp.value = String(n);
            }
            self.setQtyFor(col.name, r.name, n);
          });

          var stk = document.createElement('span');
          stk.className = 'cc-sizes__stock';
          stk.setAttribute('data-stock-color', col.name);
          stk.setAttribute('data-stock-size', r.name || '');

          // Above the size, so it is read before the quantity is typed.
          if (upcharge) cell.appendChild(upcharge);
          cell.appendChild(lab);
          cell.appendChild(inp);
          cell.appendChild(stk);
          cells.appendChild(cell);
        });

        row.appendChild(cells);
        el.colorRows.appendChild(row);
      });
    }

    /* Which row the stage is showing. Written on every render and NOT inside
       the signature guard above: the signature is which colours and which
       sizes, and the preview is neither, so marking it there would leave the
       stage changing while the rows sat still. */
    Array.prototype.forEach.call(el.colorRows.querySelectorAll('[data-crow-row]'), function (row) {
      var on = parseInt(row.getAttribute('data-crow-row'), 10) === self.state.color;
      row.classList.toggle('cc-crow--previewing', on);
      var chip = row.querySelector('.cc-crow__chip');
      if (chip) chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Values and stock, every render — both belong to state, not to shape.
    var byKey = {};
    picked.forEach(function (col) {
      var rows = self.sizeRowsFor(col);
      var list = rows.length ? rows : [{ name: '', available: col.available, stock: col.stock }];
      list.forEach(function (r) { byKey[self.qtyKey(col.name, r.name)] = r; });
    });

    Array.prototype.forEach.call(el.colorRows.querySelectorAll('.cc-sizes__in'), function (inp) {
      if (document.activeElement === inp) return;
      var v = self.qtyOf(inp.getAttribute('data-qty-color'), inp.getAttribute('data-qty-size'));
      inp.value = v ? String(v) : '';
    });

    Array.prototype.forEach.call(el.colorRows.querySelectorAll('.cc-sizes__stock'), function (node) {
      var r = byKey[self.qtyKey(node.getAttribute('data-stock-color'), node.getAttribute('data-stock-size'))];
      var n = r ? r.stock : -1;
      var txt = '';
      /* -1 is "not tracked", which is not the same as none left and must not
         read as a zero. */
      if (r && !r.available && !self.cfg.allowOutOfStock) txt = 'OUT';
      else if (typeof n === 'number' && n > 0) txt = String(n);
      else if (typeof n === 'number' && n === 0) txt = 'OUT';
      self.text(node, txt);
      node.className = 'cc-sizes__stock' + (txt === 'OUT' ? ' cc-sizes__stock--out' : '');
    });

    /* Mark the cells that are short, so "MIN 6 EACH" on the button has
       somewhere to point. A rule the customer cannot see the breach of is
       indistinguishable from a broken control. */
    var vmin = this.effectiveVariantMin();
    var vShort = this.variantShortfalls();
    var shortKeys = {};
    vShort.forEach(function (v) { shortKeys[self.qtyKey(v.color, v.size)] = true; });
    Array.prototype.forEach.call(el.colorRows.querySelectorAll('.cc-sizes__in'), function (inp) {
      var bad = shortKeys[self.qtyKey(inp.getAttribute('data-qty-color'), inp.getAttribute('data-qty-size'))];
      inp.parentNode.classList.toggle('cc-sizes__cell--short', !!bad);
    });

    // The running total, across every colour and size.
    var total = this.totalQty();
    var floor = this.effectiveMinQty();
    var short = total > 0 && total < floor;
    el.sizeSum.className = 'cc-sizes__sum' +
      ((short || vShort.length) ? ' cc-sizes__sum--short' : '');
    el.sizeSum.innerHTML = '';
    var left = document.createElement('span');
    /* The per-cell rule is named BEFORE the order total, because fixing the
       cells usually fixes the total as well — telling someone to add 4 more
       when what is wrong is a size holding 2 sends them the wrong way. */
    left.textContent = total === 0
      ? this.copy('qtyEnterQuantity')
      : (vShort.length
        ? this.copy('qtyVariantShort', {
          min: vmin,
          axis: self.sizeMode() ? 'SIZE' : 'COLOR',
          count: vShort.length
        })
        : (short
          ? this.copy('qtyAddMore', { count: floor - total, min: floor })
          : this.copy('qtyTotalPieces')));
    var right = document.createElement('b');
    right.textContent = String(total);
    el.sizeSum.appendChild(left);
    el.sizeSum.appendChild(right);
    this.show(el.sizeSum, true);
  };

  /* Looking. Moves the stage, the stock badge and the price display and
     touches nothing the customer is buying — 124 colourways are there to be
     browsed and browsing one must not put it on the order.

     qtyBy is keyed by colourway NAME and is not consulted here, so a run typed
     against a colourway survives being browsed away from and back. */
  P.previewColor = function (i) {
    this.ensureSizes(i);
    this.set({ color: i, zoom: 1 });
  };

  /* Buying. Always adds the previewed colourway and never removes one, so a
     second press cannot undo a typed run; the row's REMOVE is the only way
     out. Kept as the one place `picked` grows. */
  P.pickColor = function (i) {
    /* Also on ADD, not only on preview: the proof sheet can put a colourway on
       the order without it ever having been the one on the stage. */
    this.ensureSizes(i);
    var picked = (this.state.picked || []).slice();
    if (picked.indexOf(i) === -1) picked.push(i);
    /* Zoom resets only when the CAP on the stage changes. It used to reset
       unconditionally because this was also the colour change; now the usual
       press is ADD on the colour already showing, and snapping a customer out
       of the zoom they were inspecting their artwork in would be a punishment
       for putting it on the order. */
    var patch = { color: i, picked: picked };
    if (i !== this.state.color) patch.zoom = 1;
    this.set(patch);
  };

  P.unpickColor = function (i) {
    var col = this.cfg.colors[i];
    var picked = (this.state.picked || []).filter(function (x) { return x !== i; });

    // Its quantities go with it, or a removed colour keeps being priced.
    var cur = this.state.qtyBy || {};
    var map = {};
    var self = this;
    Object.keys(cur).forEach(function (k) {
      if (k.indexOf(self.qtyKey(col.name, '')) !== 0) map[k] = cur[k];
    });

    /* The preview stays where it is, even on the colourway just removed.
       Previewing something that is not on the order is now an ordinary state —
       it is what browsing produces — and the ADD button says so, so moving the
       stage out from under the customer would be the surprising half. */
    this.set({ picked: picked, qtyBy: map });
  };

  P.renderQty = function () {
    var self = this;
    var p = this.pricing();
    var el = this.el;

    this.renderColorRows();
    // Without a tier table there is no tier to name, and "TIER 0+" is noise.
    this.text(el.tierLabel, p.table.length === 0
      ? ''
      : 'TIER ' + p.tier.min + (p.tier.max ? '–' + p.tier.max : '+') +
        (p.pct > 0 ? ' · ' + p.pct + '% OFF' : ''));

    /* The quantity stops went with the slider they sat on. Every one of them
       set a single number, and there is no longer a single number to set. */
  };

  P.renderPrice = function () {
    var self = this;
    var p = this.pricing();
    var el = this.el;
    var money = this.money;
    var cents = function (n) { return money(Math.round(n * 100)); };
    var locs = this.state.locations;

    this.text(el.totalLabel, cents(p.total));
    this.text(el.totalLabel2, cents(p.total));
    this.text(el.perCapLabel, this.perCapText(p));
    this.text(el.perCapCaption, locs.length === 0
      ? 'PER BLANK ' + this.unit()
      : 'PER ' + this.unit() + ' DECORATED');
    /* Says what to do rather than quoting a price for nothing. "ADD TO CART
       — $0.00" is worse than the $40 it replaced. */
    /* The button reads as "Add to cart — <this>", so each phrase has to finish
       that sentence. A price on a button that cannot be pressed explains
       nothing; the shortfall does. */
    this.text(el.ctaTotal, p.empty
      ? this.copy('ctaEnterQuantities')
      : (p.variantShort.length
        ? this.copy('ctaVariantMin', { min: p.variantMin })
        : (p.belowMin ? this.copy('ctaBelowMin', { count: p.shortBy }) : cents(p.total))));

    // tier table — rows come from whichever table is active (decorated / blank).
    // With no tiers there is nothing to compare, so the block goes away rather
    // than showing a lone 0% row.
    this.show(el.tiersBlock, p.table.length > 0);
    var wrap = el.tiers;
    if (wrap) {
      wrap.innerHTML = '';
      p.table.forEach(function (t) {
        var cur = t === p.tier;
        /* The CHEAPEST ORDERED size, not the colourway's representative,
           which on a size run may not be in the order at all. The ladder
           compares TIERS, so what matters is that every row shares one basis
           and that the basis is a price somebody is actually paying. */
        var tPer = p.listMin * (1 - (t.pct || 0) / 100);
        var delta = tPer - p.perCapMin;
        var row = document.createElement('div');
        row.className = 'cc-tier';
        row.setAttribute('data-on', cur ? 'true' : 'false');
        row.innerHTML =
          '<div class="cc-tier__range">' +
            '<span>' + esc(t.max ? t.min + '–' + t.max : t.min + '+') + '</span>' +
            '<span class="cc-tier__pct">' + esc((t.pct || 0) + '%') + '</span>' +
            (cur ? '<span class="cc-tier__badge">CURRENT</span>' : '') +
          '</div>' +
          '<div class="cc-tier__price">' + esc(cents(tPer)) + '</div>' +
          '<div class="cc-tier__save" data-save="' + (!cur && delta < 0 ? 'true' : 'false') + '">' +
            esc(cur ? '—' : (delta < 0 ? '−' + cents(Math.abs(delta)) + '/' + self.unitLc() : '+' + cents(delta) + '/' + self.unitLc())) +
          '</div>';
        wrap.appendChild(row);
      });
    }

    var showUpsell = this.cfg.showUpsell && !!p.next && p.save > 0;
    this.show(el.upsell, showUpsell);
    if (showUpsell) {
      this.text(el.upsellText, this.copy('upsellText', {
        count: p.gap,
        units: this.unitsLc(),
        pct: p.next.pct,
        save: cents(p.save),
        unit: this.unitLc()
      }));
    }

    // Show the discount as its own line so the customer sees what the tier did.
    this.text(el.capsSubtotalLabel, p.qty + ' ' + this.unitsLc() + ' @ ' + this.listText(p));
    this.text(el.capsSubtotal, cents(p.listSub));
    this.show(el.discountRow, p.pct > 0);
    this.text(el.discountLabel, 'Volume discount — ' + p.pct + '% (' + (locs.length ? 'decorated' : 'blank') + ')');
    this.text(el.discountValue, '−' + cents(p.discountTotal));

    var liWrap = el.lineItems;
    if (liWrap) {
      liWrap.innerHTML = '';
      locs.forEach(function (l) {
        var row = document.createElement('div');
        row.className = 'cc-line cc-line--muted';
        row.innerHTML =
          '<span class="cc-line__k">' + esc(self.locFullName(l) + ' — ' + self.decoLabel(l)) + '</span>' +
          '<span class="cc-line__v">+' + esc(cents(self.lineAdd(l))) + '/' + esc(self.unitLc()) + '</span>';
        liWrap.appendChild(row);
      });
    }

    /* The line reads just "Setup", with no qualifier. It used to say
       "— waived, repeat order" to explain a $0; setup is now charged on
       repeats too and refunded after review, so there is no $0 to explain and
       claiming a waiver here would contradict the invoice. */
    this.text(el.setupCount, '');
    this.text(el.setupLabel, cents(p.setupTotal));

    // Only meaningful on a blank order — hidden the rest of the time rather
    // than shown at $0.00, since "Shipping (blank)" reads as a mistake on a
    // decorated order.
    this.show(el.shippingRow, p.blankShippingTotal > 0);
    this.text(el.shippingLabel, cents(p.blankShippingTotal));

    /* Judged on the colourways ON THE ORDER, not on the previewed one. The
       preview is now free to sit on anything the customer is looking at, and
       browsing a sold-out colourway must not disable a cart holding two that
       are in stock. */
    var ordering = this.pickedColors();
    var sellables = ordering.filter(function (c) {
      return c.variantId && (c.available || self.cfg.allowOutOfStock);
    });
    var sellable = sellables.length > 0;
    var anyVariant = ordering.filter(function (c) { return !!c.variantId; }).length > 0;
    // A decoration with no customization variant behind it would quote as free.
    // Block the sale rather than undercharge.
    var bad = this.unmapped();
    var mapError = bad.length
      ? this.copy('errUnpricedDecoration', {
        locations: bad.map(function (l) { return self.locFullName(l); }).join(' and ')
      })
      : '';

    /* A colour the customer never chose must not be guessed. Defaulting to the
       first swatch would put the wrong colour on the work order and the wrong
       patch on the cap — the same class of failure as an ambiguous thread
       name, which is a remake. So this blocks, the way an unmapped decoration
       does, rather than quietly picking one. */
    var noColor = this.state.locations.filter(function (l) { return self.needsColor(l); });
    var colorError = noColor.length
      ? this.copy('errChooseColor', {
        locations: noColor.map(function (l) { return self.locFullName(l); }).join(' and ')
      })
      : '';

    /* A setup charge with no variant behind it would go through the cart as
       $0 — the same silent undercharge the unmapped-decoration guard exists to
       stop, and worth up to $200 a time. So it blocks and says so, rather than
       selling a die we never billed. The quote path is unaffected: wce-oms
       prices from the metafield and needs no variant. */
    var badSetup = this.setupCharges().filter(function (c) { return !c.variantId; });
    var setupError = badSetup.length
      ? this.copy('errUnpricedSetup', {
        amounts: badSetup.map(function (c) { return self.money(Math.round(c.amount * 100)); }).join(' and ')
      })
      : '';

    if (el.addToCart) {
      el.addToCart.disabled =
        !sellable || !!mapError || !!colorError || !!setupError ||
        this.state.adding || p.empty || p.belowMin || p.variantShort.length > 0;
    }

    // Held separately from state.error so it clears itself when the offending
    // colorway or decoration is changed.
    /* Describes the ORDER, not the preview. "This colorway is sold out" while
       the customer is browsing a fourth colour points at the wrong thing.

       An EMPTY order is named FIRST. Nothing being on the order yet is the
       state every customer starts in, and telling them "no colorway is
       available to order online" points at the catalogue for something they
       simply have not done yet.

       The strings branch wrote this as a two-way branch on `col.variantId`,
       which was the shape before browsing and ordering came apart. The three
       cases are kept and each one routed through copy(). */
    var nothingPicked = ordering.length === 0;

    this.availabilityError = mapError || colorError || setupError || (sellable ? '' : (nothingPicked
      ? this.copy('errNothingPicked')
      : (anyVariant
        ? this.copy('errColorwaySoldOut')
        : this.copy('errNoColorway'))));
  };

  P.renderModal = function () {
    var el = this.el;
    var s = this.state;
    var p = this.pricing();
    var cents = (function (m) { return function (n) { return m(Math.round(n * 100)); }; })(this.money);

    this.show(el.modal, s.saveOpen);
    if (!s.saveOpen) return;
    this.show(el.modalForm, !s.saveSent);
    this.show(el.modalDone, s.saveSent);

    var locs = s.locations;
    var self = this;
    var summary = (this.cfg.productTitle || '') + ' · ' + (this.currentColor().name || '') + ' · ' +
      (locs.length === 0 ? 'blank' : locs.map(function (l) {
        var bit = self.locMeta(l.loc).name + ' ' + self.decoOf(l.deco).name;
        // The proof email has to describe the imprint it shows, curve included.
        if (l.textOn && l.text) {
          bit += ' "' + l.text + '" ' + self.threadLabel(l.thread);
          if (l.curve) bit += ' ' + (l.curve > 0 ? 'arc up' : 'arc down');
        }
        return bit;
      }).join(' + '));

    // mockSummary / mockEmail appear in both the form and the confirmation
    // panel — update every instance, not just the first.
    this.qa('mockSummary').forEach(function (n) { n.textContent = summary; });
    this.qa('mockPricing').forEach(function (n) {
      n.textContent = p.qty + ' ' + self.unitsLc() + ' · ' + self.perCapText(p) + '/' + self.unitLc() + ' · ' + cents(p.total) + ' total';
    });
    this.qa('mockEmail').forEach(function (n) { n.textContent = s.email; });

    // The modal serves THREE buttons now; every string switches on which
    // opened it. Kept as one dialog rather than three: the customer is doing
    // the same thing each time — handing over an address so we can come back
    // to them — and three copies of a consent notice is three chances for one
    // of them to go stale.
    var quote = s.saveMode === 'quote';
    var request = s.saveMode === 'request';

    /* Name and artwork belong to the REQUEST only. A quote already knows what
       the customer configured, and a download needs nothing but an address. */
    this.show(el.nameField, request);
    this.show(el.reqArtField, request);
    this.show(el.reqNotesField, request);
    if (request) this.renderRequestFiles();

    this.text(el.modalTitle, request
      ? (this.cfg.requestMockupLabel || 'REQUEST A MOCKUP')
      : (quote ? 'SAVE AS QUOTE' : 'DOWNLOAD YOUR MOCKUP'));
    this.text(el.modalLede, this.copy(request
      ? 'modalLedeRequest'
      : (quote ? 'modalLedeQuote' : 'modalLedeMockup')));
    this.text(el.doneTitle, request
      ? 'Request received'
      : (quote ? 'Quote on its way' : 'Mockup downloaded'));
    this.text(el.doneBody, this.copy(request
      ? 'modalDoneRequest'
      : (quote ? 'modalDoneQuote' : 'modalDoneMockup'), {
      summary: summary,
      email: s.email
    }));
    if (el.sendMock) {
      el.sendMock.disabled = s.saving;
      el.sendMock.textContent = s.saving
        ? (request ? 'Sending…' : (quote ? 'Sending…' : 'Building your proof…'))
        : (request ? 'Send my request' : (quote ? 'Send my quote' : 'Download my mockup'));
    }
  };

  /* Names the files the customer chose, because a file input shows "3 files"
     and nothing about which. Also the only place the size limit is stated. */
  P.renderRequestFiles = function () {
    var el = this.el;
    if (!el.reqArtNote) return;
    var files = (el.reqArtValue && el.reqArtValue.files) || [];
    if (!files.length) { this.text(el.reqArtNote, ''); return; }
    var names = [];
    for (var i = 0; i < files.length && i < 6; i++) names.push(files[i].name);
    this.text(el.reqArtNote, names.join(', '));
  };

  /* There are two error slots — one under the configurator, one inside the
     save modal — because a message shown only under the configurator is
     invisible while the modal is open, which reads to the customer as the
     button being dead. Fill every instance, the same way mockSummary and
     mockEmail are handled. */
  P.renderError = function () {
    var msg = this.state.error || this.availabilityError || '';
    var self = this;
    this.qa('error').forEach(function (n) {
      self.text(n, msg);
      self.show(n, !!msg);
    });
  };

  /* ---------- configuration payload -------------------------------------- */

  // Human-readable line item properties, plus one hidden JSON blob the shop
  // can use to reopen the exact configuration.
  /* A unique id for one add-to-cart, stamped on EVERY line it produces.

     The cart transform groups on this. Grouping on `_parent` instead would be
     wrong twice over: the cap line never carried `_parent` at all, so the cap
     would have been left out of its own merge — and two configured caps in one
     cart both carry `cap-config`, so they would have merged into each other and
     priced as one build.

     crypto.randomUUID where available; the fallback only has to be unique
     within a single cart, not globally. */
  P.newBuildId = function () {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) { /* fall through */ }
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  };

  P.buildProperties = function (buildId) {
    var self = this;
    var s = this.state;
    var p = this.pricing();
    var props = {};
    var cents = function (n) { return self.money(Math.round(n * 100)); };

    /* Read by the cart transform, not by a human — it names which set in the
       shop metafield custom.volume_tiers prices this build. Underscored so
       Shopify hides it from the customer's cart and order. A t-shirt template
       names a different set and the Function needs no change.

       Blank and decorated name DIFFERENT sets, and which one this build is
       has to be decided here rather than by the Function, which cannot see
       whether a decoration was chosen. Stamping the decorated set on a blank
       build would have the Function discount blanks — against the margin
       policy, and the same mistake the two-table split exists to prevent. */
    props['_tier'] = (s.locations.length > 0
      ? (this.cfg.tierSet || 'cap-decorated')
      : (this.cfg.tierSetBlank || 'cap-blank'));
    // Ties this line to the rest of its build for the cart transform.
    if (buildId) props['_build'] = buildId;

    /* EVERY colourway on the order. It used to be currentColor(), which is
       only the one being previewed — with three colours in a build that names
       whichever swatch was clicked last, so the floor would read a colour that
       is not what they are sewing. The variant on each line carries the exact
       colour; this is the human summary beside it. */
    props['Colorway'] = this.pickedColors().map(function (c) { return c.name; }).join(', ');

    if (s.locations.length === 0) {
      props['Decoration'] = 'Blank — no decoration';
    } else {
      s.locations.forEach(function (l, i) {
        var r = self.resolve(l);
        var bits = [self.decoOf(l.deco).name];
        if (r.label) bits.push(r.label);
        // Right after the sub-type, since it describes that sub-type.
        if (l.patchColor) bits.push(l.patchColor);
        self.activeAddons(l).forEach(function (a) { bits.push(a.label); });
        if (self.puffAdd(l)) bits.push('3D Puff');
        /* Both, when there are both. This branched on the tab, so a location
           carrying a logo AND a name reported only one of them on the order —
           the shop would have sewn what the cart said, not what the customer
           approved. */
        var names = (l.files || []).map(function (f) { return f.name; });
        if (names.length) bits.push(names.join(', '));
        if (l.textOn && l.text) {
          bits.push('Text: "' + l.text + '"');
          bits.push(l.font);
          bits.push(self.threadLabel(l.thread) + ' thread');
          if (l.curve) bits.push('Curved text ' + (l.curve > 0 ? 'arc up' : 'arc down') + ' ' + Math.abs(l.curve) + '%');
        }
        if (!names.length && !(l.textOn && l.text)) bits.push('ART TO FOLLOW');
        props['Location ' + (i + 1) + ' — ' + self.locFullName(l)] = bits.join(' · ');
      });

      // Customer-facing placement is the location they picked, not canvas
      // coordinates. The numbers stay for the production floor, hidden.
      var placeLoc = self.frontLoc() || s.locations[0];
      if (placeLoc) props['Logo placement'] = self.locFullName(placeLoc);

      /* Every view the customer actually decorated contributes coordinates.
         This used to read v0 and v1 only, so a side or back placement never
         reached the floor — they got numbers for a location nobody decorated
         and none for the one that was. */
      /* One line per LOCATION, named by where it goes on the garment (Kelly,
         2026-08-22). It used to be one per camera VIEW, which stops making
         sense the moment two locations share a photo — "FRONT" would appear
         twice with no way to tell which logo was which. The location name is
         also what the person sewing it actually needs.

         Deliberately NOT one per view: the 3/4 hero mirrors the front, so a
         view loop listed the same imprint twice, and under location labels
         both copies would read identically. */
      var coords = [];
      var strongest = 0;
      var vlist = self.viewsForColor();
      s.locations.forEach(function (l) {
        var meta = self.locMeta(l.loc);
        if (!meta) return;
        var v = null;
        for (var vi = 0; vi < vlist.length; vi++) {
          if (String(vlist[vi].id).toUpperCase() === String(meta.view).toUpperCase()) {
            v = vlist[vi];
            break;
          }
        }
        if (!v || !v.logo) return;

        /* Read the OBJECTS, never a reconstructed key. A location can now
           carry several images, each keyed by its own file id — building a
           key by hand here would miss every one of them and silently report
           the default position instead of where the customer put it. */
        var objs = self.objectsForView(v).filter(function (o) { return o.loc === l; });
        objs.forEach(function (o, oi) {
          var pv = self.placeFor(o.key);
          var rv = Math.round(pv.r);
          if (Math.abs(rv) > Math.abs(strongest)) strongest = rv;
          // Only numbered when there is more than one thing here, so the
          // common single-imprint case reads exactly as Kelly approved it.
          var label = self.locFullName(l) + (objs.length > 1 ? ' #' + (oi + 1) : '');
          if (o.file && objs.length > 1) label += ' (' + o.file.name + ')';
          coords.push(label + ': X ' + Math.round(pv.x) + '% / Y ' + Math.round(pv.y) +
            '% / ' + Math.round(pv.w) + '% wide / ' + rv + ' deg');
        });
      });
      if (coords.length) props['_logo_placement_coords'] = coords.join(' | ');

      // A heavily rotated imprint is deliberate but easy to read as a mistake
      // on the floor, so it gets its own customer-visible line rather than
      // living only in the hidden coordinate string.
      if (Math.abs(strongest) >= 90) {
        props['Orientation'] = Math.abs(strongest) === 180
          ? 'Upside down (180°)'
          : 'Rotated ' + strongest + '°';
      }
    }

    // The step is hidden without a decoration, so anything typed before the
    // last location was removed must not ride along invisibly on the order.
    if (s.locations.length > 0) {
      if (s.notes) props['Special instructions'] = s.notes;
      if (s.refMode === 'order' && s.refOrder) props['Previous order #'] = s.refOrder;
      if (s.refMode === 'mock' && s.refMock) props['Mockup #'] = s.refMock;
    }

    // Underscore-prefixed properties are hidden from the customer in cart/emails.
    props['_quoted_list_per_cap'] = this.listText(p);
    props['_quoted_tier'] = p.tier.min + (p.tier.max ? '-' + p.tier.max : '+') +
      ' · ' + p.pct + '% · ' + (s.locations.length ? 'decorated' : 'blank');
    props['_quoted_discount'] = cents(p.discountTotal);
    props['_quoted_per_cap'] = this.perCapText(p);
    props['_quoted_total'] = cents(p.total);
    props['_config'] = JSON.stringify({
      v: 1,
      /* A colourway the customer is buying, not the one they happened to be
         looking at when they pressed the button — the preview can now sit on
         something that is not on the order at all. */
      color: this.orderColor().name,
      variantId: this.orderColor().variantId,
      qty: p.qty,
      place: s.place,
      refMode: s.refMode,
      locations: s.locations.map(function (l) {
        return {
          loc: l.loc, panel: l.panel, deco: l.deco, subtype: l.subtype,
          variantId: self.resolve(l).variantId, puff: !!l.puff, tab: l.tab,
          // Replaces the old global `knockout`, which meant "the customer
          // asked" and could not tell a real cutout from the multiply fake.
          // This is per location and only true when a matted file exists.
          bgRemoved: !!(self.fileForArt(l) || {}).cut,
          text: l.text, font: l.font, thread: l.thread, curve: l.curve || 0,
          files: (l.files || []).map(function (f) { return f.name; })
        };
      })
    });

    return props;
  };

  P.attachedFiles = function () {
    var out = [];
    var self = this;
    this.state.locations.forEach(function (l, i) {
      (l.files || []).forEach(function (f, n) {
        if (f.file) {
          out.push({
            key: 'Artwork ' + (i + 1) + ' — ' + self.locFullName(l) + (n ? ' (' + (n + 1) + ')' : ''),
            file: f.file
          });
        }
      });
    });
    return out;
  };

  /* ---------- add to cart ------------------------------------------------- */

  // Decoration upcharges and setup fees ride along as their own line items,
  // because a variant's price cannot be changed from the storefront.
  P.addonItems = function (buildId) {
    var self = this;
    var c = this.cfg;
    var p = this.pricing();
    var items = [];
    var map = c.addonVariants || {};

    this.state.locations.forEach(function (l) {
      var r = self.resolve(l);
      if (r.variantId) {
        items.push({
          id: Number(r.variantId),
          quantity: p.qty,
          properties: {
            '_parent': 'cap-config', '_build': buildId || '',
            'For': self.locFullName(l)
          }
        });
      }
      if (self.puffAdd(l) && c.puffVariantId) {
        items.push({
          id: Number(c.puffVariantId),
          quantity: p.qty,
          properties: { '_parent': 'cap-config', '_build': buildId || '', 'For': self.locFullName(l), 'Option': '3D Puff' }
        });
      }

      /* Each selected add-on is its own real variant line at the cap quantity,
         the same shape 3D puff uses — so it prices correctly in the cart and
         shows up in product reporting rather than hiding inside a note. */
      self.activeAddons(l).forEach(function (a) {
        if (!a.variantId) return;
        items.push({
          id: Number(a.variantId),
          quantity: p.qty,
          properties: { '_parent': 'cap-config', '_build': buildId || '', 'For': self.locFullName(l), 'Option': a.label }
        });
      });
    });

    /* The flat first-location Setup Fee line is GONE with the $30 it billed
       (Kelly, 2026-08-18). Only the additional-location fee is still a real
       variant. One-time die charges have no variant to add — they live on a
       decoration's metafield — so the cart cannot carry them and a configured
       cap with a die under-charges here. That is another reason configured
       caps belong on the quote path, where the server bills the real amount.

       THIS FEE WAS MISSING THE `setupOnce` GUARD PRICING() ALREADY USES
       (Kelly, 2026-09-07). pricing() only adds `addlLocationSetup` to the
       QUOTE when `!self.resolve(locs[0] || l).setupOnce` -- reading
       `custom.setup_once` off the PRIMARY location's resolved variant, the
       same "DTF is one transfer sheet, set up once no matter how many
       places it lands" rule documented above. This cart-line version had
       no equivalent guard at all, so a 2-location DTF order (front chest +
       full back, no embroidery anywhere, setup_once true on both) was
       billed a real "$10 additional EMBROIDERY location" variant that the
       quote never included -- a quote/cart mismatch, not just a wrong
       price. Fixed by reading the exact same flag off the exact same
       location (index 0), not a second, different guess (a `deco_id ===
       'print'` check would happen to agree here but is a different rule
       reading a different signal, and the two silently drifting apart is
       exactly the class of bug the one_time_charge/oneTimeCents history
       above is full of). */
    var oneSetup = this.state.locations.length
      ? this.resolve(this.state.locations[0]).setupOnce
      : false;
    var extraLocationCount = oneSetup ? 0 : Math.max(0, this.state.locations.length - 1);
    if (extraLocationCount > 0 && map.addlSetup) {
      items.push({
        id: Number(map.addlSetup),
        quantity: extraLocationCount,
        /* _setup marks a one-time charge. It is EXCLUDED from the merge —
           a merge cannot hold lines of mixed quantity, and this is qty
           n-1 against caps at 25 — so it stays its own deletable line and
           the validation function is what stops checkout without it. */
        properties: { '_parent': 'cap-config', '_build': buildId || '', '_setup': '1' }
      });
    }

    /* Setup charges as real lines, one per charge, quantity 1 — they are per
       ORDER, not per cap. Before this the cart billed no setup at all once the
       flat fee was retired, so a PV+ cap went through $200 light. */
    this.setupCharges().forEach(function (c) {
      if (!c.variantId) return; // guarded by unmappedSetup(); never silently skipped
      items.push({
        id: Number(c.variantId),
        quantity: 1,
        // Setup is charged after the discount and never reduced. It is not
        // merged at all, so telling it apart is what keeps it OUT of the
        // merged line's discounted base.
        properties: { '_parent': 'cap-config', '_build': buildId || '', '_setup': '1' }
      });
    });

    /* Blank cap shipping surcharge — real cart line, same shape a decoration
       line uses (quantity = p.qty, no `_setup` marker), added ONLY when the
       order has no locations at all. Mirrors pricing()'s blankShippingTotal
       gate exactly (state.locations.length === 0) so quote and cart cannot
       disagree the way setup once did. Guarded on the variant existing, same
       pattern as addlSetup above: until it's mapped, this is quoted but not
       charged, never silently charged at $0. */
    if (!this.state.locations.length && p.blankShippingTotal > 0 && map.blankShipping) {
      items.push({
        id: Number(map.blankShipping),
        quantity: p.qty,
        properties: { '_parent': 'cap-config', '_build': buildId || '' }
      });
    }

    return items;
  };

  /* ---------- cart drawer --------------------------------------------------
     Dawn-family themes expose a <cart-drawer> custom element whose
     renderContents(state) swaps in freshly rendered sections and opens itself.
     Everything below degrades: drawer → open() → toast, never a navigation
     unless the merchant asked for one.
  -------------------------------------------------------------------------- */

  P.drawerSections = function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      } catch (e) { /* fall through */ }
    }
    return 'cart-drawer,cart-icon-bubble';
  };

  P.openCart = function (state) {
    var mode = this.cfg.afterAdd || 'drawer';
    if (mode === 'cart') { window.location.href = this.cfg.cartUrl || '/cart'; return; }

    if (mode === 'drawer') {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        try {
          if (state && state.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(state);
            return this.toast(null);
          }
          if (typeof drawer.open === 'function') { drawer.open(); return this.toast(null); }
        } catch (e) { /* fall through to toast */ }
      }
      // Themes that use a notification popover rather than a drawer.
      var note = document.querySelector('cart-notification');
      if (note && typeof note.renderContents === 'function' && state && state.sections) {
        try { note.renderContents(state); return this.toast(null); } catch (e) { /* fall through */ }
      }
      // Last resort: let the theme know something changed.
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    this.toast(this.copy('toastAdded'));
  };

  P.toast = function (msg) {
    var el = this.el.toast;
    if (!el) return;
    if (!msg) { el.hidden = true; return; }
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(this._toastT);
    this._toastT = setTimeout(function () { el.hidden = true; }, 4000);
  };

  /* ---------- add to cart --------------------------------------------------
     All AJAX — the page never navigates. Artwork files ride along as multipart
     FormData, which /cart/add.js accepts, so no hidden form or DataTransfer
     shim is needed.
  -------------------------------------------------------------------------- */

  /* Why the order cannot be placed as it stands, or '' if it can.

     ONE function, because the cart and the quote have to agree. The quote used
     to check neither: a customer could save a quote for 24 caps carrying a
     woven patch that runs 50, and wce-oms would silently RAISE the quantity to
     50 and invoice it — more caps than were asked for, and (because the raised
     total no longer matches the per-colourway breakdown) all of them billed
     against one colourway. Kelly, 2026-08-22: the minimums are the product's
     rules, so nothing that breaks them should be orderable at all.

     The three checks, cheapest and most specific first. The per-cell rule is
     named BEFORE the order total, because fixing the cells usually fixes the
     total — "add 4 more" when the real fault is a size holding 2 sends the
     customer the wrong way.

     `effectiveMinQty()` already folds in each decoration's and add-on's own
     `custom.minimum_quantity`, which is the metafield wce-oms raises to. So
     enforcing it here is what stops the raise ever having anything to do. */
  P.quantityBlocker = function (p, lines) {
    if (!lines.length) return this.copy('errNoQuantity');

    var vShort = this.variantShortfalls();
    if (vShort.length) {
      var first = vShort[0];
      var where = first.color + (first.size ? ' ' + first.size : '');
      /* The tail is its own setting rather than a fragment spliced into the
         first one, so a merchant editing either sentence cannot leave the
         other reading half a sentence. */
      return this.copy('errVariantMin', {
        min: this.effectiveVariantMin(),
        where: where,
        qty: first.qty
      }) + (vShort.length > 1 ? ' ' + this.copy('errVariantMinMore', { count: vShort.length }) : '');
    }

    /* Never raised — there is no honest way to choose which colour or size
       absorbs a shortfall — so this refuses and says by how much. */
    var floorQ = this.effectiveMinQty();
    if (p.qty < floorQ) {
      return this.copy('errMinOrder', { min: floorQ, count: floorQ - p.qty });
    }

    return '';
  };

  P.addToCart = function () {
    var self = this;
    // The colourway being BOUGHT. Browsing one with no variant behind it must
    // not block a cart made of colourways that have one.
    var col = this.orderColor();
    if (!col.variantId) {
      this.set({ error: this.copy('errColorwayUnavailable') });
      return;
    }

    /* Some products are never sold blank — a polo is bought to be decorated,
       and an undecorated one priced off the decorated tier set would be sold
       at a discount it never earned. Blocked here rather than hidden, so the
       reason is visible. */
    if (this.cfg.requireDecoration && this.state.locations.length === 0) {
      this.set({ error: this.copy('errNoLocation') });
      return;
    }

    var p = this.pricing();

    /* The garment is ONE line outside size mode and N lines inside it — one
       per size ordered, every one carrying the same _build. The tier was
       already priced on their total in pricing(), so the discount does not
       care how the run is split. */
    /* One line per colourway-and-size with a quantity. Already a LIST before
       multi-colour existed — it was one entry per size — so spanning colours
       needed no change here beyond where the entries come from. */
    var baseLines = this.orderLines();

    var short = this.quantityBlocker(p, baseLines);
    if (short) {
      this.set({ error: short });
      return;
    }

    // One id for this add-to-cart, on every line it creates.
    var buildId = this.newBuildId();
    var props = this.buildProperties(buildId);
    var files = this.attachedFiles();
    var addons = this.addonItems(buildId);

    /* How many setup lines this build actually created, counted from the lines
       themselves rather than by re-deriving the rule. The validation function
       compares the setup lines still in the cart against this number, and a
       count computed in two places is a count that drifts.

       Setup rides OUTSIDE the merged line (Kelly, 2026-08-19 — a merge cannot
       hold lines of mixed quantity, and setup is qty 1 against caps at 25), so
       a shopper CAN delete it. This stamp is what lets checkout refuse until
       it is back. */
    var setupCount = addons.filter(function (i) {
      return i.properties && i.properties['_setup'];
    }).length;
    if (setupCount) props['_setupExpected'] = String(setupCount);
    var addUrl = this.cfg.cartAddUrl || '/cart/add.js';
    var sections = this.drawerSections();

    this.set({ adding: true, error: '' });

    var fail = function (msg) {
      self.set({ adding: false, error: msg || self.copy('errCartRetry') });
    };

    var done = function (state) {
      self.set({ adding: false, error: '' });
      self.openCart(state);
    };

    /* A rendered preview of the configured build rides into the order as a
       real uploaded file property -- the exact same rail real artwork
       already uses below (`postBaseWithFiles`'s `fd.append(key, file,
       file.name)`), not a separate side-channel. Shopify hosts the upload
       and turns the property's value into that hosted URL, which is all
       wce-oms's existing attachedFiles()/downloadAndStoreFiles() needs to
       pull a file into the work order -- it matches on any property VALUE
       shaped like a URL, never on the property's name, so this needs zero
       changes on the OMS side to land next to the customer's artwork.

       Best-effort and never blocking: a canvas that fails to export (a
       tainted source image, an unsupported browser) resolves to null and
       checkout proceeds with just the real artwork, exactly as it did
       before this existed -- the mockup is a nice-to-have record for the
       floor, never a requirement to check out. Skipped entirely on a blank
       order (no locations chosen) since there is nothing to preview. */
    var mockupPromise = this.state.locations.length
      ? this.exportProof()
          .then(function (dataUrl) {
            return dataUrl ? self.dataUrlToFile(dataUrl, 'mockup-preview.png') : null;
          })
          .catch(function () { return null; })
      : Promise.resolve(null);

    var postJSON = function (items, withSections) {
      var body = { items: items };
      if (withSections) { body.sections = sections; body.sections_url = window.location.pathname; }
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error((j && j.description) || self.copy('errCartAdd'));
          return j;
        });
      });
    };

    /* `extraItems` rides in the SAME multipart request as the file-carrying
       line, via indexed `items[N][...]` fields -- verified directly against
       this store's `/cart/add.js` (including a file under `items[0]`
       alongside a second plain item) before relying on it here, since
       Shopify's docs don't spell out multi-item multipart. This is what
       lets setup lines land atomically WITH the first garment line rather
       than trailing behind it -- see the ordering comment below. */
    var postBaseWithFiles = function (withSections, line, extraItems) {
      var fd = new FormData();
      fd.append('items[0][id]', line.variantId);
      fd.append('items[0][quantity]', line.qty);
      Object.keys(props).forEach(function (k) { fd.append('items[0][properties][' + k + ']', props[k]); });
      files.forEach(function (f) { fd.append('items[0][properties][' + f.key + ']', f.file, f.file.name); });
      (extraItems || []).forEach(function (item, idx) {
        var i = idx + 1;
        fd.append('items[' + i + '][id]', item.id);
        fd.append('items[' + i + '][quantity]', item.quantity);
        Object.keys(item.properties || {}).forEach(function (k) {
          fd.append('items[' + i + '][properties][' + k + ']', item.properties[k]);
        });
      });
      if (withSections) {
        fd.append('sections', sections);
        fd.append('sections_url', window.location.pathname);
      }
      return fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error((j && j.description) || self.copy('errCartArtwork'));
            return j;
          });
        });
    };

    /* Artwork is attached to the FIRST garment line only. Repeating the
       upload on every size would multiply the same file by the number of
       sizes in the run, and the properties are identical across them, so the
       one copy represents the whole build. */
    var jsonBase = baseLines.map(function (b) {
      return { id: Number(b.variantId), quantity: b.qty, properties: props };
    });

    /* Setup lines are stamped with `_setup`; everything else in `addons` is
       decoration/add-on pricing. Split so setup can travel WITH the first
       garment line -- see the ordering comment below. */
    var setupItems = addons.filter(function (i) { return i.properties && i.properties['_setup']; });
    var decorationItems = addons.filter(function (i) { return !(i.properties && i.properties['_setup']); });

    mockupPromise.then(function (mockupFile) {
      /* Joins whatever real artwork exists. Pushed here rather than earlier
         so a build with NO uploaded artwork (text-only decoration, or a
         patch chosen from a gallery) still takes the multipart path below
         instead of the plain-JSON one -- otherwise the mockup would have
         nowhere to ride. */
      if (mockupFile) files = files.concat([{ key: 'Mockup Preview', file: mockupFile }]);

      var chain;
      if (files.length) {
        /* Ordering fixed 2026-09-06 after it broke a cart/checkout validation
           in production (wce-cart-functions incident -- see
           wce-cart-functions/docs/decoration-cart-integrity-plan.md). Two
           requirements were in tension:

           1. The setup-fee validation reads `_setupExpected` (stamped on
              every garment line, in `props`) and compares it against how many
              setup lines actually exist. If a garment line lands BEFORE its
              setup line, that check sees an expectation with nothing behind
              it and rejects -- so setup must never trail the first garment
              line into a LATER request.
           2. Any validation guarding against orphaned customization charges
              needs decoration/setup to never exist with ZERO garment lines
              behind them -- so decoration/setup must never LEAD the first
              garment line into an EARLIER request.

           Both are satisfied by landing the first garment line and ALL setup
           lines in the SAME atomic multipart request, then any remaining
           colourway lines, then decoration lines last (their quantity is only
           final once every colourway line exists -- see the cart-transformer
           sum-vs-equality comment for why decoration is a total, not a
           per-line match). Whichever request is genuinely last still carries
           `sections: true`, same requirement as before this changed. */
        var rest = jsonBase.slice(1);
        var step1Last = !rest.length && !decorationItems.length;
        chain = postBaseWithFiles(step1Last, baseLines[0], setupItems)
          .then(function () {
            if (!rest.length) return null;
            return postJSON(rest, !decorationItems.length);
          })
          .then(function () {
            if (!decorationItems.length) return null;
            return postJSON(decorationItems, true);
          });
      } else {
        chain = postJSON(jsonBase.concat(addons), true);
      }

      return chain;
    }).then(done).catch(function (e) {
      fail(e && e.message ? e.message : self.copy('errCartNetwork'));
    });
  };

  /* ---------- mockup export ------------------------------------------------
     Composites the cap photo and the positioned artwork into a PNG, mirroring
     the on-screen stage geometry. Used by the proof email, and available to a
     backend that needs a cart image or a draft order.
  -------------------------------------------------------------------------- */

  P.loadImage = function (src) {
    return new Promise(function (resolve) {
      if (!src) return resolve(null);
      var img = new Image();
      // Shopify's CDN serves CORS headers; without this the canvas is tainted
      // and toDataURL throws. Blob URLs from local uploads are unaffected.
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
  };

  /* Export exactly the view on screen — no second-guessing.

     Two earlier versions tried to be clever: first by always preferring the 3/4
     shot whenever artwork existed, then by redirecting the side and back views
     to the front because they render a bare cap. Both meant someone pressed
     save on one image and got a different one back, which is the one thing a
     proof must never do. LEFT gives you LEFT.

     Note the side and back shots carry no placement preset, so they show the
     blank cap even when that location is decorated — the artwork preview only
     covers the front. That limitation belongs to the preview, not here. */
  P.mockupViewIndex = function () {
    var views = this.viewsForColor();
    return Math.min(this.state.view, Math.max(0, views.length - 1));
  };

  /* Draws one view of ONE COLOURWAY — cap plus its own decoration — onto a
     fresh canvas. Split out of exportMockup so a multi-location proof sheet can
     call it once per tile without a second copy of the drawing rules.

     The colourway is a parameter and the view arrives as a KEYWORD, because
     that is the only identity shared across colourways: a view OBJECT already
     carries one colour's `src`, so passing one would have smuggled the
     previewed colour into every tile. Locations name views by keyword for the
     same reason. */
  P.renderViewCanvas = function (col, viewId, W, H) {
    var self = this;
    var view = this.viewOnColor(col, viewId);
    if (!view || !view.src) return Promise.resolve(null);

    /* EVERY object on the view, in the same order the screen draws them. This
       used to read `locForView(view)` — the FIRST location naming the view —
       so a second logo reached the customer's preview and never reached the
       proof they approved. Preview and proof must agree; that is the whole
       job of this function. */
    var objs = this.objectsForView(view).filter(function (o) {
      return !self.state.hidden[o.key];
    });
    var srcs = objs.map(function (o) {
      if (o.kind !== 'art') return '';
      return o.file ? self.srcForFile(o.file) : self.artSrcFor(o.loc);
    });

    return Promise.all([this.loadImage(view.src)].concat(srcs.map(function (src) {
      return self.loadImage(src);
    })))
      .then(function (imgs) {
        var cap = imgs[0];
        if (!cap) return null;

        var c = document.createElement('canvas');
        c.width = W;
        c.height = H;
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, W, H);

        // object-fit: contain, same as the on-screen slide
        var sc = Math.min(W / cap.naturalWidth, H / cap.naturalHeight);
        var cw = cap.naturalWidth * sc, ch = cap.naturalHeight * sc;
        ctx.drawImage(cap, (W - cw) / 2, (H - ch) / 2, cw, ch);

        objs.forEach(function (o, oi) {
          var art = imgs[oi + 1];
          var owner = o.loc;
          var text = o.kind === 'text' ? (owner.text || '') : '';
          if (!art && !text) return;

          // ratio travels in the placement record, so the box here is the box
          // the customer positioned rather than a constant repeated per file.
          var p = self.placeFor(o.key);
          var boxW = W * p.w / 100;
          var boxH = H * (p.w * p.ratio) / 100;

          ctx.save();
          ctx.translate(W * p.x / 100, H * p.y / 100);
          ctx.rotate(p.r * Math.PI / 180);

          if (art) {
            var as = Math.min(boxW / art.naturalWidth, boxH / art.naturalHeight);
            var aw = art.naturalWidth * as, ah = art.naturalHeight * as;
            ctx.drawImage(art, -aw / 2, -ah / 2, aw, ah);
          } else {
            // Same glyph positions the proof draws, shrunk to fit the box. A
            // curved run is taller and narrower, so both axes are checked.
            var size = boxH * 0.8;
            var face = self.faceFor(owner.font);
            var L = self.textLayout(text, size, owner.curve, face);
            var guard = 0;
            while (guard++ < 200 && size > 4) {
              var lw = L.maxX - L.minX, lh = L.maxY - L.minY;
              if (lw <= boxW && lh <= boxH) break;
              size *= 0.94;
              L = self.textLayout(text, size, owner.curve, face);
            }

            ctx.fillStyle = self.threadHex(owner.thread);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = IMPRINT_FONT(size, face.css, face.weight);
            L.glyphs.forEach(function (g) {
              ctx.save();
              ctx.translate(g.x, g.y);
              ctx.rotate(g.rot);
              ctx.fillText(g.ch, 0, 0);
              ctx.restore();
            });
          }
          ctx.restore();
        });
        return c;
      })
      .catch(function () { return null; });
  };

  /* Every decorated location, one view each — because a three-location order
     proofed as a single view is a proof of one third of the job.

     One entry per LOCATION rather than per view: the 3/4 hero and the straight
     front both belong to the front location, so tiling by view would show the
     front twice and call it two locations.

     KEYWORDS, not view objects, and deduped as strings. The old version deduped
     by object identity inside one colourway's list; across colourways every
     view object is distinct, so identity would have stopped deduping silently
     and the front would have come back twice per colour. */
  P.proofViewIds = function () {
    var self = this;
    var out = [];
    this.state.locations.forEach(function (l) {
      var meta = self.locMeta(l.loc);
      if (!meta) return;
      var id = String(meta.view).toUpperCase();
      if (out.indexOf(id) === -1) out.push(id);
    });
    return out;
  };

  /* The sheet, as a flat list of tiles: colourways x views.

     Colourways come from pickedColors() — what is ON THE ORDER — in the order
     the quantity rows show them, so the customer can read the sheet against
     what they typed. A colourway missing a photo for one of the views simply
     contributes no tile for it, rather than a tile wearing another colour's
     cap.

     A colourway with no decorated view at all still gets one tile: the view
     currently on screen. That is what keeps a BLANK order — no locations, so
     no view keywords — proofing as caps rather than as nothing. */
  /* What the band over one colourway's tiles says.

     Title is the colourway and its SKU. Detail is the run — the sizes and how
     many of each, or a single count on a one-size product — so the floor pulls
     stock against the proof the customer approved rather than a separate
     sheet, and so a customer checking the proof can see the numbers they
     typed. On a sized product each size has its OWN sku, so the title carries
     the colourway's and each size names itself in the detail.

     No detail line when nothing has been typed: SAVE MOCKUP is reachable
     before anything is on the order, and "SMALL 0 · MD-LG 0" describes an
     order nobody placed. */
  P.proofHeading = function (col) {
    var self = this;
    var name = String((col && col.name) || '').toUpperCase();
    var sku = (col && col.sku) || '';
    var title = sku ? name + '  ·  SKU ' + sku : name;

    var rows = this.sizeRowsFor(col);
    var parts = [];
    if (rows.length) {
      rows.forEach(function (r) {
        var n = self.qtyOf(col.name, r.name);
        if (n > 0) parts.push(String(r.name).toUpperCase() + ' ' + n);
      });
    } else {
      var one = this.qtyOf(col.name, '');
      if (one > 0) parts.push(this.units() + ' ' + one);
    }

    return { title: title, detail: parts.join('  ·  ') };
  };

  P.proofTiles = function () {
    var self = this;
    var ids = this.proofViewIds();
    var out = [];

    /* The sheet is one proof per colourway ON THE ORDER — but the order now
       starts EMPTY, and SAVE MOCKUP is deliberately reachable before anything
       is added. With nothing picked there is still exactly one cap the
       customer is looking at, and that is the one they are asking for a
       mockup of, so the preview stands in.

       This is the only place the previewed colourway is allowed back into the
       proof. Everything else here is driven by what is being bought. */
    var colors = this.pickedColors();
    if (!colors.length) colors = [this.currentColor()];

    colors.forEach(function (col) {
      var mine = [];
      ids.forEach(function (id) {
        if (self.viewOnColor(col, id)) mine.push(id);
      });
      if (!mine.length) {
        // This colourway's OWN list, not the previewed colour's — the whole
        // point is that the tile shows this cap.
        var views = self.viewsForColor(col);
        var v = views[Math.min(self.state.view, Math.max(0, views.length - 1))];
        if (v) mine.push(String(v.id).toUpperCase());
      }
      mine.forEach(function (id) { out.push({ color: col, viewId: id }); });
    });
    return out;
  };

  /* Force every imprint face to load, then resolve. document.fonts.ready alone
     is not enough: a face nobody has rendered yet is not "pending", so ready
     resolves immediately and the canvas silently falls back to the default
     face — the one place a wrong font is invisible until the customer opens
     the PNG. Never rejects; a font that will not load must not cost someone
     their proof. */
  P.ensureFaces = function () {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var list = (this.cfg.fonts || []).filter(function (f) { return f && f.css; });
    if (!list.length) return Promise.resolve();
    return Promise.all(
      list.map(function (f) {
        try {
          return document.fonts.load((f.weight || '800') + ' 100px ' + f.css);
        } catch (e) {
          return Promise.resolve();
        }
      })
    ).catch(function () {});
  };

  P.exportMockup = function () {
    var self = this;
    var col = this.currentColor();
    var views = this.viewsForColor();
    var view = views[this.mockupViewIndex()];
    var W = this.cfg.mockupWidth || 1600;
    var H = Math.round(W * 929 / 1600);
    // Faces first — a canvas drawn before the font loads falls back silently,
    // and nobody sees it until the customer opens the PNG.
    return this.ensureFaces().then(function () {
      return view ? self.renderViewCanvas(col, view.id, W, H) : null;
    }).then(function (c) {
      if (!c) return null;
      // Throws if any source image tainted the canvas — a missing proof image
      // must not break the quote.
      try { return c.toDataURL('image/png'); } catch (e) { return null; }
    });
  };

  /* The customer-facing proof. One tile exports that view alone, exactly as
     before; several tile into a labelled sheet — colourways down, views across
     — so the download shows the whole job rather than whichever colour and view
     happened to be on screen when they pressed save.

     Kelly chose one proof per SELECTED colourway, so the outer loop is
     pickedColors(): what is on the order, not what is being previewed. */
  P.exportProof = function () {
    var self = this;
    var tiles = this.proofTiles();
    if (tiles.length < 2) return this.exportMockup();

    /* Grouped in tile order, which is pickedColors() order, which is the order
       the quantity rows show — so the customer can read the sheet straight down
       against what they typed. */
    var groups = [];
    tiles.forEach(function (t) {
      var g = groups[groups.length - 1];
      if (!g || g.color !== t.color) { g = { color: t.color, tiles: [] }; groups.push(g); }
      g.tiles.push(t);
    });

    var widest = 1;
    groups.forEach(function (g) { widest = Math.max(widest, g.tiles.length); });
    var cols = Math.min(2, widest);

    /* Full size, before the budget below decides whether it fits. A colourway
       band only exists on a multi-colour sheet: a heading naming the only
       colour on the order is noise, and leaving it off is what makes the
       one-colourway proof pixel-for-pixel what it was before this existed. */
    var TW = 1200, TH = Math.round(TW * 929 / 1600), LABEL = 54, PAD = 24, FS = 28;
    /* ALWAYS drawn now, on one colourway as well as several (Kelly,
       2026-08-22): the band carries the SKU and the size breakdown, which the
       floor needs whether or not there is a second colour to tell it from.
       That gives up the old property that a single-colourway sheet was
       pixel-for-pixel what it was before the sheet existed. */
    var HEAD = 104;
    var HFS = 34, HSFS = 24;

    var sheetH = function (counts) {
      var h = PAD;
      counts.forEach(function (n) { h += HEAD + Math.ceil(n / cols) * (TH + LABEL + PAD); });
      return h;
    };
    var counts = groups.map(function (g) { return g.tiles.length; });
    var W = cols * TW + PAD * (cols + 1);
    var H = sheetH(counts);

    /* Tile size is a budget, not a constant. Colourways x views reaches two
       dozen tiles on a real order, and a canvas past roughly 16.7M pixels comes
       back BLANK on iOS Safari — toDataURL then hands over nothing and the
       customer is told the proof failed with no reason given. The same shrink
       keeps the base64 PNG that rides inside the quote POST down to a body the
       proxy will accept.

       Every dimension scales by the same factor, type included, so a shrunk
       sheet is the same sheet photographed smaller rather than one with giant
       labels. k is 1 whenever the sheet already fits, which is every order that
       fitted before. */
    if (W * H > 16000000) {
      var k = Math.sqrt(16000000 / (W * H));
      TW = Math.max(360, Math.round(TW * k));
      k = TW / 1200;
      TH = Math.round(929 / 1600 * TW);
      LABEL = Math.round(54 * k);
      PAD = Math.max(4, Math.round(24 * k));
      FS = Math.max(9, Math.round(28 * k));
      HFS = Math.max(11, Math.round(34 * k));
      HEAD = Math.round(104 * k);
      HSFS = Math.max(9, Math.round(24 * k));
      W = cols * TW + PAD * (cols + 1);
      H = sheetH(counts);
    }

    return this.ensureFaces()
      .then(function () {
        return Promise.all(tiles.map(function (t) {
          return self.renderViewCanvas(t.color, t.viewId, TW, TH);
        }));
      })
      .then(function (canvases) {
        /* A tile whose cap photo would not load drops out rather than leaving a
           white hole. Grouping is redone from what actually rendered, so a
           colourway that lost every tile takes its heading with it. */
        var live = [];
        canvases.forEach(function (c, i) { if (c) live.push({ c: c, tile: tiles[i] }); });
        if (!live.length) return null;

        var shown = [];
        live.forEach(function (item) {
          var g = shown[shown.length - 1];
          if (!g || g.color !== item.tile.color) { g = { color: item.tile.color, items: [] }; shown.push(g); }
          g.items.push(item);
        });

        // Re-measured off what survived, so dropped tiles do not leave the
        // sheet trailing empty rows.
        H = sheetH(shown.map(function (g) { return g.items.length; }));

        var sheet = document.createElement('canvas');
        sheet.width = W;
        sheet.height = H;
        var ctx = sheet.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, W, H);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        var y = PAD;
        shown.forEach(function (g) {
          if (HEAD) {
            /* The colourway's name and SKU, because a sheet of unlabelled caps
               is useless on the floor — and on a shared-gallery product the
               label is the ONLY thing telling two identical tiles apart. */
            var head = self.proofHeading(g.color);
            ctx.fillStyle = '#000000';
            ctx.font = '700 ' + HFS + 'px Archivo, Helvetica, Arial, sans-serif';
            ctx.fillText(head.title, W / 2, y + HEAD * 0.34);
            if (head.detail) {
              // The run, so whoever pulls stock is reading it off the proof
              // the customer approved rather than a separate sheet.
              ctx.fillStyle = '#444444';
              ctx.font = '400 ' + HSFS + 'px Archivo, Helvetica, Arial, sans-serif';
              ctx.fillText(head.detail, W / 2, y + HEAD * 0.72);
            }
            y += HEAD;
          }

          g.items.forEach(function (item, i) {
            var cx = PAD + (i % cols) * (TW + PAD);
            var cy = y + Math.floor(i / cols) * (TH + LABEL + PAD);
            ctx.drawImage(item.c, cx, cy);

            ctx.strokeStyle = '#d9d9d9';
            ctx.lineWidth = 2;
            ctx.strokeRect(cx + 1, cy + 1, TW - 2, TH - 2);

            var view = self.viewOnColor(item.tile.color, item.tile.viewId);
            var loc = self.locForView(view);
            var label = loc ? self.locFullName(loc).toUpperCase()
              : String((view && (view.label || view.id)) || item.tile.viewId);
            ctx.fillStyle = '#000000';
            ctx.font = '600 ' + FS + 'px Archivo, Helvetica, Arial, sans-serif';
            ctx.fillText(label, cx + TW / 2, cy + TH + LABEL / 2);
          });

          y += Math.ceil(g.items.length / cols) * (TH + LABEL + PAD);
        });

        try { return sheet.toDataURL('image/png'); } catch (e) { return null; }
      })
      .catch(function () { return null; });
  };

  /* Same byte-conversion `downloadMockup` uses, minus the browser-download
     part -- a File is what /cart/add.js's multipart upload wants, and a
     File IS a Blob with a name, so this feeds straight into the same
     `fd.append(key, file, file.name)` call the real artwork already rides
     on in P.addToCart. */
  P.dataUrlToFile = function (dataUrl, filename) {
    var parts = dataUrl.split(',');
    var bin = atob(parts[1]);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new File([bytes], filename, { type: 'image/png' });
  };

  /* ---------- draft order --------------------------------------------------
     A storefront cannot create draft orders: that is Admin API only, and the
     credentials must never live in theme code. When an endpoint is configured
     (an app proxy in front of your own backend), the quote button posts the
     full configuration and computed totals there and the backend creates the
     draft order with the correct amounts.
  -------------------------------------------------------------------------- */

  P.draftOrderPayload = function () {
    var self = this;
    var p = this.pricing();
    var picked = this.pickedColors();
    /* The REPRESENTATIVE colourway — it prices the order and is the variant
       the draft order falls back to if the breakdown cannot be split safely.
       Taken from what is ON the order, never from what is being previewed:
       `currentColor()` is whichever swatch was clicked last, and now that
       browsing does not add, it may not be on the order at all.

       `orderColor()` is the same one `listPerCap()` prices from, which is what
       makes wce-oms's "every cap line costs what the representative costs"
       check compare like with like. */
    var col = this.orderColor();
    return {
      product: { title: this.cfg.productTitle, url: window.location.href },
      productId: this.cfg.productId || null,
      /* What one piece is called, so the quote does not call a polo a cap.
         The storefront has said EACH / PIECES since the polo template existed;
         wce-oms hardcoded "cap" in three places and had no way to know. */
      unitNoun: this.unit(),
      unitPlural: this.units(),
      // EVERY colourway, matching the cart line's `Colorway` property. It used
      // to be one name, so a three-colour quote told the floor one colour.
      colorway: picked.map(function (c) { return c.name; }).join(', '),
      variantId: col.variantId,
      quantity: p.qty,
      /* The caps as ordered. Without this the quote invoices the TOTAL
         quantity against the single `variantId` above — 24 of one colour for a
         12 + 12 order. The cart path has always sent per-colourway lines; this
         is the same list, from the same place. */
      capLines: this.orderLines().map(function (l) {
        return { variantId: l.variantId, color: l.color, size: l.name, qty: l.qty };
      }),
      email: this.state.email || null,
      notes: this.state.notes || null,
      reference: this.state.refMode === 'order' ? this.state.refOrder
        : (this.state.refMode === 'mock' ? this.state.refMock : null),
      /* Which KIND of reference this is. A reorder number and a mockup number
         both land in `reference`, so the kind travels separately. It no longer
         changes the price on either side — it marks the order as a claimed
         repeat so setup can be refunded after review. */
      referenceType: this.state.refMode === 'order' ? 'order'
        : (this.state.refMode === 'mock' ? 'mock' : null),
      pricing: {
        listPerCap: p.list,
        tier: { min: p.tier.min, max: p.tier.max, pct: p.pct },
        discountTotal: p.discountTotal,
        perCap: p.perCap,
        capsSubtotal: p.capsSub,
        setupTotal: p.setupTotal,
        total: p.total
      },
      lines: this.state.locations.map(function (l) {
        var r = self.resolve(l);
        return {
          location: self.locFullName(l),
          decoration: self.decoLabel(l),
          /* The METHOD id, so the server can charge one setup per method. Used
             for GROUPING only — every amount is still read from Shopify — so
             the worst a forged value can do is collapse the lines into one
             method and pay ONE setup, which is what the old rule charged
             anyway. It can never bill less than that. */
          method: l.deco,
          // Same price for every colour, so this is descriptive only and never
          // affects the reprice — but it has to reach the work order.
          patchColor: l.patchColor || null,
          /* 3D puff rides in the addons array even though it is NOT one
             internally — it still runs on its own legacy settings. Leaving it
             out is what made the server undercharge: the storefront added
             $3/cap, the payload never mentioned it, and a 12-cap quote
             invoiced $36 less than the screen promised.

             It is posted rather than converted to a real add-on because the
             add-on mechanism attaches by DECORATION, not by location, and
             puff is front-embroidery-only. Converting it today would offer
             puff on the back and the side. Retiring the legacy path (see
             HANDOFF) needs per-location add-on rules first. */
          addons: self.activeAddons(l).map(function (a) {
            return { label: a.label, value: a.value, variantId: a.variantId, price: a.price };
          }).concat(self.puffAdd(l) && self.cfg.puffVariantId
            ? [{
                label: '3D Puff',
                value: self.cfg.puffOptionValue || '3D Puff',
                variantId: self.cfg.puffVariantId,
                price: self.puffAdd(l)
              }]
            : []),
          variantId: r.variantId,
          price: r.price,
          quantity: p.qty,
          artwork: (l.files || []).map(function (f) { return f.name; }),
          // Gated on the text being ON the product, not on which editor tab
          // happens to be open — a location can now carry artwork AND text,
          // and the quote has to price and describe what was approved.
          text: (l.textOn && l.text)
            ? { text: l.text, font: l.font, thread: l.thread,
                threadLabel: self.threadLabel(l.thread), curve: l.curve || 0 }
            : null
        };
      })
    };
  };

  /* ---------- save mockup ------------------------------------------------- */

  /* Shopify's native /contact now rejects any POST that did not come
     through a real on-page <form> submit carrying its own CAPTCHA
     challenge script — fetch() included. That started ~2026-09-15 and
     silently killed every SAVE MOCKUP signup: the download never depended
     on this call, so the customer kept seeing success while no customer
     record was ever written (measured against production 2026-09-22).
     Routes through wce-oms instead, which tags/subscribes via the Shopify
     ADMIN API — a server-to-server write the storefront bot check never
     touches, the same path SAVE QUOTE and REQUEST A MOCKUP already use.

     ALSO carries the configuration and the downloaded PNG (2026-09-23), so
     the backend can log this as a lead in the same queue REQUEST A MOCKUP
     uses — tagged `download` there so staff can tell a browsing customer
     who grabbed a proof from one who asked staff to build something. Before
     this, a SAVE MOCKUP customer got tagged in Shopify but nobody on staff
     ever saw the lead or had anywhere to reply to them. */
  P.subscribeEmail = function (email, png) {
    var endpoint = this.cfg.mockupSignupEndpoint;
    if (!endpoint) return Promise.resolve();
    var notice = this.cfg.marketingNotice || '';
    var tags = (this.cfg.customerTags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var payload = Object.assign({ email: email, tags: tags, marketingOptIn: !!notice, marketingOptInText: notice }, this.mockupConfigPayload());
    if (png) payload.mockupPng = png;
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('subscribe failed ' + res.status);
      return res;
    });
  };

  // Hands the proof to the browser as a file. A blob rather than the raw data
  // URL: a 630KB data: URL in an href is workable but blobs are what browsers
  // are built to download.
  P.downloadMockup = function (dataUrl) {
    var parts = dataUrl.split(',');
    var bin = atob(parts[1]);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    var url = URL.createObjectURL(new Blob([bytes], { type: 'image/png' }));

    var slug = function (t) {
      return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
    };
    /* One colourway still names itself. Several must not: the file holds the
       whole order, and naming it after whichever swatch was previewed is how a
       four-colour proof ends up filed under one colour on the floor. */
    /* Same fallback proofTiles() uses, for the same reason: with nothing on
       the order the sheet is of the previewed cap, so the file is named after
       it rather than after nothing. */
    var picked = this.pickedColors();
    if (!picked.length) picked = [this.currentColor()];
    var which = picked.length > 1 ? picked.length + '-colorways' : slug((picked[0] || {}).name);
    var name = ['mockup', slug(this.cfg.productTitle), which]
      .filter(Boolean).join('-') + '.png';

    var a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
    return name;
  };

  /* Both buttons land here; `saveMode` decides what happens.

     MOCKUP downloads the proof in exchange for an email address — no backend
     involved. QUOTE needs a draft order, which only the Admin API can create,
     so it stays gated on a configured endpoint.

     There is deliberately no local fake-success path on the quote side.
     Telling a customer their quote is on its way when nothing was sent is
     worse than an error: they wait, nothing arrives, and nobody finds out. */
  /* What the customer is looking at, for a mockup REQUEST.

     Deliberately describes the CONFIGURATION rather than an order: there may
     be no quantity, no artwork and no intention to check out yet. The SKU is
     the representative colourway's, which is what the floor pulls against, and
     the placement is the same string the cart line carries so a request and an
     order read identically on the work order. */
  /* Shared by the REQUEST payload and the SAVE MOCKUP signup payload — both
     describe the CONFIGURATION rather than an order, for the same reason:
     there may be no quantity, no artwork and no intention to check out yet,
     and neither path carries placement coordinates (Kelly, 2026-08-23) —
     where the customer happened to drag a placeholder is not information,
     it is a number that looks like a specification and would be read as one
     on the floor. The quote and the cart still carry placement, because
     there the customer approved what they positioned. */
  P.mockupConfigPayload = function () {
    var self = this;
    var col = this.orderColor();
    var p = this.pricing();

    var decorations = this.state.locations.map(function (l) {
      return {
        location: self.locFullName(l),
        decoration: self.decoLabel(l),
        patchColor: l.patchColor || null
      };
    });

    return {
      product: {
        title: this.cfg.productTitle,
        url: window.location.href,
        sku: col.sku || ''
      },
      productId: this.cfg.productId || null,
      colorway: col.name || '',
      decorations: decorations,
      // Only when they have actually typed one — neither path is an order.
      quantity: p.qty > 0 ? p.qty : null,
      sourceUrl: window.location.href
    };
  };

  P.mockupRequestPayload = function () {
    return Object.assign({
      name: (this.state.reqName || '').trim(),
      email: (this.state.email || '').trim(),
      notes: (this.state.reqNotes || '').trim()
    }, this.mockupConfigPayload());
  };

  /* Reads the chosen files as data URLs. Resolves to whatever succeeded rather
     than rejecting: one unreadable file must not cost the customer the whole
     request, and the server skips anything it cannot decode anyway. */
  P.readRequestArtwork = function () {
    var input = this.el.reqArtValue;
    var files = (input && input.files) || [];
    if (!files.length) return Promise.resolve([]);
    var list = [];
    for (var i = 0; i < files.length && i < 6; i++) list.push(files[i]);

    return Promise.all(list.map(function (f) {
      return new Promise(function (resolve) {
        var fr = new FileReader();
        fr.onload = function () { resolve({ name: f.name, data: String(fr.result || '') }); };
        fr.onerror = function () { resolve(null); };
        try { fr.readAsDataURL(f); } catch (e) { resolve(null); }
      });
    })).then(function (out) { return out.filter(Boolean); });
  };

  P.sendMockup = function () {
    var self = this;
    var quote = this.state.saveMode === 'quote';
    var request = this.state.saveMode === 'request';
    var email = (this.state.email || '').trim();

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      this.set({ error: this.copy('errEmailInvalid') });
      return;
    }

    /* A mockup REQUEST: no minimums, no quantity, no pricing. The customer is
       asking us to build something, which is the one path that has to work
       before they have decided anything. Artwork is optional; the configured
       preview goes either way, because it is what they were looking at. */
    if (request) {
      if (!(this.state.reqName || '').trim()) {
        this.set({ error: this.copy('errNameRequired') });
        return;
      }
      var endpoint = this.cfg.mockupRequestEndpoint;
      if (!endpoint) {
        this.set({ error: this.copy('errQuoteUnavailable', { email: this.cfg.proofEmail || 'us' }) });
        return;
      }

      this.set({ saving: true, error: '' });

      var payload = this.mockupRequestPayload();
      var notice = this.cfg.marketingNotice || '';
      payload.marketingOptIn = !!notice;
      payload.marketingOptInText = notice;

      Promise.all([this.readRequestArtwork(), this.exportProof().catch(function () { return null; })])
        .then(function (both) {
          payload.artwork = both[0];
          // Never fatal. exportProof legitimately returns null on a tainted
          // canvas, and a request with no picture still beats no request.
          payload.mockupPng = both[1] || null;
          return fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('request failed ' + res.status);
          return res.json();
        })
        .then(function () { self.set({ saving: false, saveSent: true }); })
        .catch(function (err) {
          console.error('[cap-customizer] mockup request failed', err);
          self.set({
            saving: false,
            error: self.copy('errQuoteSend', { email: self.cfg.proofEmail || 'us' })
          });
        });
      return;
    }

    if (!quote) {
      this.set({ saving: true, error: '' });
      this.exportProof()
        .then(function (png) {
          if (!png) throw new Error('export failed');
          self.downloadMockup(png);
          // The download is the thing the customer asked for, so it happens
          // first and a failed signup never costs them the file.
          return self.subscribeEmail(email, png).catch(function (err) {
            console.error('[cap-customizer] mockup signup failed', err);
          });
        })
        .then(function () { self.set({ saving: false, saveSent: true }); })
        .catch(function () {
          self.set({
            saving: false,
            error: self.copy('errProofFailed', { email: self.cfg.proofEmail || 'us' })
          });
        });
      return;
    }

    /* The backstop. The button checks too, but the modal can be open from
       before a quantity was cleared, and this is the last point before a
       payload that becomes a charge leaves the browser. */
    var short = this.quantityBlocker(this.pricing(), this.orderLines());
    if (short) {
      this.set({ error: short });
      return;
    }

    var endpoint = this.cfg.draftOrderEndpoint;
    if (!endpoint) {
      this.set({ error: this.copy('errQuoteUnavailable', { email: this.cfg.proofEmail || 'us' }) });
      return;
    }

    this.set({ saving: true, error: '' });
    var payload = this.draftOrderPayload();
    payload.intent = 'quote';
    payload.email = email;

    /* Consent is implied by submitting under a visible notice, so it is only
       claimed when that notice actually rendered — clearing the setting stops
       the subscription too, rather than subscribing people silently. The exact
       wording travels with the submission so there is a record of what was
       agreed to, which is the part that makes implied consent defensible. */
    var notice = this.cfg.marketingNotice || '';
    payload.marketingOptIn = !!notice;
    payload.marketingOptInText = notice;
    payload.marketingConsentMethod = notice ? 'implied_on_submit' : 'none';
    payload.customerTags = this.cfg.customerTags || '';
    payload.sourceUrl = window.location.href;

    /* The proof sheet, not the single view. The backend attaches this PNG to
       the customer's quote email, so it has to show the whole job — a two-
       location order whose proof only pictured the front would have the
       customer approving something they were never shown. */
    this.exportProof()
      .then(function (png) {
        payload.mockupPng = png;
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('bad status');
        /* No subscribeEmail() here, deliberately. The backend owns tagging and
           consent for quotes, because it is the only side that can check the
           customer's current state first — posting to /contact would re-
           subscribe someone who had previously opted out. The mockup branch
           above has no backend and so still uses the form. */
      })
      .then(function () { self.set({ saving: false, saveSent: true }); })
      .catch(function () {
        self.set({
          saving: false,
          error: self.copy('errQuoteSend', { email: self.cfg.proofEmail || 'us' })
        });
      });
  };

  /* ---------- boot -------------------------------------------------------- */

  function boot() {
    document.querySelectorAll('[data-cap-customizer]').forEach(function (n) {
      if (!n.dataset.ccBooted) {
        n.dataset.ccBooted = '1';
        new CapCustomizer(n);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', boot);

  window.CapCustomizer = CapCustomizer;
})();
